import {
  apiGet,
  apiPost,
  getApiBaseUrl,
  request,
  requestFile,
  type ApiFile,
  type RequestAuthContext,
} from "./client";
import type {
  DashboardSummary,
  ReportSearchIndex,
  Account,
  AccountCategory,
  AccountCategoryList,
  AccountInput,
  AccountMovementsFilter,
  AccountMovementsResult,
  AccountTreeNode,
  AccountTypeList,
  AgingGroupedFilter,
  AgingGroupedResult,
  AssetCustodyList,
  AssetCustodyMovement,
  AssetDailyTransactionsInquiryFilter,
  AssetDailyTransactionsResult,
  AssetDepreciationRun,
  AssetDepreciationRunList,
  AnnualAssetDepreciationPreview,
  AnnualAssetDepreciationResult,
  AssetDisposalList,
  AssetDocumentKind,
  AssetExpenseList,
  AssetExpenseReturnList,
  AssetExpensesInquiryFilter,
  AssetExpensesInquiryResult,
  AssetFinancialMovementsFilter,
  AssetFinancialMovementsResult,
  AssetInsuranceList,
  AssetInventoryCount,
  AssetInventoryCountList,
  AssetInventoryWorksheet,
  AssetLifeCycleFilter,
  AssetLifeCycleResult,
  AssetLocationMovementList,
  AssetMaintenanceList,
  AssetMovementsInquiryFilter,
  AssetMovementsResult,
  AssetPurchaseInvoice,
  AssetPurchaseInvoiceList,
  AssetPurchaseOrderList,
  AssetPurchaseReturn,
  AssetPurchaseReturnList,
  AssetRecordsFilter,
  AssetRecordsResult,
  AssetRevaluationList,
  AssetRevenueList,
  AssetSaleList,
  AssetSplit,
  AssetSplitList,
  AssetTransfer,
  AssetTransferList,
  AssetTransferStatusInquiryFilter,
  AssetTransferStatusResult,
  AssetTreeInquiryFilter,
  AssetTreeResult,
  AssetValuationSnapshot,
  AssignablePartner,
  AuditTrailEntityOption,
  AuditTrailEntry,
  AuditTrailFilter,
  AuthResult,
  Bank,
  BankAccountCurrencyFilter,
  BankAccountCurrencyResult,
  BankFacility,
  BankFacilityList,
  BankList,
  BankLoan,
  BankLoanInquiryFilter,
  BankLoanInquiryResult,
  BankLoanList,
  BankReconciliation,
  BankReconciliationMatchSummary,
  BankStatementImport,
  StatementColumn,
  BankReconciliationList,
  BankReconciliationStatus,
  BankTransaction,
  BankTransactionKind,
  BankTransactionList,
  BankTransfer,
  BankTransferList,
  BusinessPartner,
  BusinessPartnerAuditEntry,
  BusinessPartnerList,
  CapitalInvoicesFilter, CapitalInvoicesResult,
  CashAndBanksSettings,
  CashBanksDocumentsFilter,
  CashBanksDocumentsResult,
  CashBanksReportFilter,
  CashBanksReportResult,
  Cashbox,
  CashboxCashFloatList,
  CashboxClosingFollowUpFilter,
  CashboxClosingFollowUpResult,
  CashboxGroupList,
  CashboxMovementsFilter,
  CashboxMovementsResult,
  CashboxTransaction,
  CashboxTransactionList,
  CashboxTreeNode,
  CashDeposit,
  CashDepositList,
  CashSubledgerFilter,
  CashSubledgerResult,
  CashWithdrawal,
  CashWithdrawalList,
  ChangeCustomerCreditLimitInput,
  ChangePasswordRequest,
  ChequeBook,
  ChequeBookLeafList,
  ChequeBookList,
  ChequeBatchDetail,
  ChequeBatchList,
  ChequeBatchRequest,
  ChequeBatchResult,
  ChequeDeskFilter,
  ChequeDeskList,
  InventoryBranchOption,
  ItemCardLookups,
  ItemPrice,
  ItemSupplierLink,
  PriceList,
  InventoryConfigurationStatus,
  InventoryItem,
  InventoryReason,
  InventoryReportFilter,
  InventoryReportResult,
  InventorySettings,
  InventoryWarehouse,
  ItemCategory,
  ItemGroup,
  StorageLocation,
  UnitOfMeasure,
  SaveInventorySettingsInput,
  ChequeDirection,
  ChequeFilter,
  ChequeInquiryFilter,
  ChequeInquiryResult,
  ChequeList,
  ChequeMovementInquiryFilter,
  ChequeMovementInquiryResult,
  ChequeMovementList,
  ChequeMovementType,
  ChequeReturnReasonList,
  ChequeSequenceGapsFilter,
  ChequeSequenceGapsResult,
  CombinedBooksFilter,
  CombinedBooksResult,
  CostCenter,
  CostCenterAccountFilter,
  CostCenterAccountResult,
  CostCenterGroup,
  CostCenterGroupList,
  CostCenterInput,
  CostCenterTreeNode,
  CountryRegion,
  CountryRegionAuditEntry,
  CountryRegionTree,
  CreateFinancialStatementInput,
  CreateReconciliationInput,
  CreateSystemUserInput,
  CreditNote,
  CreditNoteAttachment,
  CreditNoteFilter,
  CreditNoteList,
  Currency,
  CurrencyInput,
  CustodyCategory,
  CustodyCategoryAuditEntry,
  CustodyCategoryList,
  CustomerAccountCostCenterFilter,
  CustomerAccountCostCenterResult,
  CustomerAgingDetailRow,
  CustomerAgingFilter,
  CustomerAgingResult,
  CustomerCategoryList,
  CustomerCategoryOption,
  CustomerCostCenterFilter,
  CustomerCreditLimit,
  CustomerCreditLimitHistory,
  CustomerCurrencyStatement,
  CustomerCurrencyStatementFilter,
  CustomerItemTransactionsFilter,
  CustomerItemTransactionsResult,
  CustomerLedgerCurrencies,
  CustomerMasterFilter,
  CustomerMasterResult,
  CustomerOpeningBalanceSheet,
  CustomerOpeningBalanceType,
  CustomerReceivablesByCostCenter,
  CustomerReceivablesFilter,
  CustomerReceivablesSummary,
  CustomerStatement,
  CustomerStatementFilter,
  CustomerTransactionsFilter,
  CustomerTransactionsResult,
  CustomerTransactionTransfer,
  CustomerTransactionTransferList,
  DailyTransactionsFilter,
  DailyTransactionsResult,
  DebitNote,
  DebitNoteAttachment,
  DebitNoteFilter,
  DebitNoteList,
  DetailedAgingFilter,
  DetailedAgingResult,
  DetailedAgingSettlement,
  DiscountTypeAuditEntry,
  DiscountTypeList,
  Employee,
  EmployeeFormContext,
  EmployeeListItem,
  ExchangeRateInput,
  ExchangeRateResolution,
  ExchangeRateRow,
  ExpiringDocumentsFilter, ExpiringDocumentsResult,
  FinancialLinkAuditEntry,
  FinancialLinkLevel,
  FinancialLinkModule,
  FinancialLinkResult,
  FinancialPositionFilter,
  FinancialPositionResult,
  FinancialStatementDefinition,
  FinancialStatementLine,
  FinancialStatementList,
  FiscalPeriodResolution,
  FixedAssetAttachment,
  FixedAssetCard,
  FixedAssetGroup,
  FixedAssetList,
  FixedAssetLocation,
  FixedAssetLookupEntry,
  FixedAssetLookupOption,
  FixedAssetLookupType,
  FixedAssetsReportCoverage,
  FixedAssetsReportFilter,
  FixedAssetsReportResult,
  FixedAssetsSettings,
  FixedAssetTreeNode,
  FreezeMember,
  GeneralLedgerReportFilter,
  GeneralLedgerReportResult,
  GeneralLedgerSettings,
  GeneralLedgerSettingsAuditEntry,
  GuaranteesFilter, GuaranteesResult,
  InquirySupplierOption,
  InvoiceSettlement,
  IssueChequeInput,
  JournalAttachment,
  JournalAuditEntry,
  JournalEntryContext,
  JournalParticipants,
  JournalPostingEligibility,
  JournalStatus,
  JournalVoucher,
  JournalVoucherFilter,
  JournalVoucherInput,
  JournalVoucherPage,
  LedgerMovementsFilter,
  LedgerMovementsResult,
  LetterOfCredit,
  LetterOfCreditInquiryFilter,
  LetterOfCreditInquiryResult,
  LetterOfCreditList,
  LetterOfCreditStatus,
  LetterOfCreditTypeList,
  LinkLevelEntities,
  LoanStatus,
  LoginRequest,
  LogoutRequest,
  MissingBookSequencesFilter,
  MissingBookSequencesResult,
  MissingReceiptVoucherSequencesResult,
  MissingVoucherSequenceFilter,
  NonCompliantAccountsCount,
  OpeningBalanceFilter,
  OpeningBalanceFiscalYear,
  OpeningBalanceRowStatus,
  OpeningBalanceSheet,
  OutstandingInvoicesFilter,
  OutstandingInvoicesResult,
  OutstandingSupplierInvoicesFilter,
  OutstandingSupplierInvoicesResult,
  PaidUnpaidInvoicesFilter,
  PaidUnpaidInvoicesResult,
  PaidUnpaidSupplierInvoicesFilter,
  PaidUnpaidSupplierInvoicesResult,
  PartnerInfoChangesFilter, PartnerInfoChangesResult,
  PartnerLookupList,
  PartnerLookupType,
  PartnerStaff,
  PartyOpenItems,
  PayableOpenInvoices,
  PaymentBook,
  PaymentBookAction,
  PaymentBookList,
  PaymentBooksInquiryFilter,
  PaymentBooksInquiryResult,
  PaymentCardCommissionPolicyList,
  PaymentCardTypeList,
  PaymentMethodList,
  PaymentOrder,
  PaymentOrderList,
  PaymentsDailyTransactionsFilter,
  PaymentsDailyTransactionsResult,
  PaymentsInquiryFilter,
  PaymentVoucher,
  PaymentVoucherList,
  PaymentVoucherMovementsFilter,
  PaymentVoucherMovementsResult,
  PermissionCatalog,
  PersonnelOptions,
  PersonnelRole,
  PersonnelRoleAuditEntry,
  PersonnelRoleList,
  PersonnelRoleType,
  PostingAccount,
  PrepaidSchedule,
  PrepaidScheduleList,
  PurchaseInvoicesByTypeFilter, PurchaseInvoicesByTypeResult,
  PurchaseItemList,
  PurchaseItemType,
  PurchaseOrder,
  PurchaseOrderList,
  PurchaseOrdersAwaitingPaymentFilter,
  PurchaseOrdersAwaitingPaymentResult,
  PurchaseOrderStatus,
  QuotationComparison,
  QuotationRequest,
  QuotationRequestList,
  ReceiptAllocationDetailResult,
  ReceiptBook,
  ReceiptBookHolder,
  ReceiptBookList,
  ReceiptOrder,
  ReceiptOrderAttachment,
  ReceiptOrderFilter,
  ReceiptOrderList,
  ReceiptPaymentOrdersFilter, ReceiptPaymentOrdersResult,
  ReceiptsReportFilter,
  ReceiptsWithoutInvoicesFilter,
  ReceiptVoucher,
  ReceiptVoucherAttachment,
  ReceiptVoucherList,
  ReceiptVouchersWithoutInvoicesResult,
  ReceivablesAgingPeriod,
  ReceivablesAgingPeriodAuditEntry,
  ReceivablesAgingPeriodList,
  ReceivablesSettings,
  ReceivablesSettingsAuditEntry,
  RecognitionSchedule,
  RecognitionScheduleList,
  RecognizableInvoiceList,
  RecognizeDuePeriodsResult,
  RecognizeDueResult,
  ReconciliationHistory,
  RefreshRequest,
  RelatedPartyType,
  ReminderBatch,
  ReminderBatchList,
  ReminderCandidateExportFilter,
  ReminderCandidateFilter,
  ReminderCandidateList,
  ReminderPreview,
  ReminderTemplateInfo,
  ReportCategoryDetail,
  ReportsCenterResult,
  ReportSignatureList,
  ResetSystemUserPasswordInput,
  ResolvedTaxRate,
  ResponsibleEntity,
  ReturnableAssetInvoice,
  ReturnableExpense,
  ReturnableInvoiceList,
  ReturnedChequeAction,
  ReturnedOutgoingChequeAction,
  RevenueRecognitionList,
  SalesPurchaseTaxType,
  SalesPurchaseTaxTypeList,
  SaveAccountCategoryInput,
  SaveAccountTypeInput,
  SaveBankAccountInput,
  SaveBankBranchInput,
  SaveBankFacilityInput,
  SaveBankInput,
  SaveBankLoanInput,
  SaveBankReconciliationInput,
  SaveBankTransactionInput,
  SaveBankTransferInput,
  SaveBusinessPartnerInput,
  SaveCashAndBanksSettingsInput,
  SaveCashboxCashFloatInput,
  SaveCashboxGroupInput,
  SaveCashboxInput,
  SaveCashboxTransactionInput,
  SaveCashDepositInput,
  SaveCashWithdrawalInput,
  SaveChequeBookInput,
  SaveChequeReturnReasonInput,
  SaveCostCenterGroupInput,
  SaveCountryRegionInput,
  SaveCreditNoteInput,
  SaveCustodyCategoryInput,
  SaveCustomerOpeningBalancesInput,
  SaveCustomerOpeningBalancesResult,
  SaveCustomerTransactionTransferInput,
  SaveDebitNoteInput,
  SaveDiscountTypeInput,
  SaveEmployeeInput,
  SaveFacilityExpenseInput,
  SaveFinancialLinkInput,
  SaveFinancialStatementLineInput,
  SaveFixedAssetCodingSettingsInput,
  SaveFixedAssetGroupInput,
  SaveFixedAssetInput,
  SaveFixedAssetLocationInput,
  SaveFixedAssetLookupInput,
  SaveFixedAssetsSystemSettingsInput,
  SaveHrLookupInput,
  HrLookupEntry,
  EmployeeReportFilter,
  EmployeeReportResult,
  CompanyDocumentInquiryRow,
  EmployeeStateChangeRow,
  HrDailyRegisterRow,
  HrLookupType,
  SaveLetterOfCreditInput,
  SaveLetterOfCreditTypeInput,
  SaveOpeningBalancesInput,
  SaveOpeningBalancesResult,
  SavePartnerLookupInput,
  SavePaymentBookInput,
  SavePaymentCardCommissionPolicyInput,
  SavePaymentCardTypeInput,
  SavePaymentMethodInput,
  SavePaymentOrderInput,
  SavePaymentVoucherInput,
  SavePersonnelRoleInput,
  SavePrepaidScheduleInput,
  SavePurchaseItemInput,
  SavePurchaseOrderInput,
  SaveReceiptBookInput,
  SaveReceiptOrderInput,
  SaveReceiptVoucherInput,
  SaveReceivablesAgingPeriodInput,
  SaveReceivablesSettingsInput,
  SaveReportSignatureInput,
  SaveResponsibleEntityInput,
  SaveSalesPurchaseTaxTypeInput,
  SaveServicePurchaseInvoiceInput,
  SaveServicePurchaseRequestInput,
  SaveServicePurchaseReturnInput,
  SaveServiceQuotationInput,
  SaveServiceSalesInvoiceInput,
  SaveServiceSalesReturnInput,
  SaveServiceSalesTypeInput,
  SaveSmsReminderSettingsInput,
  SaveSupplierCreditNoteInput,
  SaveSupplierDebitNoteInput,
  SaveSupplierEvaluationCriterionInput,
  SaveSupplierTransactionTransferInput,
  SaveSystemBranchInput,
  SaveSystemCompanyInput,
  SaveSystemRoleInput,
  SaveTransactionFreezeInput,
  SaveVoucherTypeInput,
  SaveWorkflowActionInput,
  SchedulableLineList,
  SendRemindersInput,
  SendSupplierRemindersInput,
  ServicePurchaseDocumentsFilter,
  ServicePurchaseDocumentsResult,
  ServicePurchaseInvoice,
  ServicePurchaseInvoiceList,
  ServicePurchaseRequest,
  ServicePurchaseRequestList,
  ServicePurchaseReturn,
  ServicePurchaseReturnAvailability,
  ServicePurchaseReturnList,
  ServiceQuotation,
  ServiceQuotationAttachment,
  ServiceQuotationList,
  ServiceSalesInvoice,
  ServiceSalesInvoiceAttachment,
  ServiceSalesInvoiceList,
  ServiceSalesReturn,
  ServiceSalesReturnAttachment,
  ServiceSalesReturnFilter,
  ServiceSalesReturnList,
  ServiceSalesTypeAuditEntry,
  ServiceSalesTypeList,
  ServiceSalesTypeLookupRow,
  ServiceVoucherTransactionsFilter,
  ServiceVoucherTransactionsResult,
  ShortTrialBalanceFilter, ShortTrialBalanceResult,
  SmsReminderSettings,
  SmsReminderSettingsAuditEntry,
  SubledgerParty,
  SupplierAccessScopeValue,
  SupplierAccountMovementsFilter,
  SupplierAccountMovementsResult,
  SupplierAgeingFilter, SupplierAgeingResult,
  SupplierBalancesByCostCenterFilter,
  SupplierBalancesByCostCenterResult,
  SupplierBlacklistFilter, SupplierBlacklistResult,
  SupplierByAccountFilter, SupplierByAccountResult,
  SupplierCostCenterFilter,
  SupplierCostCenterResult,
  SupplierCreditLimit,
  SupplierCreditLimitHistory,
  SupplierCreditNote,
  SupplierCreditNoteList,
  SupplierCurrencyStatementFilter,
  SupplierCurrencyStatementResult,
  SupplierDebitNote,
  SupplierDebitNoteList,
  SupplierEditableFields,
  SupplierEvaluationCriteriaList,
  SupplierInformation,
  SupplierInformationInquiryFilter,
  SupplierInformationInquiryResult,
  SupplierItemTransactionsFilter,
  SupplierItemTransactionsResult,
  SupplierQuotationList,
  SupplierReminderBatch,
  SupplierReminderBatchList,
  SupplierReminderCandidateExportFilter,
  SupplierReminderCandidateFilter,
  SupplierReminderCandidateList,
  SupplierReminderPreview,
  SupplierReminderTemplateInfo,
  SupplierTransactionTransfer,
  SupplierTransactionTransferList,
  SystemBranch,
  SystemCompany,
  SystemPagedResult,
  SystemRole,
  SystemRoleDetail,
  SystemRoleFilter,
  SystemUserDetail,
  SystemUserFilter,
  TaxRate,
  TaxRateFilter,
  TaxRateInput,
  TaxType,
  TaxTypeFilter,
  TaxTypeInput,
  TimeZoneOption,
  TotalSupplierPayablesFilter,
  TotalSupplierPayablesResult,
  TransactionFreezeList,
  TransferableMovementList,
  TransferableSupplierMovementList,
  UnappliedPaymentVouchersFilter,
  UnappliedPaymentVouchersResult,
  UnauditedJournalNotesFilter,
  UnauditedJournalNotesResult,
  UnsettledPaymentOrdersFilter,
  UnsettledPaymentOrdersResult,
  UpdateFinancialStatementInput,
  UpdateGeneralLedgerSettingsInput,
  UpdateSystemUserInput,
  User,
  UserCashboxAccess,
  UserCashboxAccessSummary,
  UserPartnerAccess,
  UserPartnerAccessAuditEntry,
  UserProfile,
  VoucherTransactionsFilter,
  VoucherTransactionsResult,
  VoucherType,
  VoucherTypeAuditEntry,
  VoucherTypeList,
  VoucherTypeModule,
  VoucherTypeUsage,
  WorkflowActionAuditEntry,
  WorkflowActionList,
  MaterialRequest,
  MaterialOrder,
  GoodsReceipt,
  MaterialInvoice,
  MaterialReturn,
  SalesDocument,
  SalesSourceLine,
  StockDocument,
  StockCount,
  StockBalanceFilter,
  StockBalanceResult,
  StockMovementInquiryFilter,
  StockMovementInquiryResult,
  ReorderFilter,
  ReorderResult,
  NonMovingFilter,
  NonMovingResult,
  PurchaseOrderInquiryFilter,
  PurchaseOrderInquiryResult,
  GoodsReceiptInquiryFilter,
  GoodsReceiptInquiryResult,
  MaterialInvoiceInquiryFilter,
  MaterialInvoiceInquiryResult,
  MaterialReturnInquiryFilter,
  MaterialReturnInquiryResult,
  StockDocumentInquiryFilter,
  StockDocumentInquiryResult,
  StockCountInquiryFilter,
  StockCountInquiryResult,
  ItemBySupplierFilter,
  ItemRegisterFilter,
  ItemRegisterResult,
  ItemBySupplierResult,
  InventoryReconciliationFilter,
  InventoryReconciliationResult,
  LeaveType,
  SaveLeaveTypeInput,
  LeaveFormContext,
  LeaveRequestListItem,
  LeaveRequestDetail,
  SaveLeaveRequestInput,
  SaveLeaveAmendmentInput,
  SaveLeaveBalanceAdjustmentInput,
  LeaveMovement,
  LeaveBalanceRow,
  LeaveReportFilter,
  LeaveReportResult,
  LeaveReportCoverage,
  HrDocumentListItem,
  HrDocument,
  HrDocumentSearchFilter,
  HrDailyFormContext,
  CompanyDocumentRow,
  PolicyRegulationRow,
  EmployeeCustodyRow,
  HotelSettingsDto,
  QuickAddGuestResultDto,
  RoomBoardTileDto,
  RoomDto,
  RoomTypeDto,
} from "./types";

// Value import: the route helper below compares against it at runtime.
import { RELATED_PARTY_TYPE } from "./types";
import { localizePermissionCatalog } from "@/lib/permission-labels";

export interface EndpointOptions {
  signal?: AbortSignal;
  /** Scope the call to a specific company/branch instead of the ambient one. */
  auth?: RequestAuthContext;
}

export function login(input: LoginRequest, options: EndpointOptions = {}): Promise<AuthResult> {
  return apiPost<AuthResult>("/auth/login", input, { ...options, anonymous: true });
}

export function refresh(input: RefreshRequest, options: EndpointOptions = {}): Promise<AuthResult> {
  // Anonymous + no recovery: this endpoint *is* the recovery path.
  return apiPost<AuthResult>("/auth/refresh", input, {
    ...options,
    anonymous: true,
    skipAuthRecovery: true,
  });
}

export function logout(input: LogoutRequest, options: EndpointOptions = {}): Promise<void> {
  // A 401 here means the session is already gone; refreshing it would be pointless.
  return apiPost<void>("/auth/logout", input, { ...options, skipAuthRecovery: true });
}

export function changePassword(
  input: ChangePasswordRequest,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>("/auth/change-password", input, options);
}

export function getCurrentUser(options: EndpointOptions = {}): Promise<UserProfile> {
  return apiGet<UserProfile>("/auth/me", options);
}

/** Requires the `reporting.view` permission. */
export function getReportsCenter(options: EndpointOptions = {}): Promise<ReportsCenterResult> {
  return apiGet<ReportsCenterResult>("/reports-center", options);
}

/**
 * One category and the reports inside it — the navigation screen behind a category tile.
 *
 * Serves every category, not just Accounting. A category the user may not open answers 404
 * rather than 403, so an unauthorised caller learns nothing about what the product contains.
 */
export function getReportCategory(
  categoryCode: string,
  options: EndpointOptions = {},
): Promise<ReportCategoryDetail> {
  return apiGet<ReportCategoryDetail>(
    `/reports-center/${encodeURIComponent(categoryCode)}`,
    options,
  );
}

// ───────────────────────────────────────── Accounting master data

/** Appends only the query parameters that were actually supplied. */
function withQuery(
  path: string,
  params: Record<string, string | number | boolean | undefined>,
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === "") continue;
    search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `${path}?${qs}` : path;
}

export interface MasterDataFilter {
  search?: string;
  isActive?: boolean;
}

// Currencies are tenant-wide, so these calls carry no company scope.

export function getCurrencies(
  filter: MasterDataFilter = {},
  options: EndpointOptions = {},
): Promise<Currency[]> {
  return apiGet<Currency[]>(withQuery("/accounting/currencies", { ...filter }), options);
}

export function createCurrency(input: CurrencyInput, options: EndpointOptions = {}): Promise<string> {
  return apiPost<string>("/accounting/currencies", input, options);
}

export function updateCurrency(
  id: string,
  input: CurrencyInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/currencies/${id}`, { ...options, method: "PUT", body: input });
}

export function setCurrencyActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/currencies/${id}/active`, {
    ...options,
    method: "PATCH",
    body: { isActive },
  });
}

export function deleteCurrency(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`/accounting/currencies/${id}`, { ...options, method: "DELETE" });
}

/** The full rate history for one currency, newest window first. */
export function getExchangeRates(
  currencyId: string,
  options: EndpointOptions = {},
): Promise<ExchangeRateRow[]> {
  return apiGet<ExchangeRateRow[]>(`/accounting/currencies/${currencyId}/rates`, options);
}

/**
 * Makes a currency the company's base. Requires its own permission, and the body must echo the
 * currency code — a base-currency change is never one stray click away.
 */
export function setBaseCurrency(
  currencyId: string,
  confirmation: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/currencies/${currencyId}/base`, {
    ...options,
    method: "POST",
    body: { confirmation },
  });
}

/** Appends a dated rate. Never edits an existing window. */
export function addExchangeRate(
  currencyId: string,
  input: ExchangeRateInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/currencies/${currencyId}/rates`, {
    ...options,
    method: "POST",
    body: input,
  });
}

// Cost centres and accounts are company-scoped. The company travels on the X-Company-Id header
// that the API client attaches, so no id is threaded through these signatures.

export interface CostCenterFilter extends MasterDataFilter {
  /**
   * Omit for the whole tree; pass true for the leaves a posting may name.
   *
   * A document line's picker wants the postable set - a group aggregates its children and the
   * server refuses a posting to one, so offering it is offering a choice that can only fail.
   * A report filter wants the whole tree, where picking a group means "and everything under it".
   */
  isPostable?: boolean;
}

export function getCostCenters(
  filter: CostCenterFilter = {},
  options: EndpointOptions = {},
): Promise<CostCenter[]> {
  return apiGet<CostCenter[]>(withQuery("/accounting/cost-centers", { ...filter }), options);
}

export function getCostCenterTree(
  activeOnly = false,
  options: EndpointOptions = {},
): Promise<CostCenterTreeNode[]> {
  return apiGet<CostCenterTreeNode[]>(
    withQuery("/accounting/cost-centers/tree", { activeOnly: activeOnly || undefined }),
    options,
  );
}

export function createCostCenter(input: CostCenterInput, options: EndpointOptions = {}): Promise<string> {
  return apiPost<string>("/accounting/cost-centers", input, options);
}

export function updateCostCenter(
  id: string,
  input: CostCenterInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/cost-centers/${id}`, { ...options, method: "PUT", body: input });
}

export function setCostCenterActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/cost-centers/${id}/active`, {
    ...options,
    method: "PATCH",
    body: { isActive },
  });
}

export function deleteCostCenter(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`/accounting/cost-centers/${id}`, { ...options, method: "DELETE" });
}

export interface AccountFilter extends MasterDataFilter {
  accountType?: string;
  isPostable?: boolean;
}

export function getAccounts(
  filter: AccountFilter = {},
  options: EndpointOptions = {},
): Promise<Account[]> {
  return apiGet<Account[]>(withQuery("/accounting/accounts", { ...filter }), options);
}

export function getAccountTree(
  activeOnly = false,
  options: EndpointOptions = {},
): Promise<AccountTreeNode[]> {
  return apiGet<AccountTreeNode[]>(
    withQuery("/accounting/accounts/tree", { activeOnly: activeOnly || undefined }),
    options,
  );
}

/** One account with everything the details screen needs, in a single call. */
export function getAccount(id: string, options: EndpointOptions = {}): Promise<Account> {
  return apiGet<Account>(`/accounting/accounts/${id}`, options);
}

/** Account classifications the details screen offers. */
export function getAccountCategories(options: EndpointOptions = {}): Promise<AccountCategory[]> {
  return apiGet<AccountCategory[]>("/accounting/accounts/categories", options);
}

export function createAccount(input: AccountInput, options: EndpointOptions = {}): Promise<string> {
  return apiPost<string>("/accounting/accounts", input, options);
}

export function updateAccount(
  id: string,
  input: AccountInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/accounts/${id}`, { ...options, method: "PUT", body: input });
}

export function setAccountActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`/accounting/accounts/${id}/active`, {
    ...options,
    method: "PATCH",
    body: { isActive },
  });
}

export function deleteAccount(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`/accounting/accounts/${id}`, { ...options, method: "DELETE" });
}

// ---------------------------------------------------------------- Journal entries
//
// Company-scoped like the rest of accounting: the company travels on the X-Company-Id header the
// API client attaches, so no company id appears in these signatures.

const JOURNALS = "/accounting/journal-entries";

/** Voucher type, branches, base currency and today's period — one call, before the form renders. */
export function getJournalEntryContext(options: EndpointOptions = {}): Promise<JournalEntryContext> {
  return apiGet<JournalEntryContext>(`${JOURNALS}/context`, options);
}

/** The fiscal year and period a voucher date falls in. Called whenever the date changes. */
export function resolveFiscalPeriod(
  date: string,
  options: EndpointOptions = {},
): Promise<FiscalPeriodResolution> {
  return apiGet<FiscalPeriodResolution>(withQuery(`${JOURNALS}/fiscal-period`, { date }), options);
}

/** The rate effective for a currency on a voucher date. */
export function resolveExchangeRate(
  currencyId: string,
  date: string,
  options: EndpointOptions = {},
): Promise<ExchangeRateResolution> {
  return apiGet<ExchangeRateResolution>(
    withQuery(`${JOURNALS}/exchange-rate`, { currencyId, date }),
    options,
  );
}

/** Accounts a line may target: active, open, postable leaves only. */
/**
 * Accounts a line may target.
 *
 * `includeGroups` also returns group headers. Off for journal entry, where a group is not a valid
 * line coordinate; on for the inquiry screens, whose "include child accounts" option exists
 * precisely to expand one — an option that can only ever be applied to a leaf does nothing.
 */
export function getPostingAccounts(
  search: string | undefined,
  options: EndpointOptions = {},
  includeGroups = false,
): Promise<PostingAccount[]> {
  return apiGet<PostingAccount[]>(
    withQuery(`${JOURNALS}/posting-accounts`, {
      search: search || undefined,
      take: 100,
      includeGroups: includeGroups || undefined,
    }),
    options,
  );
}

/** Parties of the kind the chosen account requires. */
export function getSubledgerParties(
  partyType: RelatedPartyType,
  search: string | undefined,
  options: EndpointOptions = {},
): Promise<SubledgerParty[]> {
  return apiGet<SubledgerParty[]>(
    withQuery(`${JOURNALS}/subledger-parties`, {
      partyType,
      search: search || undefined,
      take: 100,
    }),
    options,
  );
}

export function getJournalVouchers(
  filter: JournalVoucherFilter = {},
  options: EndpointOptions = {},
): Promise<JournalVoucherPage> {
  return apiGet<JournalVoucherPage>(withQuery(JOURNALS, { ...filter }), options);
}

export function getJournalVoucher(id: string, options: EndpointOptions = {}): Promise<JournalVoucher> {
  return apiGet<JournalVoucher>(`${JOURNALS}/${id}`, options);
}

/** Saves a new entry as an unposted draft. Returns the saved voucher, numbered by the server. */
export function createJournalVoucher(
  input: JournalVoucherInput,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(JOURNALS, input, options);
}

export function updateJournalVoucher(
  id: string,
  input: JournalVoucherInput,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return request<JournalVoucher>(`${JOURNALS}/${id}`, { ...options, method: "PUT", body: input });
}

export function deleteJournalVoucher(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${JOURNALS}/${id}`, { ...options, method: "DELETE" });
}

/**
 * The print URL. Returned as a string rather than fetched: the PDF is opened in a browser tab so
 * the built-in viewer can preview, print and download it, which is exactly what was asked for and
 * needs no blob handling of our own.
 */
export function journalPrintUrl(
  id: string,
  options: {
    locale?: string;
    printSubledger?: boolean;
    showCostCenters?: boolean;
    showCurrency?: boolean;
    printStamps?: boolean;
  } = {},
): string {
  // Only the journal screens print through this URL, so the heading is always «قيد يومية». The
  // cash deposit/withdrawal/cashbox prints use their own fetchers and keep their type heading.
  return `${getApiBaseUrl()}${withQuery(`${JOURNALS}/${id}/print`, { ...options, asJournalEntry: true })}`;
}

export function uploadJournalAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<JournalAttachment> {
  const form = new FormData();
  form.append("file", file);

  if (description) {
    form.append("description", description);
  }

  return request<JournalAttachment>(`${JOURNALS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function journalAttachmentUrl(id: string, attachmentId: string, download = false): string {
  return `${getApiBaseUrl()}${withQuery(`${JOURNALS}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteJournalAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${JOURNALS}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

/** The change history of one entry. Reads the existing audit trail; records nothing new. */
export function getJournalAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<JournalAuditEntry[]> {
  return apiGet<JournalAuditEntry[]>(`${JOURNALS}/${id}/audit-history`, options);
}

// ─────────────────── Journal audit and posting (stages 2 and 3)
//
// Separate calls with separate permissions on purpose: a user may audit and not post.

export function getPostingEligibility(
  id: string,
  options: EndpointOptions = {},
): Promise<JournalPostingEligibility> {
  return apiGet<JournalPostingEligibility>(`${JOURNALS}/${id}/posting-eligibility`, options);
}

/** Approves the audit. No accounting impact. */
export function auditJournalVoucher(
  id: string,
  auditNotes: string | null,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(`${JOURNALS}/${id}/audit`, { auditNotes }, options);
}

/** Rejects and returns the entry to the accountant. The reason is required. */
export function rejectJournalVoucher(
  id: string,
  reason: string,
  auditNotes: string | null,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(`${JOURNALS}/${id}/reject`, { reason, auditNotes }, options);
}

/** Saves review notes without reaching a verdict. */
export function saveAuditNotes(
  id: string,
  auditNotes: string | null,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(`${JOURNALS}/${id}/audit-notes`, { auditNotes }, options);
}

/** Posts an audited entry through the centralised posting service. */
export function postJournalVoucher(
  id: string,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(`${JOURNALS}/${id}/post`, {}, options);
}

// ─────────────────────────────── Daily Transactions Inquiry

const GL_INQUIRIES = "/accounting/gl-inquiries";
const RECEIVABLES_INQUIRIES = "/accounting/receivables-inquiries";

/** Journal Voucher movements on one account. Paged and sorted server-side. */
export function getDailyTransactions(
  filter: DailyTransactionsFilter,
  options: EndpointOptions = {},
): Promise<DailyTransactionsResult> {
  return apiGet<DailyTransactionsResult>(
    withQuery(`${GL_INQUIRIES}/daily-transactions`, { ...filter }),
    options,
  );
}

/**
 * URLs for the two exports.
 *
 * Returned as strings and fetched with the auth helper rather than navigated to: an API URL
 * opened as a plain navigation carries no bearer token and no company header.
 */
export function dailyTransactionsExportUrl(
  format: "pdf" | "excel",
  filter: DailyTransactionsFilter,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_INQUIRIES}/daily-transactions/${format}`, {
    ...filter,
    locale,
  })}`;
}

// ─────────────────────────────── Account Movements Inquiry

/** Every General Ledger movement on one account, with its balances. Paged server-side. */
export function getAccountMovements(
  filter: AccountMovementsFilter,
  options: EndpointOptions = {},
): Promise<AccountMovementsResult> {
  return apiGet<AccountMovementsResult>(
    withQuery(`${GL_INQUIRIES}/account-movements`, { ...filter }),
    options,
  );
}

/**
 * URLs for the statement exports.
 *
 * `forPrinting` changes no byte of the output — it tells the server to check the PRINT right
 * rather than the export right, because putting a statement on paper and taking a copy of it away
 * are different acts that a role may be trusted with separately.
 */
export function accountMovementsExportUrl(
  format: "pdf" | "excel",
  filter: AccountMovementsFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_INQUIRIES}/account-movements/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Cost Center Account Inquiry

/** Movements charged to one cost centre on one account, with its balances. Paged server-side. */
export function getCostCenterAccount(
  filter: CostCenterAccountFilter,
  options: EndpointOptions = {},
): Promise<CostCenterAccountResult> {
  return apiGet<CostCenterAccountResult>(
    withQuery(`${GL_INQUIRIES}/cost-center-account`, { ...filter }),
    options,
  );
}

/** URLs for the statement exports. `forPrinting` selects the print right over the export right. */
export function costCenterAccountExportUrl(
  format: "pdf" | "excel",
  filter: CostCenterAccountFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_INQUIRIES}/cost-center-account/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Cash Subledger Movements Inquiry

/** Cash and immediately settled movements, by party. Paged, sorted and totalled server-side. */
export function getCashSubledger(
  filter: CashSubledgerFilter,
  options: EndpointOptions = {},
): Promise<CashSubledgerResult> {
  return apiGet<CashSubledgerResult>(
    withQuery(`${GL_INQUIRIES}/cash-subledger`, { ...filter }),
    options,
  );
}

/** URLs for the cash subledger exports. `forPrinting` selects the print right over the export right. */
export function cashSubledgerExportUrl(
  format: "pdf" | "excel",
  filter: CashSubledgerFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_INQUIRIES}/cash-subledger/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Unaudited Journal Notes Inquiry

/**
 * Who has entered or reviewed journals here, for the Created By and Auditor filters.
 *
 * Deliberately not the user directory: a filter dropdown is a poor reason to hand every accountant
 * a list of every account in the system.
 */
export function getJournalParticipants(
  options: EndpointOptions = {},
): Promise<JournalParticipants> {
  return apiGet<JournalParticipants>(`${GL_INQUIRIES}/journal-participants`, options);
}

/** Journal entries still inside the audit conversation. Paged, sorted and totalled server-side. */
export function getUnauditedJournalNotes(
  filter: UnauditedJournalNotesFilter,
  options: EndpointOptions = {},
): Promise<UnauditedJournalNotesResult> {
  return apiGet<UnauditedJournalNotesResult>(
    withQuery(`${GL_INQUIRIES}/unaudited-journal-notes`, { ...filter }),
    options,
  );
}

/** URLs for the inquiry exports. `forPrinting` selects the print right over the export right. */
export function unauditedJournalNotesExportUrl(
  format: "pdf" | "excel",
  filter: UnauditedJournalNotesFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_INQUIRIES}/unaudited-journal-notes/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Tax Types (Jordan Tax module)

const TAX_TYPES = "/accounting/tax-types";

/** The company's tax catalogue. Returned whole — a tax list is a handful of rows, not thousands. */
export function getTaxTypes(
  filter: TaxTypeFilter = {},
  options: EndpointOptions = {},
): Promise<TaxType[]> {
  return apiGet<TaxType[]>(withQuery(TAX_TYPES, { ...filter }), options);
}

export function createTaxType(input: TaxTypeInput, options: EndpointOptions = {}): Promise<string> {
  return request<string>(TAX_TYPES, { ...options, method: "POST", body: input });
}

export function updateTaxType(
  id: string,
  input: TaxTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${TAX_TYPES}/${id}`, { ...options, method: "PUT", body: input });
}

/** Activates or deactivates. The server picks the permission from the direction. */
export function setTaxTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${TAX_TYPES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

export function deleteTaxType(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${TAX_TYPES}/${id}`, { ...options, method: "DELETE" });
}

/** URLs for the catalogue exports. `forPrinting` selects the print right over the export right. */
export function taxTypesExportUrl(
  format: "pdf" | "excel",
  filter: TaxTypeFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${TAX_TYPES}/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Tax Rates (Jordan Tax module)

const TAX_RATES = "/accounting/tax-rates";

/** The company's effective-dated rates, newest window first. */
export function getTaxRates(
  filter: TaxRateFilter = {},
  options: EndpointOptions = {},
): Promise<TaxRate[]> {
  return apiGet<TaxRate[]>(withQuery(TAX_RATES, { ...filter }), options);
}

/** Every rate one tax type has ever carried, expired ones included. */
export function getTaxRateHistory(
  taxTypeId: string,
  options: EndpointOptions = {},
): Promise<TaxRate[]> {
  return apiGet<TaxRate[]>(`${TAX_RATES}/history/${taxTypeId}`, options);
}

/**
 * The rate in force for one tax on one date.
 *
 * The centralized resolution service over HTTP — the screen never works this out for itself, so a
 * future invoice and this page can never disagree about which rate applies.
 */
export function resolveTaxRate(
  taxTypeId: string,
  onDate?: string,
  options: EndpointOptions = {},
): Promise<ResolvedTaxRate> {
  return apiGet<ResolvedTaxRate>(withQuery(`${TAX_RATES}/resolve`, { taxTypeId, onDate }), options);
}

export function createTaxRate(input: TaxRateInput, options: EndpointOptions = {}): Promise<string> {
  return request<string>(TAX_RATES, { ...options, method: "POST", body: input });
}

export function updateTaxRate(
  id: string,
  input: TaxRateInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${TAX_RATES}/${id}`, { ...options, method: "PUT", body: input });
}

export function setTaxRateActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${TAX_RATES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

/** Gives an open-ended rate an end date. Always explicit, always audited. */
export function closeTaxRate(
  id: string,
  effectiveTo: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${TAX_RATES}/${id}/close`, { effectiveTo }), {
    ...options,
    method: "POST",
  });
}

export function deleteTaxRate(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${TAX_RATES}/${id}`, { ...options, method: "DELETE" });
}

/** URLs for the schedule exports. `forPrinting` selects the print right over the export right. */
export function taxRatesExportUrl(
  format: "pdf" | "excel",
  filter: TaxRateFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${TAX_RATES}/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── General Ledger Settings

const GENERAL_LEDGER_SETTINGS = "/accounting/general-ledger-settings";

/** The current company's settings, created with approved defaults on first read. */
export function getGeneralLedgerSettings(options: EndpointOptions = {}): Promise<GeneralLedgerSettings> {
  return apiGet<GeneralLedgerSettings>(GENERAL_LEDGER_SETTINGS, options);
}

/** Saves every setting atomically. */
export function updateGeneralLedgerSettings(
  input: UpdateGeneralLedgerSettingsInput,
  options: EndpointOptions = {},
): Promise<GeneralLedgerSettings> {
  return request<GeneralLedgerSettings>(GENERAL_LEDGER_SETTINGS, { ...options, method: "PUT", body: input });
}

/** Resets every setting back to its approved default. Always an explicit, confirmed act. */
export function restoreGeneralLedgerSettingsDefaults(
  options: EndpointOptions = {},
): Promise<GeneralLedgerSettings> {
  return request<GeneralLedgerSettings>(`${GENERAL_LEDGER_SETTINGS}/restore-defaults`, {
    ...options,
    method: "POST",
  });
}

/** How many postable accounts currently have no Default Cost Center. */
export function getNonCompliantAccountsCount(
  options: EndpointOptions = {},
): Promise<NonCompliantAccountsCount> {
  return apiGet<NonCompliantAccountsCount>(`${GENERAL_LEDGER_SETTINGS}/non-compliant-accounts-count`, options);
}

/** The change history of this company's General Ledger Settings. */
export function getGeneralLedgerSettingsAuditHistory(
  options: EndpointOptions = {},
): Promise<GeneralLedgerSettingsAuditEntry[]> {
  return apiGet<GeneralLedgerSettingsAuditEntry[]>(`${GENERAL_LEDGER_SETTINGS}/audit-history`, options);
}

// ─────────────────────────────── Financial Position Inquiry

const FINANCIAL_POSITION = `${GL_INQUIRIES}/financial-position`;

/** The balance sheet as of a date: a flat pre-ordered hierarchy plus server-computed totals. */
export function getFinancialPosition(
  filter: FinancialPositionFilter,
  options: EndpointOptions = {},
): Promise<FinancialPositionResult> {
  return apiGet<FinancialPositionResult>(withQuery(FINANCIAL_POSITION, { ...filter }), options);
}

/** URLs for the exports. `forPrinting` selects the print right over the export right. */
export function financialPositionExportUrl(
  format: "pdf" | "excel",
  filter: FinancialPositionFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${FINANCIAL_POSITION}/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── Financial Link Settings

const FINANCIAL_LINKS = "/accounting/financial-links";

/**
 * The predefined slots and the mapping each currently carries.
 *
 * `module` is which screen is asking: General Ledger and Receivables read the same table and the
 * same rows, and differ only in which roles they are responsible for.
 */
export function getFinancialLinks(
  options: EndpointOptions & { search?: string; module?: FinancialLinkModule } = {},
): Promise<FinancialLinkResult> {
  const { search, module, ...rest } = options;
  return apiGet<FinancialLinkResult>(withQuery(FINANCIAL_LINKS, { search, module }), rest);
}

/** The entities a level offers — or an honest statement that its module has not shipped. */
export function getLinkLevelEntities(
  level: FinancialLinkLevel,
  options: EndpointOptions & { search?: string } = {},
): Promise<LinkLevelEntities> {
  const { search, ...rest } = options;
  return apiGet<LinkLevelEntities>(
    withQuery(`${FINANCIAL_LINKS}/levels/${level}/entities`, { search }),
    rest,
  );
}

/** Maps a slot at a level and entity to an account, or re-points that mapping. */
export function saveFinancialLink(
  input: SaveFinancialLinkInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(FINANCIAL_LINKS, { ...options, method: "PUT", body: input });
}

/** Removes the account, keeping the row and its history. There is no delete. */
/** Every change recorded against one mapping, newest first. */
export function getFinancialLinkAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<FinancialLinkAuditEntry[]> {
  return apiGet<FinancialLinkAuditEntry[]>(`${FINANCIAL_LINKS}/${id}/audit-history`, options);
}

export function clearFinancialLink(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${FINANCIAL_LINKS}/${id}/clear`, { ...options, method: "POST" });
}

export function setFinancialLinkActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FINANCIAL_LINKS}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

// ─────────────────────────────── Financial Statement Setup

const FINANCIAL_STATEMENTS = "/accounting/financial-statements";

/** The statements this company has defined. Backs the screen's Query button. */
export function getFinancialStatements(
  options: EndpointOptions & { search?: string; activeOnly?: boolean } = {},
): Promise<FinancialStatementList> {
  const { search, activeOnly, ...rest } = options;
  return apiGet<FinancialStatementList>(
    withQuery(FINANCIAL_STATEMENTS, { search, activeOnly }),
    rest,
  );
}

/** One statement definition, loaded into the form. */
export function getFinancialStatement(
  id: string,
  options: EndpointOptions = {},
): Promise<FinancialStatementDefinition> {
  return apiGet<FinancialStatementDefinition>(`${FINANCIAL_STATEMENTS}/${id}`, options);
}

/** Defines a new financial statement. Returns its id. */
export function createFinancialStatement(
  input: CreateFinancialStatementInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(FINANCIAL_STATEMENTS, input, options);
}

/** Amends an existing statement. */
export function updateFinancialStatement(
  id: string,
  input: UpdateFinancialStatementInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FINANCIAL_STATEMENTS}/${id}`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

/** Removes a statement definition — the screen's "Delete All". */
export function deleteFinancialStatement(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${FINANCIAL_STATEMENTS}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Voucher Types

const VOUCHER_TYPES = "/accounting/voucher-types";

export interface VoucherTypeFilter {
  search?: string;
  isActive?: boolean;
  /** Which settings screen is asking. Omitted returns the whole catalogue. */
  module?: VoucherTypeModule;
}

/** The catalogue, with the usage count that decides whether each row can be retired. */
export function getVoucherTypes(
  options: EndpointOptions & VoucherTypeFilter = {},
): Promise<VoucherTypeList> {
  const { search, isActive, module, ...rest } = options;
  return apiGet<VoucherTypeList>(withQuery(VOUCHER_TYPES, { search, isActive, module }), rest);
}

export function getVoucherType(id: string, options: EndpointOptions = {}): Promise<VoucherType> {
  return apiGet<VoucherType>(`${VOUCHER_TYPES}/${id}`, options);
}

/** Where a type is used, so retiring it is an informed decision. */
export function getVoucherTypeUsage(
  id: string,
  options: EndpointOptions = {},
): Promise<VoucherTypeUsage> {
  return apiGet<VoucherTypeUsage>(`${VOUCHER_TYPES}/${id}/usage`, options);
}

export function getVoucherTypeAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<VoucherTypeAuditEntry[]> {
  return apiGet<VoucherTypeAuditEntry[]>(`${VOUCHER_TYPES}/${id}/audit-history`, options);
}

export function createVoucherType(
  input: SaveVoucherTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(VOUCHER_TYPES, input, options);
}

export function updateVoucherType(
  id: string,
  input: SaveVoucherTypeInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${VOUCHER_TYPES}/${id}`, { ...options, method: "PUT", body: input });
}

/** Activates or deactivates. There is no delete — a used type must stay explicable. */
export function setVoucherTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${VOUCHER_TYPES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

/** Absolute URLs for Print, PDF and Excel — the browser fetches these directly. */
export function voucherTypesExportUrl(
  format: "pdf" | "excel",
  filter: VoucherTypeFilter & { locale?: string; forPrinting?: boolean } = {},
): string {
  return `${getApiBaseUrl()}${withQuery(`${VOUCHER_TYPES}/export/${format}`, { ...filter })}`;
}

// ─────────────────────────────── Account Opening Balances

const OPENING_BALANCES = "/accounting/account-opening-balances";

/** The preparation sheet: every eligible posting account, with zeros where nothing is declared. */
export function getOpeningBalanceSheet(
  options: EndpointOptions & OpeningBalanceFilter = {},
): Promise<OpeningBalanceSheet> {
  // The auth context travels as a request option, not as a query parameter — destructured out
  // so it can never end up in the URL.
  const { signal, auth, ...filter } = options;
  return apiGet<OpeningBalanceSheet>(withQuery(OPENING_BALANCES, { ...filter }), { signal, auth });
}

/** The fiscal years a sheet may be prepared for. Never free text. */
export function getOpeningBalanceFiscalYears(
  options: EndpointOptions = {},
): Promise<OpeningBalanceFiscalYear[]> {
  return apiGet<OpeningBalanceFiscalYear[]>(`${OPENING_BALANCES}/fiscal-years`, options);
}

/**
 * Saves declared figures. Serves both "Save Selected Rows" and "Save All Changes" — they differ
 * only in which rows the screen puts in `rows`. The batch is all-or-nothing on the server.
 */
export function saveOpeningBalances(
  input: SaveOpeningBalancesInput,
  options: EndpointOptions = {},
): Promise<SaveOpeningBalancesResult> {
  return request<SaveOpeningBalancesResult>(OPENING_BALANCES, {
    ...options,
    method: "PUT",
    body: input,
  });
}

/**
 * The sheet as a PDF or a spreadsheet, under the SAME filters the screen is showing.
 *
 * Fetched as an authenticated request rather than by opening the URL in a tab: the API accepts a
 * bearer token and nothing else, so a plain `window.open` at an export URL is answered with 401.
 * The server re-runs the sheet query, so this is always every filtered row and never a page.
 */
export function fetchOpeningBalancesExport(
  format: "pdf" | "excel",
  filter: OpeningBalanceFilter & { locale?: string; forPrinting?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  const extension = format === "pdf" ? "pdf" : "xlsx";
  return requestFile(
    withQuery(`${OPENING_BALANCES}/export/${format}`, { ...filter }),
    `account-opening-balances.${extension}`,
    options,
  );
}

// ─────────────────────────────── Cost Center Groups

const COST_CENTER_GROUPS = "/accounting/cost-center-groups";

export function getCostCenterGroups(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CostCenterGroupList> {
  return apiGet<CostCenterGroupList>(withQuery(COST_CENTER_GROUPS, { ...filter }), options);
}

/** One group WITH its cost centers. The list endpoint returns no members. */
export function getCostCenterGroup(
  id: string,
  options: EndpointOptions = {},
): Promise<CostCenterGroup> {
  return apiGet<CostCenterGroup>(`${COST_CENTER_GROUPS}/${id}`, options);
}

export function createCostCenterGroup(
  input: SaveCostCenterGroupInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(COST_CENTER_GROUPS, input, options);
}

export function updateCostCenterGroup(
  id: string,
  input: SaveCostCenterGroupInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${COST_CENTER_GROUPS}/${id}`, { ...options, method: "PUT", body: input });
}

export function setCostCenterGroupActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${COST_CENTER_GROUPS}/${id}/active`, { isActive }),
    undefined,
    options,
  );
}

export function deleteCostCenterGroup(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${COST_CENTER_GROUPS}/${id}`, { ...options, method: "DELETE" });
}

/** Attaches EXISTING cost centers to the group. Returns how many were newly added. */
export function addCostCenterGroupMembers(
  groupId: string,
  costCenterIds: string[],
  options: EndpointOptions = {},
): Promise<number> {
  return apiPost<number>(`${COST_CENTER_GROUPS}/${groupId}/cost-centers`, { costCenterIds }, options);
}

/** Removes the MEMBERSHIP. The cost center itself is untouched. */
export function removeCostCenterGroupMember(
  memberId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${COST_CENTER_GROUPS}/cost-centers/${memberId}`, {
    ...options,
    method: "DELETE",
  });
}

/**
 * Groups and their cost centers as a PDF or a spreadsheet.
 *
 * Fetched as an authenticated request rather than by opening the URL in a tab: the API accepts a
 * bearer token and nothing else, so a plain `window.open` at an export URL is answered with 401.
 */
export function fetchCostCenterGroupsExport(
  format: "pdf" | "excel",
  filter: { groupId?: string; search?: string; activeOnly?: boolean; locale?: string; forPrinting?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  const extension = format === "pdf" ? "pdf" : "xlsx";
  return requestFile(
    withQuery(`${COST_CENTER_GROUPS}/export/${format}`, { ...filter }),
    `cost-center-groups.${extension}`,
    options,
  );
}

// ─────────────────────────────── Payment Methods

const PAYMENT_METHODS = "/cash-banks/payment-methods";

export function getPaymentMethods(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<PaymentMethodList> {
  return apiGet<PaymentMethodList>(withQuery(PAYMENT_METHODS, { ...filter }), options);
}

/** Adds when `id` is absent, edits when present. */
export function savePaymentMethod(
  input: SavePaymentMethodInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_METHODS, { ...options, method: "PUT", body: input });
}

export function setPaymentMethodActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${PAYMENT_METHODS}/${id}/active`, { isActive }), undefined, options);
}

export function deletePaymentMethod(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${PAYMENT_METHODS}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Banks

const BANKS = "/cash-banks/banks";

export function getBanks(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<BankList> {
  return apiGet<BankList>(withQuery(BANKS, { ...filter }), options);
}

/** One bank WITH its branches. The list endpoint returns none. */
export function getBank(id: string, options: EndpointOptions = {}): Promise<Bank> {
  return apiGet<Bank>(`${BANKS}/${id}`, options);
}

export function createBank(input: SaveBankInput, options: EndpointOptions = {}): Promise<string> {
  return apiPost<string>(BANKS, input, options);
}

export function updateBank(
  id: string,
  input: SaveBankInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${BANKS}/${id}`, { ...options, method: "PUT", body: input });
}

export function setBankActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${BANKS}/${id}/active`, { isActive }), undefined, options);
}

export function deleteBank(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANKS}/${id}`, { ...options, method: "DELETE" });
}

/** Adds a branch when `id` is absent, edits it when present. */
export function saveBankBranch(
  bankId: string,
  input: SaveBankBranchInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${BANKS}/${bankId}/branches`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function setBankBranchActive(
  branchId: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${BANKS}/branches/${branchId}/active`, { isActive }),
    undefined,
    options,
  );
}

export function deleteBankBranch(branchId: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANKS}/branches/${branchId}`, { ...options, method: "DELETE" });
}

/** Adds an account to the bank when `id` is absent, edits it when present. */
export function saveBankAccount(
  bankId: string,
  input: SaveBankAccountInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${BANKS}/${bankId}/accounts`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function setBankAccountActive(
  accountId: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${BANKS}/accounts/${accountId}/active`, { isActive }),
    undefined,
    options,
  );
}

export function deleteBankAccount(accountId: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANKS}/accounts/${accountId}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Cash Deposit

const CASH_DEPOSITS = "/cash-banks/cash-deposits";

export function getCashDeposits(
  filter: {
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    bankId?: string;
    status?: JournalStatus;
  } = {},
  options: EndpointOptions = {},
): Promise<CashDepositList> {
  return apiGet<CashDepositList>(withQuery(CASH_DEPOSITS, { ...filter }), options);
}

export function getCashDeposit(id: string, options: EndpointOptions = {}): Promise<CashDeposit> {
  return apiGet<CashDeposit>(`${CASH_DEPOSITS}/${id}`, options);
}

/** Records when `id` is absent, amends when present. */
export function saveCashDeposit(
  input: SaveCashDepositInput,
  options: EndpointOptions = {},
): Promise<CashDeposit> {
  return request<CashDeposit>(CASH_DEPOSITS, { ...options, method: "PUT", body: input });
}

export function deleteCashDeposit(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${CASH_DEPOSITS}/${id}`, { ...options, method: "DELETE" });
}

export function postCashDeposit(
  id: string,
  options: EndpointOptions = {},
): Promise<CashDeposit> {
  return apiPost<CashDeposit>(`${CASH_DEPOSITS}/${id}/post`, undefined, options);
}

/**
 * The deposit's printed voucher.
 *
 * Fetched with the bearer token rather than opened as a URL: the API is JWT-only, so a plain
 * window.open would arrive without the header and be refused.
 */
export function fetchCashDepositPrint(
  journalVoucherId: string,
  voucherNumber: string,
  printOptions: { locale?: string; showCostCenters?: boolean; showCurrency?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${JOURNALS}/${journalVoucherId}/print`, { ...printOptions }),
    `${voucherNumber}.pdf`,
    options,
  );
}

// ─────────────────────────────── Cash Withdrawal

const CASH_WITHDRAWALS = "/cash-banks/cash-withdrawals";

export function getCashWithdrawals(
  filter: { search?: string; dateFrom?: string; dateTo?: string; bankId?: string; status?: JournalStatus } = {},
  options: EndpointOptions = {},
): Promise<CashWithdrawalList> {
  return apiGet<CashWithdrawalList>(withQuery(CASH_WITHDRAWALS, { ...filter }), options);
}

export function getCashWithdrawal(
  id: string,
  options: EndpointOptions = {},
): Promise<CashWithdrawal> {
  return apiGet<CashWithdrawal>(`${CASH_WITHDRAWALS}/${id}`, options);
}

export function saveCashWithdrawal(
  input: SaveCashWithdrawalInput,
  options: EndpointOptions = {},
): Promise<CashWithdrawal> {
  return request<CashWithdrawal>(CASH_WITHDRAWALS, { ...options, method: "PUT", body: input });
}

export function postCashWithdrawal(
  id: string,
  options: EndpointOptions = {},
): Promise<CashWithdrawal> {
  return apiPost<CashWithdrawal>(`${CASH_WITHDRAWALS}/${id}/post`, undefined, options);
}

export function deleteCashWithdrawal(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${CASH_WITHDRAWALS}/${id}`, { ...options, method: "DELETE" });
}

/** The withdrawal's printed voucher, fetched with the bearer token. */
export function fetchCashWithdrawalPrint(
  journalVoucherId: string,
  voucherNumber: string,
  printOptions: { locale?: string; showCostCenters?: boolean; showCurrency?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${JOURNALS}/${journalVoucherId}/print`, { ...printOptions }),
    `${voucherNumber}.pdf`,
    options,
  );
}

// ─────────────────────────────── Cashbox Transactions

const CASHBOX_TRANSACTIONS = "/cash-banks/cashbox-transactions";

export function getCashboxTransactions(
  filter: { search?: string; dateFrom?: string; dateTo?: string; status?: JournalStatus } = {},
  options: EndpointOptions = {},
): Promise<CashboxTransactionList> {
  return apiGet<CashboxTransactionList>(withQuery(CASHBOX_TRANSACTIONS, { ...filter }), options);
}

export function getCashboxTransaction(
  id: string,
  options: EndpointOptions = {},
): Promise<CashboxTransaction> {
  return apiGet<CashboxTransaction>(`${CASHBOX_TRANSACTIONS}/${id}`, options);
}

export function saveCashboxTransaction(
  input: SaveCashboxTransactionInput,
  options: EndpointOptions = {},
): Promise<CashboxTransaction> {
  return request<CashboxTransaction>(CASHBOX_TRANSACTIONS, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function postCashboxTransaction(
  id: string,
  options: EndpointOptions = {},
): Promise<CashboxTransaction> {
  return apiPost<CashboxTransaction>(`${CASHBOX_TRANSACTIONS}/${id}/post`, undefined, options);
}

export function deleteCashboxTransaction(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${CASHBOX_TRANSACTIONS}/${id}`, { ...options, method: "DELETE" });
}

export function fetchCashboxTransactionPrint(
  journalVoucherId: string,
  voucherNumber: string,
  printOptions: { locale?: string; showCostCenters?: boolean; showCurrency?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${JOURNALS}/${journalVoucherId}/print`, { ...printOptions }),
    `${voucherNumber}.pdf`,
    options,
  );
}

// ─────────────────────────────── Bank Facilities

const FACILITIES = "/cash-banks/facilities";

export function getBankFacilities(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<BankFacilityList> {
  return apiGet<BankFacilityList>(withQuery(FACILITIES, { ...filter }), options);
}

/** One facility with its two account sides resolved and its expense lines. */
export function getBankFacility(id: string, options: EndpointOptions = {}): Promise<BankFacility> {
  return apiGet<BankFacility>(`${FACILITIES}/${id}`, options);
}

/** Creates when `id` is absent, amends when present. */
export function saveBankFacility(
  input: SaveBankFacilityInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(FACILITIES, { ...options, method: "PUT", body: input });
}

export function setBankFacilityActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${FACILITIES}/${id}/active`, { isActive }), undefined, options);
}

export function saveFacilityExpense(
  facilityId: string,
  input: SaveFacilityExpenseInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FACILITIES}/${facilityId}/expenses`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function deleteFacilityExpense(
  expenseId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FACILITIES}/expenses/${expenseId}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Cashboxes

const CASHBOXES = "/cash-banks/cashboxes";

/** The cashbox tree, flat with each node's depth. */
/**
 * `activeOnly` filters the cashbox's own flag — the maintenance screen's filter.
 * `openOnly` returns only what may be chosen today: open and active all the way up.
 */
export function getCashboxTree(
  filter: { search?: string; activeOnly?: boolean; openOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CashboxTreeNode[]> {
  return apiGet<CashboxTreeNode[]>(withQuery(CASHBOXES, { ...filter }), options);
}

/** One cashbox with its six account links resolved. */
export function getCashbox(id: string, options: EndpointOptions = {}): Promise<Cashbox> {
  return apiGet<Cashbox>(`${CASHBOXES}/${id}`, options);
}

export function createCashbox(
  input: SaveCashboxInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(CASHBOXES, input, options);
}

export function updateCashbox(
  id: string,
  input: SaveCashboxInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${CASHBOXES}/${id}`, { ...options, method: "PUT", body: input });
}

export function setCashboxActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${CASHBOXES}/${id}/active`, { isActive }), undefined, options);
}

export function deleteCashbox(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${CASHBOXES}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Account Types

const ACCOUNT_TYPES = "/accounting/account-types";

export function getAccountTypes(
  options: EndpointOptions & { search?: string; activeOnly?: boolean } = {},
): Promise<AccountTypeList> {
  const { search, activeOnly, ...rest } = options;
  return apiGet<AccountTypeList>(withQuery(ACCOUNT_TYPES, { search, activeOnly }), rest);
}

export function createAccountType(
  input: SaveAccountTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(ACCOUNT_TYPES, input, options);
}

export function updateAccountType(
  id: string,
  input: SaveAccountTypeInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${ACCOUNT_TYPES}/${id}`, { ...options, method: "PUT", body: input });
}

export function setAccountTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${ACCOUNT_TYPES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

/** Removes a type nothing uses. Refused by the server once an account points at it. */
export function deleteAccountType(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${ACCOUNT_TYPES}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Account Categories

const ACCOUNT_CATEGORIES = "/accounting/account-categories";

export function getAccountCategoryCatalogue(
  options: EndpointOptions & { search?: string; activeOnly?: boolean } = {},
): Promise<AccountCategoryList> {
  const { search, activeOnly, ...rest } = options;
  return apiGet<AccountCategoryList>(withQuery(ACCOUNT_CATEGORIES, { search, activeOnly }), rest);
}

export function createAccountCategory(
  input: SaveAccountCategoryInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(ACCOUNT_CATEGORIES, input, options);
}

export function updateAccountCategory(
  id: string,
  input: SaveAccountCategoryInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${ACCOUNT_CATEGORIES}/${id}`, { ...options, method: "PUT", body: input });
}

export function setAccountCategoryActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${ACCOUNT_CATEGORIES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

/** Removes a category nothing uses. Refused by the server once an account carries it. */
export function deleteAccountCategory(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${ACCOUNT_CATEGORIES}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────── Freeze Transactions

const FREEZE_TRANSACTIONS = "/accounting/freeze-transactions";

export function getTransactionFreezes(
  options: EndpointOptions & { search?: string; isActive?: boolean } = {},
): Promise<TransactionFreezeList> {
  const { search, isActive, ...rest } = options;
  return apiGet<TransactionFreezeList>(withQuery(FREEZE_TRANSACTIONS, { search, isActive }), rest);
}

/** Branches this company offers — owned by this module, not borrowed from Financial Links. */
export function getFreezeBranches(options: EndpointOptions = {}): Promise<FreezeMember[]> {
  return apiGet<FreezeMember[]>(`${FREEZE_TRANSACTIONS}/branches`, options);
}

export function getFreezeVoucherTypes(options: EndpointOptions = {}): Promise<FreezeMember[]> {
  return apiGet<FreezeMember[]>(`${FREEZE_TRANSACTIONS}/voucher-types`, options);
}

export function saveTransactionFreeze(
  input: SaveTransactionFreezeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(FREEZE_TRANSACTIONS, { ...options, method: "PUT", body: input });
}

export function setTransactionFreezeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FREEZE_TRANSACTIONS}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

// ─────────────────────────────── Financial Statement Lines

/** Nested under the statement: a line has no life apart from the statement that owns it. */
export function getFinancialStatementLines(
  definitionId: string,
  options: EndpointOptions & { search?: string } = {},
): Promise<FinancialStatementLine[]> {
  const { search, ...rest } = options;
  return apiGet<FinancialStatementLine[]>(
    withQuery(`${FINANCIAL_STATEMENTS}/${definitionId}/lines`, { search }),
    rest,
  );
}

export function saveFinancialStatementLine(
  definitionId: string,
  input: SaveFinancialStatementLineInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FINANCIAL_STATEMENTS}/${definitionId}/lines`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

/** A line with children needs `deleteSubtree` — the server refuses otherwise. */
export function deleteFinancialStatementLine(
  lineId: string,
  deleteSubtree: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${FINANCIAL_STATEMENTS}/lines/${lineId}`, { deleteSubtree }),
    { ...options, method: "DELETE" },
  );
}

export function moveFinancialStatementLine(
  lineId: string,
  up: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FINANCIAL_STATEMENTS}/lines/${lineId}/move`, { up }), {
    ...options,
    method: "POST",
  });
}

// ─────────────────────────────── Business Partners (Customers · Suppliers)

const BUSINESS_PARTNERS = "/accounting/business-partners";
const PARTNER_LOOKUPS = "/accounting/partner-lookups";

/**
 * The partner list.
 *
 * `selectableOnly` is what a picker asks for: active AND not blacklisted. The management screen
 * never sends it — a card you cannot see is a card you cannot reinstate.
 */
export function getBusinessPartners(
  filter: { search?: string; partnerType?: RelatedPartyType; selectableOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<BusinessPartnerList> {
  return apiGet<BusinessPartnerList>(withQuery(BUSINESS_PARTNERS, { ...filter }), options);
}

export function getBusinessPartner(
  id: string,
  options: EndpointOptions = {},
): Promise<BusinessPartner> {
  return apiGet<BusinessPartner>(`${BUSINESS_PARTNERS}/${id}`, options);
}

export function saveBusinessPartner(
  input: SaveBusinessPartnerInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(BUSINESS_PARTNERS, { ...options, method: "PUT", body: input });
}

/**
 * Removes a partner card for good — refused by the server while anything names it.
 *
 * Deactivation above is the normal answer and stays that way; this exists for the card typed by
 * mistake, which the register previously had no way to take back.
 */
export function deleteBusinessPartner(id: string, options: EndpointOptions = {}) {
  return request<void>(`${BUSINESS_PARTNERS}/${id}`, { ...options, method: "DELETE" });
}

/** Withdraws a partner from new use, or returns them. Never a deletion. */
export function setBusinessPartnerActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${BUSINESS_PARTNERS}/${id}/active`, { isActive }), undefined, options);
}

export function getBusinessPartnerAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<BusinessPartnerAuditEntry[]> {
  return apiGet<BusinessPartnerAuditEntry[]>(`${BUSINESS_PARTNERS}/${id}/audit-history`, options);
}

/** The people a card may name — the existing users, active ones only. */
export function getPartnerStaff(
  search?: string,
  options: EndpointOptions = {},
): Promise<PartnerStaff[]> {
  return apiGet<PartnerStaff[]>(withQuery(`${BUSINESS_PARTNERS}/staff`, { search }), options);
}

/**
 * The printed list, fetched with the bearer token rather than opened as a URL: the API is
 * JWT-only, so a plain window.open would arrive without the header and be refused.
 */
export function fetchBusinessPartnersPrint(
  filter: {
    search?: string;
    partnerType?: RelatedPartyType;
    selectableOnly?: boolean;
    locale?: string;
    forPrinting?: boolean;
  } = {},
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${BUSINESS_PARTNERS}/export/pdf`, { ...filter }),
    "partners.pdf",
    options,
  );
}

/** One route for all eleven vocabularies; `lookupType` picks which. Omit it to read them all. */
export function getPartnerLookups(
  filter: { lookupType?: PartnerLookupType; search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<PartnerLookupList> {
  return apiGet<PartnerLookupList>(withQuery(PARTNER_LOOKUPS, { ...filter }), options);
}

export function savePartnerLookup(
  input: SavePartnerLookupInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PARTNER_LOOKUPS, { ...options, method: "PUT", body: input });
}

export function setPartnerLookupActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${PARTNER_LOOKUPS}/${id}/active`, { isActive }), undefined, options);
}

// ─────────────────────────────── Receivables System Settings

const RECEIVABLES_SETTINGS = "/accounting/receivables-settings";

export function getReceivablesSettings(
  options: EndpointOptions = {},
): Promise<ReceivablesSettings> {
  return apiGet<ReceivablesSettings>(RECEIVABLES_SETTINGS, options);
}

/** Saves every setting at once — one row, one write, never a partial save. */
export function saveReceivablesSettings(
  input: SaveReceivablesSettingsInput,
  options: EndpointOptions = {},
): Promise<ReceivablesSettings> {
  return request<ReceivablesSettings>(RECEIVABLES_SETTINGS, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function restoreReceivablesSettingsDefaults(
  options: EndpointOptions = {},
): Promise<ReceivablesSettings> {
  return apiPost<ReceivablesSettings>(`${RECEIVABLES_SETTINGS}/restore-defaults`, undefined, options);
}

export function getReceivablesSettingsAuditHistory(
  options: EndpointOptions = {},
): Promise<ReceivablesSettingsAuditEntry[]> {
  return apiGet<ReceivablesSettingsAuditEntry[]>(`${RECEIVABLES_SETTINGS}/audit-history`, options);
}

// ─────────────────────────────── Workflow Actions

const WORKFLOW_ACTIONS = "/accounting/workflow-actions";

/**
 * The defined steps.
 *
 * `activeOnly` is what a future assignment screen asks for. The management screen never sends it:
 * a step you cannot see is a step you cannot reinstate.
 */
export function getWorkflowActions(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<WorkflowActionList> {
  return apiGet<WorkflowActionList>(withQuery(WORKFLOW_ACTIONS, { ...filter }), options);
}

export function saveWorkflowAction(
  input: SaveWorkflowActionInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(WORKFLOW_ACTIONS, { ...options, method: "PUT", body: input });
}

/** Withdraws a step from new use, or returns it. There is no delete. */
export function setWorkflowActionActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${WORKFLOW_ACTIONS}/${id}/active`, { isActive }), undefined, options);
}

export function getWorkflowActionAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<WorkflowActionAuditEntry[]> {
  return apiGet<WorkflowActionAuditEntry[]>(`${WORKFLOW_ACTIONS}/${id}/audit-history`, options);
}

// ─────────────────────────────── Customer Opening Balances

const CUSTOMER_OPENING_BALANCES = "/accounting/customer-opening-balances";

/** The sheet for one classification: every eligible customer, plus totals over the filtered set. */
export function getCustomerOpeningBalanceSheet(
  filter: {
    balanceType: CustomerOpeningBalanceType;
    fiscalYearId?: string;
    categoryId?: string;
    currencyId?: string;
    status?: OpeningBalanceRowStatus;
    search?: string;
  },
  options: EndpointOptions = {},
): Promise<CustomerOpeningBalanceSheet> {
  return apiGet<CustomerOpeningBalanceSheet>(
    withQuery(CUSTOMER_OPENING_BALANCES, { ...filter }),
    options,
  );
}

interface CustomerOpeningBalanceExportFilter {
  balanceType: CustomerOpeningBalanceType;
  fiscalYearId?: string;
  categoryId?: string;
  currencyId?: string;
  status?: OpeningBalanceRowStatus;
  search?: string;
  locale?: string;
  forPrinting?: boolean;
}

/**
 * The printed sheet, fetched with the bearer token rather than opened as a URL: the API is
 * JWT-only, so a plain window.open would arrive without the header and be refused.
 */
export function fetchCustomerOpeningBalancesFile(
  format: "pdf" | "excel",
  filter: CustomerOpeningBalanceExportFilter,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${CUSTOMER_OPENING_BALANCES}/export/${format}`, { ...filter }),
    format === "pdf" ? "customer-opening-balances.pdf" : "customer-opening-balances.xlsx",
    options,
  );
}

/** Declares balances. All-or-nothing: a rejection saves nothing. */
export function saveCustomerOpeningBalances(
  input: SaveCustomerOpeningBalancesInput,
  options: EndpointOptions = {},
): Promise<SaveCustomerOpeningBalancesResult> {
  return request<SaveCustomerOpeningBalancesResult>(CUSTOMER_OPENING_BALANCES, {
    ...options,
    method: "PUT",
    body: input,
  });
}

// ─────────────────────────────── Service Sales Types

const SERVICE_SALES_TYPES = "/accounting/service-sales-types";

export function getServiceSalesTypes(
  options: EndpointOptions & { search?: string; activeOnly?: boolean } = {},
): Promise<ServiceSalesTypeList> {
  const { search, activeOnly, ...rest } = options;
  return apiGet<ServiceSalesTypeList>(
    withQuery(SERVICE_SALES_TYPES, { search, activeOnly }),
    rest,
  );
}

/**
 * The controlled lookup a future sales or service document picks from: active types only, each
 * carrying the account, taxable flag and tax type the document defaults to.
 */
export function getServiceSalesTypeLookup(
  options: EndpointOptions & { search?: string } = {},
): Promise<ServiceSalesTypeLookupRow[]> {
  const { search, ...rest } = options;
  return apiGet<ServiceSalesTypeLookupRow[]>(
    withQuery(`${SERVICE_SALES_TYPES}/lookup`, { search }),
    rest,
  );
}

/** Creates when the input carries no id, updates when it does. Returns the row's id either way. */
export function saveServiceSalesType(
  input: SaveServiceSalesTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_SALES_TYPES, { ...options, method: "PUT", body: input });
}

/** Withdraws a type from new use, or returns it. The only removal the server offers. */
export function setServiceSalesTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${SERVICE_SALES_TYPES}/${id}/active`, { isActive }), {
    ...options,
    method: "POST",
  });
}

export function getServiceSalesTypeAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<ServiceSalesTypeAuditEntry[]> {
  return apiGet<ServiceSalesTypeAuditEntry[]>(`${SERVICE_SALES_TYPES}/${id}/audit-history`, options);
}

// ─────────────────────────────── Discount Types

const DISCOUNT_TYPES = "/accounting/discount-types";

/** `activeOnly` is what a future transaction picker asks for; the settings screen never sends it. */
export function getDiscountTypes(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<DiscountTypeList> {
  return apiGet<DiscountTypeList>(withQuery(DISCOUNT_TYPES, { ...filter }), options);
}

export function saveDiscountType(
  input: SaveDiscountTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(DISCOUNT_TYPES, { ...options, method: "PUT", body: input });
}

/** Withdraws a discount type from new use, or returns it. There is no delete. */
export function setDiscountTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${DISCOUNT_TYPES}/${id}/active`, { isActive }), undefined, options);
}

export function getDiscountTypeAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<DiscountTypeAuditEntry[]> {
  return apiGet<DiscountTypeAuditEntry[]>(`${DISCOUNT_TYPES}/${id}/audit-history`, options);
}

// ─────────────────────────────── Electronic Payment Policy

const PAYMENT_CARD_TYPES = "/accounting/payment-card-types";
const PAYMENT_CARD_POLICIES = "/accounting/payment-card-commission-policies";

export function getPaymentCardTypes(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<PaymentCardTypeList> {
  return apiGet<PaymentCardTypeList>(withQuery(PAYMENT_CARD_TYPES, { ...filter }), options);
}

export function savePaymentCardType(
  input: SavePaymentCardTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_CARD_TYPES, { ...options, method: "PUT", body: input });
}

/** Withdraws a card type from new use, or returns it. There is no delete. */
export function setPaymentCardTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${PAYMENT_CARD_TYPES}/${id}/active`, { isActive }), undefined, options);
}

export function getPaymentCardCommissionPolicies(
  filter: { paymentCardTypeId?: string; branchId?: string } = {},
  options: EndpointOptions = {},
): Promise<PaymentCardCommissionPolicyList> {
  return apiGet<PaymentCardCommissionPolicyList>(
    withQuery(PAYMENT_CARD_POLICIES, { ...filter }), options);
}

/** Saves a policy and its whole set of ranges. The ranges are replaced, not merged. */
export function savePaymentCardCommissionPolicy(
  input: SavePaymentCardCommissionPolicyInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_CARD_POLICIES, { ...options, method: "PUT", body: input });
}

// ─────────────────────────────── SMS Reminder Settings

const SMS_REMINDER_SETTINGS = "/accounting/sms-reminder-settings";

export function getSmsReminderSettings(
  options: EndpointOptions = {},
): Promise<SmsReminderSettings> {
  return apiGet<SmsReminderSettings>(SMS_REMINDER_SETTINGS, options);
}

/** Updates the SAME company row — it never creates a second. */
export function saveSmsReminderSettings(
  input: SaveSmsReminderSettingsInput,
  options: EndpointOptions = {},
): Promise<SmsReminderSettings> {
  return request<SmsReminderSettings>(SMS_REMINDER_SETTINGS, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function restoreSmsReminderSettingsDefaults(
  options: EndpointOptions = {},
): Promise<SmsReminderSettings> {
  return apiPost<SmsReminderSettings>(`${SMS_REMINDER_SETTINGS}/restore-defaults`, undefined, options);
}

export function getSmsReminderSettingsAuditHistory(
  options: EndpointOptions = {},
): Promise<SmsReminderSettingsAuditEntry[]> {
  return apiGet<SmsReminderSettingsAuditEntry[]>(`${SMS_REMINDER_SETTINGS}/audit-history`, options);
}

// ─────────────────────────────── User-Partner Access (Customers · Suppliers)

/**
 * Two routes over ONE engine. The party type is fixed by the route rather than sent in the
 * payload, so a customer administrator cannot reach a supplier grant by posting its id.
 */
const USER_SUPPLIER_ACCESS = "/accounting/user-supplier-access";
const USER_CUSTOMER_ACCESS = "/accounting/user-customer-access";

/** Suppliers are party type 2, customers 1; this picks the matching route. */
function accessBase(partyType: RelatedPartyType): string {
  return partyType === RELATED_PARTY_TYPE.Customer ? USER_CUSTOMER_ACCESS : USER_SUPPLIER_ACCESS;
}

/** The three grids for one user, on one side of the ledger. */
export function getUserPartnerAccess(
  partyType: RelatedPartyType,
  userId: string,
  options: EndpointOptions = {},
): Promise<UserPartnerAccess> {
  return apiGet<UserPartnerAccess>(withQuery(accessBase(partyType), { userId }), options);
}

/** Partners still assignable to this user at this level: active, and not already granted. */
export function getAssignablePartners(
  partyType: RelatedPartyType,
  filter: { userId: string; scope: SupplierAccessScopeValue; search?: string },
  options: EndpointOptions = {},
): Promise<AssignablePartner[]> {
  return apiGet<AssignablePartner[]>(
    withQuery(`${accessBase(partyType)}/assignable-partners`, { ...filter }),
    options,
  );
}

/** Adds ONE partner at ONE level. Never touches the other two. */
export function grantUserPartnerAccess(
  partyType: RelatedPartyType,
  input: { userId: string; partnerId: string; scope: SupplierAccessScopeValue },
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(accessBase(partyType), { ...options, method: "POST", body: input });
}

/** Suspends or restores one mapping, keeping it on the record. */
export function setUserPartnerAccessActive(
  partyType: RelatedPartyType,
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${accessBase(partyType)}/${id}/active`, { isActive }),
    undefined,
    options,
  );
}

/** Withdraws one mapping. Soft-deleted server-side, so the grant stays auditable. */
export function revokeUserPartnerAccess(
  partyType: RelatedPartyType,
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${accessBase(partyType)}/${id}`, { ...options, method: "DELETE" });
}

export function getUserPartnerAccessAuditHistory(
  partyType: RelatedPartyType,
  userId: string,
  options: EndpointOptions = {},
): Promise<UserPartnerAccessAuditEntry[]> {
  return apiGet<UserPartnerAccessAuditEntry[]>(
    withQuery(`${accessBase(partyType)}/audit-history`, { userId }),
    options,
  );
}

// ─────────────────────────────── Countries & Regions

const COUNTRY_REGIONS = "/accounting/country-regions";

/** The whole tree, depth-first. `activeOnly` is what a picker asks for. */
export function getCountryRegions(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CountryRegionTree> {
  return apiGet<CountryRegionTree>(withQuery(COUNTRY_REGIONS, { ...filter }), options);
}

export function saveCountryRegion(
  input: SaveCountryRegionInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(COUNTRY_REGIONS, { ...options, method: "PUT", body: input });
}

/** Withdraws a country or region from new use, or returns it. There is no delete. */
export function setCountryRegionActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${COUNTRY_REGIONS}/${id}/active`, { isActive }), undefined, options);
}

/** The platform's IANA zones — the same list the save validates against. */
export function getTimeZoneOptions(options: EndpointOptions = {}): Promise<TimeZoneOption[]> {
  return apiGet<TimeZoneOption[]>(`${COUNTRY_REGIONS}/time-zones`, options);
}

export function getCountryRegionAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<CountryRegionAuditEntry[]> {
  return apiGet<CountryRegionAuditEntry[]>(`${COUNTRY_REGIONS}/${id}/audit-history`, options);
}

/**
 * Uploads or replaces a flag.
 *
 * Sent as multipart through the shared request helper so it carries the JWT and the company
 * header like every other call — a bare fetch would 401.
 */
export function uploadCountryRegionFlag(
  id: string,
  file: File,
  options: EndpointOptions = {},
): Promise<CountryRegion> {
  const body = new FormData();
  body.append("file", file);

  return request<CountryRegion>(`${COUNTRY_REGIONS}/${id}/flag`, {
    ...options,
    method: "POST",
    body,
  });
}

export function removeCountryRegionFlag(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${COUNTRY_REGIONS}/${id}/flag`, { ...options, method: "DELETE" });
}

/**
 * Fetches a flag as a blob URL for the preview.
 *
 * The API is JWT-only, so an <img src="…/flag"> would 401 — the browser sends no Authorization
 * header on an image request. The bytes are fetched through the authenticated client and handed
 * to the DOM as an object URL instead.
 */
export function getCountryRegionFlagUrl(
  id: string,
  options: EndpointOptions = {},
): Promise<string> {
  return requestFile(`${COUNTRY_REGIONS}/${id}/flag`, "flag", options).then((file) =>
    URL.createObjectURL(file.blob),
  );
}

// ─────────────────────────────── Custody Categories

const CUSTODY_CATEGORIES = "/accounting/custody-categories";

/** `activeOnly` is what a future custody screen asks for; the settings screen never sends it. */
export function getCustodyCategories(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CustodyCategoryList> {
  return apiGet<CustodyCategoryList>(withQuery(CUSTODY_CATEGORIES, { ...filter }), options);
}

export function saveCustodyCategory(
  input: SaveCustodyCategoryInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(CUSTODY_CATEGORIES, { ...options, method: "PUT", body: input });
}

/** Withdraws a category from new use, or returns it. There is no delete. */
export function setCustodyCategoryActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${CUSTODY_CATEGORIES}/${id}/active`, { isActive }),
    undefined,
    options,
  );
}

// ── Payments › Daily Transactions › أمر صرف + سند صرف ──────────────────────────────────────
const PAYMENT_ORDERS = "/accounting/payment-orders";
const PAYMENT_VOUCHERS = "/accounting/payment-vouchers";

export function getPaymentOrders(
  filter: { dateFrom?: string; dateTo?: string; supplierId?: string; status?: number;
            payableOnly?: boolean; search?: string } = {},
  options: EndpointOptions = {},
): Promise<PaymentOrderList> {
  return apiGet<PaymentOrderList>(withQuery(PAYMENT_ORDERS, { ...filter }), options);
}

export function getPaymentOrder(id: string, options: EndpointOptions = {}): Promise<PaymentOrder> {
  return apiGet<PaymentOrder>(`${PAYMENT_ORDERS}/${id}`, options);
}

export function savePaymentOrder(
  input: SavePaymentOrderInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_ORDERS, { ...options, method: "PUT", body: input });
}

export function cancelPaymentOrder(
  id: string, reason: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PAYMENT_ORDERS}/${id}/cancel`, { reason }, options);
}

export function getPaymentVouchers(
  filter: { dateFrom?: string; dateTo?: string; supplierId?: string; paymentOrderId?: string;
            status?: number; search?: string } = {},
  options: EndpointOptions = {},
): Promise<PaymentVoucherList> {
  return apiGet<PaymentVoucherList>(withQuery(PAYMENT_VOUCHERS, { ...filter }), options);
}

export function getPaymentVoucher(
  id: string, options: EndpointOptions = {},
): Promise<PaymentVoucher> {
  return apiGet<PaymentVoucher>(`${PAYMENT_VOUCHERS}/${id}`, options);
}

/**
 * تسديد الفواتير - the supplier's still-open documents, for the settlement picker.
 *
 * Guarded by the payment voucher's own permission and the supplier's daily-transaction scope,
 * so it can never offer an invoice the screen itself could not reach.
 */
export function getPayableOpenInvoices(
  filter: { supplierId: string; currencyId?: string },
  options: EndpointOptions = {},
): Promise<PayableOpenInvoices> {
  return apiGet<PayableOpenInvoices>(
    withQuery(`${PAYMENT_VOUCHERS}/open-invoices`, { ...filter }), options);
}

export function savePaymentVoucher(
  input: SavePaymentVoucherInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_VOUCHERS, { ...options, method: "PUT", body: input });
}

export function auditPaymentVoucher(
  id: string, auditNotes: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PAYMENT_VOUCHERS}/${id}/audit`, { auditNotes }, options);
}

export function postPaymentVoucher(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${PAYMENT_VOUCHERS}/${id}/post`, {}, options);
}

export function reversePaymentVoucher(
  id: string, reversalDate: string, reason: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PAYMENT_VOUCHERS}/${id}/reverse`, { reversalDate, reason }, options);
}

/** The rendered payment voucher, fetched WITH the session's auth - never a bare link to the API. */
export function fetchPaymentVoucherFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${PAYMENT_VOUCHERS}/${id}/${format}`, { locale }),
    format === "pdf" ? "payment.pdf" : "payment.xlsx",
    options,
  );
}

// ─────────────────────────────── Supplier Debit Note (إشعار مدين للمورّد)

const SUPPLIER_DEBIT_NOTES = "/accounting/supplier-debit-notes";

export function getSupplierDebitNotes(
  filter: {
    searchTerm?: string; supplierId?: string; status?: number;
    currencyId?: string; fromDate?: string; toDate?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<SupplierDebitNoteList> {
  return apiGet<SupplierDebitNoteList>(withQuery(SUPPLIER_DEBIT_NOTES, { ...filter }), options);
}

export function getSupplierDebitNote(
  id: string,
  options: EndpointOptions = {},
): Promise<SupplierDebitNote> {
  return apiGet<SupplierDebitNote>(`${SUPPLIER_DEBIT_NOTES}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveSupplierDebitNote(
  input: SaveSupplierDebitNoteInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SUPPLIER_DEBIT_NOTES, { ...options, method: "PUT", body: input });
}

export function auditSupplierDebitNote(
  id: string,
  auditNotes?: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_DEBIT_NOTES}/${id}/audit`, { auditNotes }, options);
}

export function postSupplierDebitNote(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_DEBIT_NOTES}/${id}/post`, undefined, options);
}

export function reverseSupplierDebitNote(
  id: string,
  reversalDate?: string | null,
  reason?: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SUPPLIER_DEBIT_NOTES}/${id}/reverse`, { reversalDate, reason }, options);
}

/** The rendered note, fetched WITH the session's auth - never a bare link to the API. */
export function fetchSupplierDebitNoteFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SUPPLIER_DEBIT_NOTES}/${id}/${format}`, { locale }),
    format === "pdf" ? "supplier-debit-note.pdf" : "supplier-debit-note.xlsx",
    options,
  );
}

// ─────────────────────────────── Supplier Credit Note (إشعار دائن للمورّد)

const SUPPLIER_CREDIT_NOTES = "/accounting/supplier-credit-notes";

export function getSupplierCreditNotes(
  filter: {
    searchTerm?: string; supplierId?: string; status?: number;
    currencyId?: string; fromDate?: string; toDate?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<SupplierCreditNoteList> {
  return apiGet<SupplierCreditNoteList>(withQuery(SUPPLIER_CREDIT_NOTES, { ...filter }), options);
}

export function getSupplierCreditNote(
  id: string,
  options: EndpointOptions = {},
): Promise<SupplierCreditNote> {
  return apiGet<SupplierCreditNote>(`${SUPPLIER_CREDIT_NOTES}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveSupplierCreditNote(
  input: SaveSupplierCreditNoteInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SUPPLIER_CREDIT_NOTES, { ...options, method: "PUT", body: input });
}

export function auditSupplierCreditNote(
  id: string,
  auditNotes?: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_CREDIT_NOTES}/${id}/audit`, { auditNotes }, options);
}

export function postSupplierCreditNote(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_CREDIT_NOTES}/${id}/post`, undefined, options);
}

export function reverseSupplierCreditNote(
  id: string,
  reversalDate?: string | null,
  reason?: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SUPPLIER_CREDIT_NOTES}/${id}/reverse`, { reversalDate, reason }, options);
}

/** The rendered note, fetched WITH the session's auth - never a bare link to the API. */
export function fetchSupplierCreditNoteFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SUPPLIER_CREDIT_NOTES}/${id}/${format}`, { locale }),
    format === "pdf" ? "supplier-credit-note.pdf" : "supplier-credit-note.xlsx",
    options,
  );
}

// ── Payments › Daily Transactions › دفاتر الصرف ────────────────────────────────────────────
const PAYMENT_BOOKS = "/accounting/payment-books";

export function getPaymentBooks(
  filter: { search?: string; status?: number; branchId?: string; holderId?: string } = {},
  options: EndpointOptions = {},
): Promise<PaymentBookList> {
  return apiGet<PaymentBookList>(withQuery(PAYMENT_BOOKS, { ...filter }), options);
}

export function getPaymentBook(
  id: string, options: EndpointOptions = {},
): Promise<PaymentBook> {
  return apiGet<PaymentBook>(`${PAYMENT_BOOKS}/${id}`, options);
}

export function savePaymentBook(
  input: SavePaymentBookInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PAYMENT_BOOKS, { ...options, method: "PUT", body: input });
}

/** Hand over, take back, or withdraw. Each writes one immutable movement row. */
export function movePaymentBook(
  id: string,
  body: { action: PaymentBookAction; holderId: string | null; movementDate: string; notes: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PAYMENT_BOOKS}/${id}/movements`, body, options);
}

// ── Payments › Daily Transactions › مردود شراء خدمات ───────────────────────────────────────
const SERVICE_PURCHASE_RETURNS = "/accounting/service-purchase-returns";

export function getServicePurchaseReturns(
  filter: { dateFrom?: string; dateTo?: string; supplierId?: string; sourceInvoiceId?: string;
            status?: number; search?: string } = {},
  options: EndpointOptions = {},
): Promise<ServicePurchaseReturnList> {
  return apiGet<ServicePurchaseReturnList>(
    withQuery(SERVICE_PURCHASE_RETURNS, { ...filter }), options);
}

export function getServicePurchaseReturn(
  id: string, options: EndpointOptions = {},
): Promise<ServicePurchaseReturn> {
  return apiGet<ServicePurchaseReturn>(`${SERVICE_PURCHASE_RETURNS}/${id}`, options);
}

/** What is still returnable on each line — derived from POSTED returns, never stamped. */
export function getServicePurchaseReturnAvailability(
  invoiceId: string, excludeReturnId?: string, options: EndpointOptions = {},
): Promise<ServicePurchaseReturnAvailability> {
  return apiGet<ServicePurchaseReturnAvailability>(
    withQuery(`${SERVICE_PURCHASE_RETURNS}/availability/${invoiceId}`, { excludeReturnId }),
    options);
}

export function saveServicePurchaseReturn(
  input: SaveServicePurchaseReturnInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_PURCHASE_RETURNS, { ...options, method: "PUT", body: input });
}

export function auditServicePurchaseReturn(
  id: string, auditNotes: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_PURCHASE_RETURNS}/${id}/audit`, { auditNotes }, options);
}

export function postServicePurchaseReturn(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_PURCHASE_RETURNS}/${id}/post`, {}, options);
}

/** The return as a file. The server re-loads the document; the screen's rows never travel. */
export function servicePurchaseReturnExportUrl(
  id: string, format: "pdf" | "excel", locale: string, forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${SERVICE_PURCHASE_RETURNS}/${id}/${format}`, {
    locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

/** Reversing also restores what the return had made unavailable. */
export function reverseServicePurchaseReturn(
  id: string, reversalDate: string, reason: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SERVICE_PURCHASE_RETURNS}/${id}/reverse`, { reversalDate, reason }, options);
}

// ── Payments › Daily Transactions › فاتورة شراء خدمات ──────────────────────────────────────
//
// An accounting document. Audit, post and reverse are the JOURNAL VOUCHER's verbs, served here
// rather than re-implemented; there is no delete, because a posted invoice is reversed.
const SERVICE_PURCHASE_INVOICES = "/accounting/service-purchase-invoices";

export function getServicePurchaseInvoices(
  filter: {
    dateFrom?: string; dateTo?: string; supplierId?: string; status?: number;
    search?: string; page?: number; pageSize?: number;
  } = {},
  options: EndpointOptions = {},
): Promise<ServicePurchaseInvoiceList> {
  return apiGet<ServicePurchaseInvoiceList>(
    withQuery(SERVICE_PURCHASE_INVOICES, { ...filter }), options);
}

export function getServicePurchaseInvoice(
  id: string, options: EndpointOptions = {},
): Promise<ServicePurchaseInvoice> {
  return apiGet<ServicePurchaseInvoice>(`${SERVICE_PURCHASE_INVOICES}/${id}`, options);
}

export function saveServicePurchaseInvoice(
  input: SaveServicePurchaseInvoiceInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_PURCHASE_INVOICES, { ...options, method: "PUT", body: input });
}

/** Approves the figures. Whoever entered the voucher may not approve it. */
export function auditServicePurchaseInvoice(
  id: string, auditNotes: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_PURCHASE_INVOICES}/${id}/audit`, { auditNotes }, options);
}

/** Puts an audited invoice into the ledger, through the posting service alone. */
export function postServicePurchaseInvoice(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_PURCHASE_INVOICES}/${id}/post`, {}, options);
}

/** The invoice as a file. The server re-loads the document; the screen's rows never travel. */
export function servicePurchaseInvoiceExportUrl(
  id: string,
  format: "pdf" | "excel",
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${SERVICE_PURCHASE_INVOICES}/${id}/${format}`, {
    locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

/** Reverses a posted invoice. The original is never edited or deleted. */
export function reverseServicePurchaseInvoice(
  id: string, reversalDate: string, reason: string | null, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SERVICE_PURCHASE_INVOICES}/${id}/reverse`, { reversalDate, reason }, options);
}

// ── Payments › Daily Transactions › طلب شراء خدمات ─────────────────────────────────────────
//
// A pre-accounting document. There is no audit and no post endpoint, because the document never
// reaches the ledger; withdrawing one cancels it.
const SERVICE_PURCHASE_REQUESTS = "/accounting/service-purchase-requests";

export function getServicePurchaseRequests(
  filter: {
    dateFrom?: string;
    dateTo?: string;
    supplierId?: string;
    branchId?: string;
    currencyId?: string;
    status?: number;
    search?: string;
    page?: number;
    pageSize?: number;
  } = {},
  options: EndpointOptions = {},
): Promise<ServicePurchaseRequestList> {
  return apiGet<ServicePurchaseRequestList>(
    withQuery(SERVICE_PURCHASE_REQUESTS, { ...filter }), options);
}

export function getServicePurchaseRequest(
  id: string,
  options: EndpointOptions = {},
): Promise<ServicePurchaseRequest> {
  return apiGet<ServicePurchaseRequest>(`${SERVICE_PURCHASE_REQUESTS}/${id}`, options);
}

export function saveServicePurchaseRequest(
  input: SaveServicePurchaseRequestInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_PURCHASE_REQUESTS, { ...options, method: "PUT", body: input });
}

/** Withdraws a request. There is no delete: the record of having raised it survives. */
export function cancelServicePurchaseRequest(
  id: string,
  reason: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_PURCHASE_REQUESTS}/${id}/cancel`, { reason }, options);
}

// ── Payments › Master Data › the four personnel lists ──────────────────────────────────────
//
// One endpoint set with a role on it, matching the server. The four screens differ in which
// role they pass and in nothing else.
const PERSONNEL = "/accounting/personnel";

export function getPersonnelRoles(
  filter: {
    roleType: PersonnelRoleType;
    search?: string;
    activeOnly?: boolean;
    branchId?: string;
    linkedToUser?: boolean;
  },
  options: EndpointOptions = {},
): Promise<PersonnelRoleList> {
  return apiGet<PersonnelRoleList>(withQuery(PERSONNEL, { ...filter }), options);
}

/** The users and branches a record may name, on this module's own right. */
export function getPersonnelOptions(options: EndpointOptions = {}): Promise<PersonnelOptions> {
  return apiGet<PersonnelOptions>(`${PERSONNEL}/options`, options);
}

export function savePersonnelRole(
  input: SavePersonnelRoleInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PERSONNEL, { ...options, method: "PUT", body: input });
}

/** Withdraws a person from new work, or returns them. There is no delete. */
export function setPersonnelRoleActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(withQuery(`${PERSONNEL}/${id}/active`, { isActive }), undefined, options);
}

export function getPersonnelRoleAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<PersonnelRoleAuditEntry[]> {
  return apiGet<PersonnelRoleAuditEntry[]>(`${PERSONNEL}/${id}/audit-history`, options);
}

export function getCustodyCategoryAuditHistory(
  id: string,
  options: EndpointOptions = {},
): Promise<CustodyCategoryAuditEntry[]> {
  return apiGet<CustodyCategoryAuditEntry[]>(`${CUSTODY_CATEGORIES}/${id}/audit-history`, options);
}

// ─────────────────────────────── Receivables Aging Periods

const AGING_PERIODS = "/accounting/aging-periods";

/** The whole definition, in sequence order. Ships empty until a company defines it. */
export function getReceivablesAgingPeriods(
  options: EndpointOptions = {},
): Promise<ReceivablesAgingPeriodList> {
  return apiGet<ReceivablesAgingPeriodList>(AGING_PERIODS, options);
}

export function saveReceivablesAgingPeriod(
  input: SaveReceivablesAgingPeriodInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(AGING_PERIODS, { ...options, method: "PUT", body: input });
}

/** Removes one period. Soft-deleted server-side, so the definition's history survives. */
export function deleteReceivablesAgingPeriod(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${AGING_PERIODS}/${id}`, { ...options, method: "DELETE" });
}

export function getReceivablesAgingPeriodAuditHistory(
  options: EndpointOptions = {},
): Promise<ReceivablesAgingPeriodAuditEntry[]> {
  return apiGet<ReceivablesAgingPeriodAuditEntry[]>(`${AGING_PERIODS}/audit-history`, options);
}

// ─────────────────────────────── Sales & Purchase Tax Types

const SALES_PURCHASE_TAX_TYPES = "/accounting/sales-purchase-tax-types";

/** The approved grid: one row per tax type, carrying the rate in force for it. */
export function getSalesPurchaseTaxTypes(
  filter: { search?: string; activeOnly?: boolean; category?: number } = {},
  options: EndpointOptions = {},
): Promise<SalesPurchaseTaxTypeList> {
  return apiGet<SalesPurchaseTaxTypeList>(
    withQuery(SALES_PURCHASE_TAX_TYPES, { ...filter }),
    options,
  );
}

/** Saves the tax type and its rate in one call. */
export function saveSalesPurchaseTaxType(
  input: SaveSalesPurchaseTaxTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SALES_PURCHASE_TAX_TYPES, { ...options, method: "PUT", body: input });
}

/** Withdraws a tax from new documents, or returns it. Sends the existing lifecycle command. */
export function setSalesPurchaseTaxTypeActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    withQuery(`${SALES_PURCHASE_TAX_TYPES}/${id}/active`, { isActive }),
    undefined,
    options,
  );
}

// ─────────────────────────────── Service Sales Quotations

const SERVICE_QUOTATIONS = "/accounting/service-quotations";

export function getServiceQuotations(
  filter: { search?: string; customerId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<ServiceQuotationList> {
  return apiGet<ServiceQuotationList>(withQuery(SERVICE_QUOTATIONS, { ...filter }), options);
}

export function getServiceQuotation(
  id: string,
  options: EndpointOptions = {},
): Promise<ServiceQuotation> {
  return apiGet<ServiceQuotation>(`${SERVICE_QUOTATIONS}/${id}`, options);
}

/** Creates or replaces a quotation. Writes nothing to the ledger — a quotation posts nothing. */
export function saveServiceQuotation(
  input: SaveServiceQuotationInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_QUOTATIONS, { ...options, method: "PUT", body: input });
}

/** Withdraws a quotation. Never a delete: the offer was made. */
export function cancelServiceQuotation(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_QUOTATIONS}/${id}/cancel`, undefined, options);
}

/**
 * The quotation as a document.
 *
 * Only a SAVED quotation can be rendered — the id is the proof it exists. Every figure on the
 * page is read back from the database, so what prints is what the document holds.
 */
export function fetchServiceQuotationFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SERVICE_QUOTATIONS}/${id}/${format}`, { locale }),
    format === "pdf" ? "quotation.pdf" : "quotation.xlsx",
    options,
  );
}

/** Attaches a file to a saved quotation. Multipart: the bytes stream, they do not inflate. */
export function uploadServiceQuotationAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<ServiceQuotationAttachment> {
  const form = new FormData();
  form.append("file", file);

  if (description) {
    form.append("description", description);
  }

  return request<ServiceQuotationAttachment>(`${SERVICE_QUOTATIONS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

/** The address of one stored attachment. Fetched with auth headers, never opened directly. */
export function serviceQuotationAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${SERVICE_QUOTATIONS}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteServiceQuotationAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SERVICE_QUOTATIONS}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Receipt Voucher (سند القبض) + Cheques

const RECEIPT_VOUCHERS = "/accounting/receipt-vouchers";
const CHEQUES = "/accounting/cheques";

export function getReceiptVouchers(
  filter: { search?: string; customerId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<ReceiptVoucherList> {
  return apiGet<ReceiptVoucherList>(withQuery(RECEIPT_VOUCHERS, { ...filter }), options);
}

export function getReceiptVoucher(
  id: string,
  options: EndpointOptions = {},
): Promise<ReceiptVoucher> {
  return apiGet<ReceiptVoucher>(`${RECEIPT_VOUCHERS}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveReceiptVoucher(
  input: SaveReceiptVoucherInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(RECEIPT_VOUCHERS, { ...options, method: "PUT", body: input });
}

export function auditReceiptVoucher(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_VOUCHERS}/${id}/audit`, { auditNotes }, options);
}

export function postReceiptVoucher(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${RECEIPT_VOUCHERS}/${id}/post`, undefined, options);
}

export function reverseReceiptVoucher(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_VOUCHERS}/${id}/reverse`, { reason }, options);
}

/** The rendered receipt, fetched WITH the session's auth - never a bare link to the API. */
export function fetchReceiptVoucherFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${RECEIPT_VOUCHERS}/${id}/${format}`, { locale }),
    format === "pdf" ? "receipt.pdf" : "receipt.xlsx",
    options,
  );
}

export function uploadReceiptVoucherAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<ReceiptVoucherAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<ReceiptVoucherAttachment>(`${RECEIPT_VOUCHERS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function receiptVoucherAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIPT_VOUCHERS}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteReceiptVoucherAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${RECEIPT_VOUCHERS}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

export function getCheques(
  filter: ChequeFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeList> {
  return apiGet<ChequeList>(withQuery(CHEQUES, { ...filter }), options);
}

/** مودع للتحصيل — operational only; the API takes no bank account at this stage. */
export function depositCheque(
  id: string,
  notes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUES}/${id}/deposit`, { notes }, options);
}

export function clearCheque(
  id: string,
  input: { bankAccountId: string; clearedDate?: string; notes?: string },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUES}/${id}/clear`, input, options);
}

export function bounceCheque(
  id: string,
  notes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUES}/${id}/bounce`, { notes }, options);
}

export function returnCheque(
  id: string,
  notes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUES}/${id}/return`, { notes }, options);
}

// ─────────────────────────────── Debit Note (إشعار مدين)

const DEBIT_NOTES = "/accounting/debit-notes";

export function getDebitNotes(
  filter: DebitNoteFilter = {},
  options: EndpointOptions = {},
): Promise<DebitNoteList> {
  return apiGet<DebitNoteList>(withQuery(DEBIT_NOTES, { ...filter }), options);
}

export function getDebitNote(id: string, options: EndpointOptions = {}): Promise<DebitNote> {
  return apiGet<DebitNote>(`${DEBIT_NOTES}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveDebitNote(
  input: SaveDebitNoteInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(DEBIT_NOTES, { ...options, method: "PUT", body: input });
}

export function auditDebitNote(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${DEBIT_NOTES}/${id}/audit`, { auditNotes }, options);
}

export function postDebitNote(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${DEBIT_NOTES}/${id}/post`, undefined, options);
}

export function reverseDebitNote(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${DEBIT_NOTES}/${id}/reverse`, { reason }, options);
}

/** The rendered note, fetched WITH the session's auth - never a bare link to the API. */
export function fetchDebitNoteFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${DEBIT_NOTES}/${id}/${format}`, { locale }),
    format === "pdf" ? "debit-note.pdf" : "debit-note.xlsx",
    options,
  );
}

export function uploadDebitNoteAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<DebitNoteAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<DebitNoteAttachment>(`${DEBIT_NOTES}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function debitNoteAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${DEBIT_NOTES}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteDebitNoteAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${DEBIT_NOTES}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Credit Note (إشعار دائن)

const CREDIT_NOTES = "/accounting/credit-notes";

export function getCreditNotes(
  filter: CreditNoteFilter = {},
  options: EndpointOptions = {},
): Promise<CreditNoteList> {
  return apiGet<CreditNoteList>(withQuery(CREDIT_NOTES, { ...filter }), options);
}

export function getCreditNote(id: string, options: EndpointOptions = {}): Promise<CreditNote> {
  return apiGet<CreditNote>(`${CREDIT_NOTES}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveCreditNote(
  input: SaveCreditNoteInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(CREDIT_NOTES, { ...options, method: "PUT", body: input });
}

export function auditCreditNote(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CREDIT_NOTES}/${id}/audit`, { auditNotes }, options);
}

export function postCreditNote(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${CREDIT_NOTES}/${id}/post`, undefined, options);
}

export function reverseCreditNote(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CREDIT_NOTES}/${id}/reverse`, { reason }, options);
}

/** The rendered note, fetched WITH the session's auth - never a bare link to the API. */
export function fetchCreditNoteFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${CREDIT_NOTES}/${id}/${format}`, { locale }),
    format === "pdf" ? "credit-note.pdf" : "credit-note.xlsx",
    options,
  );
}

export function uploadCreditNoteAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<CreditNoteAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<CreditNoteAttachment>(`${CREDIT_NOTES}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function creditNoteAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${CREDIT_NOTES}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteCreditNoteAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${CREDIT_NOTES}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Service Sales Return (مردود بيع خدمات)

const SERVICE_SALES_RETURNS = "/accounting/service-sales-returns";

/** Where the screen STARTS: the posted invoices a return may be raised against. */
export function getReturnableInvoices(
  filter: { search?: string; customerId?: string; includeFullyReturned?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ReturnableInvoiceList> {
  return apiGet<ReturnableInvoiceList>(
    withQuery(`${SERVICE_SALES_RETURNS}/returnable-invoices`, { ...filter }), options);
}

export function getServiceSalesReturns(
  filter: ServiceSalesReturnFilter = {},
  options: EndpointOptions = {},
): Promise<ServiceSalesReturnList> {
  return apiGet<ServiceSalesReturnList>(withQuery(SERVICE_SALES_RETURNS, { ...filter }), options);
}

export function getServiceSalesReturn(
  id: string,
  options: EndpointOptions = {},
): Promise<ServiceSalesReturn> {
  return apiGet<ServiceSalesReturn>(`${SERVICE_SALES_RETURNS}/${id}`, options);
}

export function saveServiceSalesReturn(
  input: SaveServiceSalesReturnInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_SALES_RETURNS, { ...options, method: "PUT", body: input });
}

export function auditServiceSalesReturn(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_RETURNS}/${id}/audit`, { auditNotes }, options);
}

export function postServiceSalesReturn(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_RETURNS}/${id}/post`, undefined, options);
}

export function reverseServiceSalesReturn(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_RETURNS}/${id}/reverse`, { reason }, options);
}

export function fetchServiceSalesReturnFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SERVICE_SALES_RETURNS}/${id}/${format}`, { locale }),
    format === "pdf" ? "service-sales-return.pdf" : "service-sales-return.xlsx",
    options,
  );
}

export function uploadServiceSalesReturnAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<ServiceSalesReturnAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<ServiceSalesReturnAttachment>(`${SERVICE_SALES_RETURNS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function serviceSalesReturnAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${SERVICE_SALES_RETURNS}/${id}/attachments/${attachmentId}`,
    { download: download || undefined },
  )}`;
}

export function deleteServiceSalesReturnAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SERVICE_SALES_RETURNS}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Receipt Order (أمر القبض)

const RECEIPT_ORDERS = "/accounting/receipt-orders";

export function getReceiptOrders(
  filter: ReceiptOrderFilter = {},
  options: EndpointOptions = {},
): Promise<ReceiptOrderList> {
  return apiGet<ReceiptOrderList>(withQuery(RECEIPT_ORDERS, { ...filter }), options);
}

export function getReceiptOrder(id: string, options: EndpointOptions = {}): Promise<ReceiptOrder> {
  return apiGet<ReceiptOrder>(`${RECEIPT_ORDERS}/${id}`, options);
}

export function saveReceiptOrder(
  input: SaveReceiptOrderInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(RECEIPT_ORDERS, { ...options, method: "PUT", body: input });
}

/** Authorises collection. Writes no journal and moves no balance. */
export function approveReceiptOrder(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${RECEIPT_ORDERS}/${id}/approve`, undefined, options);
}

export function cancelReceiptOrder(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_ORDERS}/${id}/cancel`, { reason }, options);
}

export function fetchReceiptOrderFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${RECEIPT_ORDERS}/${id}/${format}`, { locale }),
    format === "pdf" ? "receipt-order.pdf" : "receipt-order.xlsx",
    options,
  );
}

export function uploadReceiptOrderAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<ReceiptOrderAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<ReceiptOrderAttachment>(`${RECEIPT_ORDERS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function receiptOrderAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIPT_ORDERS}/${id}/attachments/${attachmentId}`, {
    download: download || undefined,
  })}`;
}

export function deleteReceiptOrderAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${RECEIPT_ORDERS}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Customer Balance Reminder (تذكير بأرصدة العملاء)

const CUSTOMER_BALANCE_REMINDERS = "/accounting/customer-balance-reminders";

export function getReminderCandidates(
  filter: ReminderCandidateFilter = {},
  options: EndpointOptions = {},
): Promise<ReminderCandidateList> {
  return apiGet<ReminderCandidateList>(
    withQuery(`${CUSTOMER_BALANCE_REMINDERS}/candidates`, { ...filter }), options);
}

/** The company's approved reminder wording, so the screen need not invent one. */
export function getReminderTemplate(options: EndpointOptions = {}): Promise<ReminderTemplateInfo> {
  return apiGet<ReminderTemplateInfo>(`${CUSTOMER_BALANCE_REMINDERS}/template`, options);
}

/** Renders for one customer. Sends nothing and writes nothing. */
export function previewReminder(
  input: { customerId: string; subject?: string; message?: string },
  options: EndpointOptions = {},
): Promise<ReminderPreview> {
  return apiGet<ReminderPreview>(
    withQuery(`${CUSTOMER_BALANCE_REMINDERS}/preview`, { ...input }), options);
}

export function sendReminders(
  input: SendRemindersInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${CUSTOMER_BALANCE_REMINDERS}/send`, input, options);
}

export function getReminderBatches(
  filter: { fromDate?: string; toDate?: string } = {},
  options: EndpointOptions = {},
): Promise<ReminderBatchList> {
  return apiGet<ReminderBatchList>(
    withQuery(`${CUSTOMER_BALANCE_REMINDERS}/batches`, { ...filter }), options);
}

export function getReminderBatch(
  id: string,
  options: EndpointOptions = {},
): Promise<ReminderBatch> {
  return apiGet<ReminderBatch>(`${CUSTOMER_BALANCE_REMINDERS}/batches/${id}`, options);
}

// ─────────────────────────────── Receipt Books (دفاتر القبض)

const RECEIPT_BOOKS = "/accounting/receipt-books";

export function getReceiptBooks(
  filter: {
    search?: string; status?: number; holderType?: number; holderId?: string;
    branchId?: string; fromReceiptNumber?: number; toReceiptNumber?: number;
  } = {},
  options: EndpointOptions = {},
): Promise<ReceiptBookList> {
  return apiGet<ReceiptBookList>(withQuery(RECEIPT_BOOKS, { ...filter }), options);
}

export function getReceiptBook(id: string, options: EndpointOptions = {}): Promise<ReceiptBook> {
  return apiGet<ReceiptBook>(`${RECEIPT_BOOKS}/${id}`, options);
}

/** Who a book may be handed to, for one holder type. Empty for types with no master file. */
export function getReceiptBookHolders(
  holderType: number,
  search?: string,
  options: EndpointOptions = {},
): Promise<ReceiptBookHolder[]> {
  return apiGet<ReceiptBookHolder[]>(
    withQuery(`${RECEIPT_BOOKS}/holders`, { holderType, search }), options);
}

/** استلام دفتر جديد — registers a physical book, or amends one that has not moved. */
export function saveReceiptBook(
  input: SaveReceiptBookInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(RECEIPT_BOOKS, { ...options, method: "PUT", body: input });
}

/** تسليم دفتر */
export function assignReceiptBook(
  id: string,
  input: { holderType: number; holderId: string; assignmentDate?: string; notes?: string },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_BOOKS}/${id}/assign`, input, options);
}

/** استلام دفتر */
export function receiveReceiptBook(
  id: string,
  input: { returnDate?: string; notes?: string } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_BOOKS}/${id}/receive`, input, options);
}

export function closeReceiptBook(
  id: string,
  notes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${RECEIPT_BOOKS}/${id}/close`, { notes }, options);
}

// ─────────────────────────────── Service Sales Invoice (فاتورة مبيعات الخدمات)

const SERVICE_SALES_INVOICES = "/accounting/service-sales-invoices";

export function getServiceSalesInvoices(
  filter: { search?: string; customerId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<ServiceSalesInvoiceList> {
  return apiGet<ServiceSalesInvoiceList>(
    withQuery(SERVICE_SALES_INVOICES, { ...filter }), options);
}

export function getServiceSalesInvoice(
  id: string,
  options: EndpointOptions = {},
): Promise<ServiceSalesInvoice> {
  return apiGet<ServiceSalesInvoice>(`${SERVICE_SALES_INVOICES}/${id}`, options);
}

/** Creates or amends a DRAFT. The number is allocated by the first successful save. */
export function saveServiceSalesInvoice(
  input: SaveServiceSalesInvoiceInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SERVICE_SALES_INVOICES, { ...options, method: "PUT", body: input });
}

/** Approves a draft. Zero accounting impact — nothing reaches the ledger here. */
export function auditServiceSalesInvoice(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_INVOICES}/${id}/audit`, { auditNotes }, options);
}

/** Puts an audited invoice into the ledger, exactly once. */
export function postServiceSalesInvoice(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_INVOICES}/${id}/post`, undefined, options);
}

/** Reverses a posted invoice through the existing engine. Never a delete. */
export function reverseServiceSalesInvoice(
  id: string,
  reason?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SERVICE_SALES_INVOICES}/${id}/reverse`, { reason }, options);
}

export function fetchServiceSalesInvoiceFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SERVICE_SALES_INVOICES}/${id}/${format}`, { locale }),
    format === "pdf" ? "invoice.pdf" : "invoice.xlsx",
    options,
  );
}

export function uploadServiceSalesInvoiceAttachment(
  id: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<ServiceSalesInvoiceAttachment> {
  const form = new FormData();
  form.append("file", file);
  if (description) form.append("description", description);

  return request<ServiceSalesInvoiceAttachment>(`${SERVICE_SALES_INVOICES}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function serviceSalesInvoiceAttachmentUrl(
  id: string,
  attachmentId: string,
  download = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${SERVICE_SALES_INVOICES}/${id}/attachments/${attachmentId}`,
    { download: download || undefined },
  )}`;
}

export function deleteServiceSalesInvoiceAttachment(
  id: string,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SERVICE_SALES_INVOICES}/${id}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

// ─────────────────────────────── Customer Categories (فئات العملاء)

/**
 * The approved customer categories, from the Receivables settings module.
 *
 * The CUSTOMER card reads these. Suppliers keep their own categories in the shared partner
 * lookup — the two are different vocabularies and a supplier must not be offered "Local
 * Customers".
 */
export function getCustomerCategories(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CustomerCategoryList> {
  return apiGet<CustomerCategoryList>(
    withQuery("/accounting/customer-categories", { ...filter }),
    options,
  );
}

// ─────────────────────────────────────────────── Advance Received Revenue
const ADVANCE_RECEIVED_REVENUES = "/accounting/advance-received-revenues";

/** Posted CONTRACT invoices with no schedule yet - where the screen starts. */
export function getRecognizableInvoices(
  search?: string,
  options: EndpointOptions = {},
): Promise<RecognizableInvoiceList> {
  return apiGet<RecognizableInvoiceList>(
    withQuery(`${ADVANCE_RECEIVED_REVENUES}/recognizable-invoices`, { search }),
    options,
  );
}

export function getRecognitionSchedules(
  filter: { search?: string; status?: number; asOfDate?: string } = {},
  options: EndpointOptions = {},
): Promise<RecognitionScheduleList> {
  return apiGet<RecognitionScheduleList>(
    withQuery(ADVANCE_RECEIVED_REVENUES, { ...filter }),
    options,
  );
}

export function getRecognitionSchedule(
  id: string,
  asOfDate?: string,
  options: EndpointOptions = {},
): Promise<RecognitionSchedule> {
  return apiGet<RecognitionSchedule>(
    withQuery(`${ADVANCE_RECEIVED_REVENUES}/${id}`, { asOfDate }),
    options,
  );
}

/** Builds the plan. ZERO accounting effect. */
export function generateRecognitionSchedule(
  input: { sourceServiceSalesInvoiceId: string; notes?: string },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(ADVANCE_RECEIVED_REVENUES, input, options);
}

export function activateRecognitionSchedule(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${ADVANCE_RECEIVED_REVENUES}/${id}/activate`, undefined, options);
}

export function deleteRecognitionSchedule(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${ADVANCE_RECEIVED_REVENUES}/${id}`, { ...options, method: "DELETE" });
}

/** Raises a DRAFT recognition per due period. Still writes nothing to the ledger. */
export function recognizeDuePeriods(
  id: string,
  input: { asOfDate: string; periodId?: string },
  options: EndpointOptions = {},
): Promise<RecognizeDuePeriodsResult> {
  return apiPost<RecognizeDuePeriodsResult>(
    `${ADVANCE_RECEIVED_REVENUES}/${id}/recognize`,
    input,
    options,
  );
}

export function getRevenueRecognitions(
  filter: { scheduleId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<RevenueRecognitionList> {
  return apiGet<RevenueRecognitionList>(
    withQuery(`${ADVANCE_RECEIVED_REVENUES}/recognitions`, { ...filter }),
    options,
  );
}

export function auditRevenueRecognition(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${ADVANCE_RECEIVED_REVENUES}/recognitions/${id}/audit`, undefined, options);
}

/** The only call in this module that writes to the general ledger. */
export function postRevenueRecognition(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(
    `${ADVANCE_RECEIVED_REVENUES}/recognitions/${id}/post`, undefined, options);
}

export function reverseRevenueRecognition(
  id: string,
  input: { reversalDate?: string; reason?: string } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${ADVANCE_RECEIVED_REVENUES}/recognitions/${id}/reverse`, input, options);
}

// ─────────────────────────────────────────────── Customer Transaction Transfer
const CUSTOMER_TRANSACTION_TRANSFERS = "/accounting/customer-transaction-transfers";

/** The movements a customer owns RIGHT NOW — including ones transferred to them. */
export function getTransferableMovements(
  filter: { customerId: string; fromDate: string; toDate: string; search?: string },
  options: EndpointOptions = {},
): Promise<TransferableMovementList> {
  return apiGet<TransferableMovementList>(
    withQuery(`${CUSTOMER_TRANSACTION_TRANSFERS}/movements`, { ...filter }),
    options,
  );
}

export function getCustomerTransactionTransfers(
  filter: { search?: string; customerId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<CustomerTransactionTransferList> {
  return apiGet<CustomerTransactionTransferList>(
    withQuery(CUSTOMER_TRANSACTION_TRANSFERS, { ...filter }),
    options,
  );
}

export function getCustomerTransactionTransfer(
  id: string,
  options: EndpointOptions = {},
): Promise<CustomerTransactionTransfer> {
  return apiGet<CustomerTransactionTransfer>(
    `${CUSTOMER_TRANSACTION_TRANSFERS}/${id}`, options);
}

/** Creates or amends a DRAFT. Writes nothing to the ledger. */
export function saveCustomerTransactionTransfer(
  input: SaveCustomerTransactionTransferInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(CUSTOMER_TRANSACTION_TRANSFERS, {
    ...options, method: "PUT", body: input,
  });
}

export function auditCustomerTransactionTransfer(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${CUSTOMER_TRANSACTION_TRANSFERS}/${id}/audit`, { auditNotes }, options);
}

/** The only call in this module that moves a balance. */
export function postCustomerTransactionTransfer(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CUSTOMER_TRANSACTION_TRANSFERS}/${id}/post`, undefined, options);
}

export function reverseCustomerTransactionTransfer(
  id: string,
  input: { reversalDate?: string; reason?: string } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CUSTOMER_TRANSACTION_TRANSFERS}/${id}/reverse`, input, options);
}

// ─────────────────────────────────────────────── Supplier Transaction Transfer
const SUPPLIER_TRANSACTION_TRANSFERS = "/accounting/supplier-transaction-transfers";

/** The movements a supplier owns RIGHT NOW — including ones transferred to them. */
export function getTransferableSupplierMovements(
  filter: { supplierId: string; fromDate: string; toDate: string; search?: string },
  options: EndpointOptions = {},
): Promise<TransferableSupplierMovementList> {
  return apiGet<TransferableSupplierMovementList>(
    withQuery(`${SUPPLIER_TRANSACTION_TRANSFERS}/movements`, { ...filter }),
    options,
  );
}

export function getSupplierTransactionTransfers(
  filter: { search?: string; supplierId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<SupplierTransactionTransferList> {
  return apiGet<SupplierTransactionTransferList>(
    withQuery(SUPPLIER_TRANSACTION_TRANSFERS, { ...filter }),
    options,
  );
}

export function getSupplierTransactionTransfer(
  id: string,
  options: EndpointOptions = {},
): Promise<SupplierTransactionTransfer> {
  return apiGet<SupplierTransactionTransfer>(
    `${SUPPLIER_TRANSACTION_TRANSFERS}/${id}`, options);
}

/** Creates or amends a DRAFT. Writes nothing to the ledger. */
export function saveSupplierTransactionTransfer(
  input: SaveSupplierTransactionTransferInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(SUPPLIER_TRANSACTION_TRANSFERS, {
    ...options, method: "PUT", body: input,
  });
}

export function auditSupplierTransactionTransfer(
  id: string,
  auditNotes?: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SUPPLIER_TRANSACTION_TRANSFERS}/${id}/audit`, { auditNotes }, options);
}

/** The only call in this module that moves a balance. */
export function postSupplierTransactionTransfer(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_TRANSACTION_TRANSFERS}/${id}/post`, undefined, options);
}

export function reverseSupplierTransactionTransfer(
  id: string,
  input: { reversalDate?: string; reason?: string } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SUPPLIER_TRANSACTION_TRANSFERS}/${id}/reverse`, input, options);
}

/**
 * The reminder balance list as a file. INFORMATIONAL ONLY: it sends nothing, posts nothing and is
 * not a statement of account. The server re-runs the screen's own query, so the figures match.
 */
export function fetchCustomerBalanceReminderFile(
  format: "pdf" | "excel",
  filter: ReminderCandidateExportFilter,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${CUSTOMER_BALANCE_REMINDERS}/export/${format}`, { ...filter }),
    format === "pdf" ? "customer-balance-reminders.pdf" : "customer-balance-reminders.xlsx",
    options,
  );
}



// ── Payments › Daily Transactions › تعديل بيانات المورد (#14) + سقف الائتمان (#15) ───────────

const SUPPLIER_INFORMATION = "/accounting/supplier-information";
const SUPPLIER_CREDIT_LIMITS = "/accounting/supplier-credit-limits";

export function getSupplierInformation(
  supplierId: string,
  options: EndpointOptions = {},
): Promise<SupplierInformation> {
  return apiGet<SupplierInformation>(`${SUPPLIER_INFORMATION}/${supplierId}`, options);
}

/** Applies the changes through the MASTER's own command. Returns how many fields moved. */
export function adjustSupplierInformation(
  supplierId: string,
  changes: SupplierEditableFields,
  reason: string,
  options: EndpointOptions = {},
): Promise<number> {
  return apiPost<number>(
    `${SUPPLIER_INFORMATION}/${supplierId}/adjust`, { changes, reason }, options);
}

export function getSupplierCreditLimit(
  supplierId: string,
  options: EndpointOptions = {},
): Promise<SupplierCreditLimit> {
  return apiGet<SupplierCreditLimit>(`${SUPPLIER_CREDIT_LIMITS}/${supplierId}`, options);
}

export function getSupplierCreditLimitHistory(
  supplierId: string,
  options: EndpointOptions = {},
): Promise<SupplierCreditLimitHistory> {
  return apiGet<SupplierCreditLimitHistory>(
    `${SUPPLIER_CREDIT_LIMITS}/${supplierId}/history`, options);
}

/**
 * Moves the ceiling. `expectedCurrentLimit` is a STALENESS check — two concurrent edits refuse
 * rather than one silently overwriting the other.
 */
export function changeSupplierCreditLimit(
  supplierId: string,
  input: { newCreditLimit: number; reason: string; expectedCurrentLimit?: number | null },
  options: EndpointOptions = {},
): Promise<SupplierCreditLimit> {
  return apiPost<SupplierCreditLimit>(
    `${SUPPLIER_CREDIT_LIMITS}/${supplierId}/change`, input, options);
}

// ── Payments › Daily Transactions › المصروفات المدفوعة مقدماً (#13) ──────────────────────────

const PREPAID_EXPENSES = "/accounting/prepaid-expenses";

export function getPrepaidSchedules(
  filter: { searchTerm?: string; supplierId?: string; sourceInvoiceId?: string; state?: string } = {},
  options: EndpointOptions = {},
): Promise<PrepaidScheduleList> {
  return apiGet<PrepaidScheduleList>(withQuery(PREPAID_EXPENSES, { ...filter }), options);
}

export function getPrepaidSchedule(
  id: string,
  options: EndpointOptions = {},
): Promise<PrepaidSchedule> {
  return apiGet<PrepaidSchedule>(`${PREPAID_EXPENSES}/${id}`, options);
}

/** The lines of one posted purchase invoice, with what is still unscheduled on each. */
export function getSchedulableLines(
  filter: { invoiceId: string; excludeScheduleId?: string },
  options: EndpointOptions = {},
): Promise<SchedulableLineList> {
  return apiGet<SchedulableLineList>(
    withQuery(`${PREPAID_EXPENSES}/schedulable-lines`, { ...filter }), options);
}

/** Creates or amends a DRAFT plan and regenerates its periods. Posts nothing. */
export function savePrepaidSchedule(
  input: SavePrepaidScheduleInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PREPAID_EXPENSES, { ...options, method: "PUT", body: input });
}

export function activatePrepaidSchedule(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PREPAID_EXPENSES}/${id}/activate`, undefined, options);
}

export function cancelPrepaidSchedule(
  id: string,
  reason: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PREPAID_EXPENSES}/${id}/cancel`, { reason }, options);
}

/** The ONLY call in this module that writes accounting. Idempotent; skips what is not due. */
export function recognizePrepaidPeriods(
  id: string,
  input: { periodId?: string | null } = {},
  options: EndpointOptions = {},
): Promise<RecognizeDueResult> {
  return apiPost<RecognizeDueResult>(`${PREPAID_EXPENSES}/${id}/recognize`, input, options);
}

export function reversePrepaidRecognition(
  recognitionId: string,
  input: { reversalDate?: string | null; reason?: string | null } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${PREPAID_EXPENSES}/recognitions/${recognitionId}/reverse`, input, options);
}

/** The rendered schedule, fetched WITH the session's auth - never a bare link to the API. */
export function fetchPrepaidScheduleFile(
  format: "pdf" | "excel",
  id: string,
  locale: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${PREPAID_EXPENSES}/${id}/${format}`, { locale }),
    format === "pdf" ? "prepaid-schedule.pdf" : "prepaid-schedule.xlsx",
    options,
  );
}

// ── Payments › Daily Transactions › تذكير بأرصدة المورّدين (#12) ─────────────────────────
//
// Its own tables and its own three rights. Non-accounting: nothing here posts, and the
// balance is stated from the COMPANY'S side — positive means the company owes.


const SUPPLIER_BALANCE_REMINDERS = "/accounting/supplier-balance-reminders";

export function getSupplierReminderCandidates(
  filter: SupplierReminderCandidateFilter = {},
  options: EndpointOptions = {},
): Promise<SupplierReminderCandidateList> {
  return apiGet<SupplierReminderCandidateList>(
    withQuery(`${SUPPLIER_BALANCE_REMINDERS}/candidates`, { ...filter }), options);
}

/** The company's approved reminder wording, so the screen need not invent one. */
export function getSupplierReminderTemplate(options: EndpointOptions = {}): Promise<SupplierReminderTemplateInfo> {
  return apiGet<SupplierReminderTemplateInfo>(`${SUPPLIER_BALANCE_REMINDERS}/template`, options);
}

/** Renders for one supplier. Sends nothing and writes nothing. */
export function previewSupplierReminder(
  input: { supplierId: string; subject?: string; message?: string },
  options: EndpointOptions = {},
): Promise<SupplierReminderPreview> {
  return apiGet<SupplierReminderPreview>(
    withQuery(`${SUPPLIER_BALANCE_REMINDERS}/preview`, { ...input }), options);
}

export function sendSupplierReminders(
  input: SendSupplierRemindersInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${SUPPLIER_BALANCE_REMINDERS}/send`, input, options);
}

export function getSupplierReminderBatches(
  filter: { fromDate?: string; toDate?: string } = {},
  options: EndpointOptions = {},
): Promise<SupplierReminderBatchList> {
  return apiGet<SupplierReminderBatchList>(
    withQuery(`${SUPPLIER_BALANCE_REMINDERS}/batches`, { ...filter }), options);
}

export function getSupplierReminderBatch(
  id: string,
  options: EndpointOptions = {},
): Promise<SupplierReminderBatch> {
  return apiGet<SupplierReminderBatch>(`${SUPPLIER_BALANCE_REMINDERS}/batches/${id}`, options);
}

/**
 * The reminder balance list as a file. INFORMATIONAL ONLY: it sends nothing, posts nothing and is
 * not a statement of account. The server re-runs the screen's own query, so the figures match.
 */
export function fetchSupplierBalanceReminderFile(
  format: "pdf" | "excel",
  filter: SupplierReminderCandidateExportFilter,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(
    withQuery(`${SUPPLIER_BALANCE_REMINDERS}/export/${format}`, { ...filter }),
    format === "pdf" ? "supplier-balance-reminders.pdf" : "supplier-balance-reminders.xlsx",
    options,
  );
}

// ─────────────────────────────────────────────── Customer credit limit
export function getCustomerCreditLimit(
  customerId: string,
  options: EndpointOptions = {},
): Promise<CustomerCreditLimit> {
  return apiGet<CustomerCreditLimit>(`${BUSINESS_PARTNERS}/${customerId}/credit-limit`, options);
}

/** Moves the ceiling. Requires its own permission and a reason. Posts nothing. */
export function changeCustomerCreditLimit(
  customerId: string,
  input: ChangeCustomerCreditLimitInput,
  options: EndpointOptions = {},
): Promise<CustomerCreditLimit> {
  return request<CustomerCreditLimit>(`${BUSINESS_PARTNERS}/${customerId}/credit-limit`, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function getCustomerCreditLimitHistory(
  customerId: string,
  options: EndpointOptions = {},
): Promise<CustomerCreditLimitHistory> {
  return apiGet<CustomerCreditLimitHistory>(
    `${BUSINESS_PARTNERS}/${customerId}/credit-limit/history`, options);
}

// ─────────────────────────────────────────────── Account Reconciliation
const ACCOUNT_RECONCILIATIONS = "/accounting/account-reconciliations";

export function getPartyOpenItems(
  filter: {
    partyId: string; partyType: number;
    fromDate?: string; toDate?: string; currencyId?: string; status?: string;
    includeFullySettled?: boolean;
  },
  options: EndpointOptions = {},
): Promise<PartyOpenItems> {
  return apiGet<PartyOpenItems>(
    withQuery(`${ACCOUNT_RECONCILIATIONS}/open-items`, { ...filter }), options);
}

/** Matches documents. Creates no accounting entry of any kind. */
export function createReconciliation(
  input: CreateReconciliationInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(ACCOUNT_RECONCILIATIONS, input, options);
}

/** Withdraws ONE allocation. Does not cancel the invoice. Needs its own permission and a reason. */
export function cancelSettlement(
  lineId: string,
  reason: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${ACCOUNT_RECONCILIATIONS}/settlements/${lineId}/cancel`, { reason }, options);
}

export function getReconciliationHistory(
  filter: { partyId?: string; outstandingJournalVoucherId?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ReconciliationHistory> {
  return apiGet<ReconciliationHistory>(
    withQuery(`${ACCOUNT_RECONCILIATIONS}/history`, { ...filter }), options);
}

export function getInvoiceSettlement(
  invoiceId: string,
  options: EndpointOptions = {},
): Promise<InvoiceSettlement> {
  return apiGet<InvoiceSettlement>(
    `${ACCOUNT_RECONCILIATIONS}/invoices/${invoiceId}/settlement`, options);
}

/**
 * The invoice's own settlement panel, and the action that releases one allocation.
 *
 * Both reach the SHARED settlement engine — the same query and the same command the Account
 * Reconciliation screen uses. Cancelling releases the payment from the invoice; it does not
 * cancel the invoice, does not cancel the receipt, and writes no accounting entry.
 */
export function getServiceSalesInvoiceSettlement(
  invoiceId: string,
  options: EndpointOptions = {},
): Promise<InvoiceSettlement> {
  return apiGet<InvoiceSettlement>(`${SERVICE_SALES_INVOICES}/${invoiceId}/settlement`, options);
}

export function cancelInvoiceSettlement(
  invoiceId: string,
  settlementId: string,
  reason: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(
    `${SERVICE_SALES_INVOICES}/${invoiceId}/settlements/${settlementId}/cancel`,
    { reason },
    options,
  );
}

// ─────────────────────────────── Receivables Inquiries

/**
 * إجمالي ذمم العملاء. Totals come back covering the WHOLE filtered result.
 *
 * Without `upToDate` the figures are today's stored balances; with it they are read from the
 * posted ledger up to that date. The response says which, so the screen never has to guess.
 */
export function getCustomerReceivables(
  filter: CustomerReceivablesFilter,
  options: EndpointOptions = {},
): Promise<CustomerReceivablesSummary> {
  return apiGet<CustomerReceivablesSummary>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-receivables`, { ...filter }),
    options,
  );
}

/** كشف حساب العميل. Opening balance, movements and closing balance, all server-computed. */
export function getCustomerStatement(
  filter: CustomerStatementFilter,
  options: EndpointOptions = {},
): Promise<CustomerStatement> {
  return apiGet<CustomerStatement>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-statement`, { ...filter }),
    options,
  );
}

/** Export URLs. Both re-run the server query from these same filters. */
export function customerReceivablesExportUrl(
  format: "pdf" | "excel",
  filter: CustomerReceivablesFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIVABLES_INQUIRIES}/customer-receivables/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

export function customerStatementExportUrl(
  format: "pdf" | "excel",
  filter: CustomerStatementFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIVABLES_INQUIRIES}/customer-statement/${format}`, {
    ...filter,
    locale,
    ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

/**
 * كشف إجمالي ذمم العملاء - مركز التكلفة.
 *
 * Always ledger-derived, cut-off or not: PartyBalance carries no cost centre, so it cannot
 * answer this even for "now".
 */
export function getCustomerReceivablesByCostCenter(
  filter: CustomerCostCenterFilter,
  options: EndpointOptions = {},
): Promise<CustomerReceivablesByCostCenter> {
  return apiGet<CustomerReceivablesByCostCenter>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-receivables-by-cost-center`, { ...filter }),
    options,
  );
}

export function customerCostCenterReceivablesExportUrl(
  format: "pdf" | "excel",
  filter: CustomerCostCenterFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/customer-receivables-by-cost-center/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── كشف حساب العميل / عملة

/** The currencies one customer actually has posted movements in. */
export function getCustomerLedgerCurrencies(
  customerId: string,
  options: EndpointOptions = {},
): Promise<CustomerLedgerCurrencies> {
  return apiGet<CustomerLedgerCurrencies>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-ledger-currencies`, { customerId }),
    options,
  );
}

/** One customer, one transaction currency. Both are required by the server. */
export function getCustomerStatementByCurrency(
  filter: CustomerCurrencyStatementFilter,
  options: EndpointOptions = {},
): Promise<CustomerCurrencyStatement> {
  return apiGet<CustomerCurrencyStatement>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-statement-by-currency`, { ...filter }),
    options,
  );
}

export function customerCurrencyStatementExportUrl(
  format: "pdf" | "excel",
  filter: CustomerCurrencyStatementFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/customer-statement-by-currency/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── الحركات اليومية

/** Customer movements, paged and totalled server-side over the whole filtered set. */
export function getCustomerTransactions(
  filter: CustomerTransactionsFilter,
  options: EndpointOptions = {},
): Promise<CustomerTransactionsResult> {
  return apiGet<CustomerTransactionsResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-transactions`, { ...filter }),
    options,
  );
}

export function customerTransactionsExportUrl(
  format: "pdf" | "excel",
  filter: CustomerTransactionsFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/customer-transactions/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── حركات السندات - خدمات

/** Service documents, one row per document. Paged and totalled server-side. */
export function getServiceVoucherTransactions(
  filter: ServiceVoucherTransactionsFilter,
  options: EndpointOptions = {},
): Promise<ServiceVoucherTransactionsResult> {
  return apiGet<ServiceVoucherTransactionsResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/service-voucher-transactions`, { ...filter }),
    options,
  );
}

export function serviceVoucherTransactionsExportUrl(
  format: "pdf" | "excel",
  filter: ServiceVoucherTransactionsFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/service-voucher-transactions/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── حركات مادة عميل

/** What each customer bought, one row per sales line. Paged and totalled server-side. */
export function getCustomerItemTransactions(
  filter: CustomerItemTransactionsFilter,
  options: EndpointOptions = {},
): Promise<CustomerItemTransactionsResult> {
  return apiGet<CustomerItemTransactionsResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-item-transactions`, { ...filter }),
    options,
  );
}

export function customerItemTransactionsExportUrl(
  format: "pdf" | "excel",
  filter: CustomerItemTransactionsFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/customer-item-transactions/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── الفواتير المسددة وغير المسددة

/**
 * Customer invoices with their settlement state.
 *
 * Settlement HISTORY for one invoice is not served here — `getInvoiceSettlement` already returns
 * it from the settlement engine's own endpoint, and duplicating it would be a second reader that
 * could disagree with the first.
 */
export function getPaidUnpaidInvoices(
  filter: PaidUnpaidInvoicesFilter,
  options: EndpointOptions = {},
): Promise<PaidUnpaidInvoicesResult> {
  return apiGet<PaidUnpaidInvoicesResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/paid-unpaid-invoices`, { ...filter }),
    options,
  );
}

export function paidUnpaidInvoicesExportUrl(
  format: "pdf" | "excel",
  filter: PaidUnpaidInvoicesFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/paid-unpaid-invoices/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── أعمار ذمم العملاء

/** Customer receivables aging across the company's own configured periods. */
export function getCustomerAging(
  filter: CustomerAgingFilter,
  options: EndpointOptions = {},
): Promise<CustomerAgingResult> {
  return apiGet<CustomerAgingResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-aging`, { ...filter }),
    options,
  );
}

/** The open items behind one customer's aging, on the same date and basis. */
export function getCustomerAgingDetail(
  filter: { customerId: string; asOfDate?: string; basis?: number; branchId?: string },
  options: EndpointOptions = {},
): Promise<CustomerAgingDetailRow[]> {
  return apiGet<CustomerAgingDetailRow[]>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-aging/detail`, { ...filter }),
    options,
  );
}

export function customerAgingExportUrl(
  format: "pdf" | "excel",
  filter: CustomerAgingFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIVABLES_INQUIRIES}/customer-aging/${format}`, {
    ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── تقرير أعمار الذمم التفصيلي

/** The same aging engine as the summary, one row per open receivable item. */
export function getDetailedAging(
  filter: DetailedAgingFilter,
  options: EndpointOptions = {},
): Promise<DetailedAgingResult> {
  return apiGet<DetailedAgingResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/detailed-aging`, { ...filter }),
    options,
  );
}

/** Settlement history for one open item, on the report's own as-of date. */
export function getDetailedAgingSettlements(
  filter: { journalVoucherId: string; asOfDate?: string },
  options: EndpointOptions = {},
): Promise<DetailedAgingSettlement[]> {
  return apiGet<DetailedAgingSettlement[]>(
    withQuery(`${RECEIVABLES_INQUIRIES}/detailed-aging/settlements`, { ...filter }),
    options,
  );
}

export function detailedAgingExportUrl(
  format: "pdf" | "excel",
  filter: DetailedAgingFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIVABLES_INQUIRIES}/detailed-aging/${format}`, {
    ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

// ─────────────────────────────── حركات السندات

/** Every Receivables voucher/document in one flat list — one row per document. READ ONLY. */
/** ONE customer's movements with the cost centre each was posted with. Customer REQUIRED. */
/** Aging rolled up by category or currency — the same engine the aging reports use. */
const RECEIPTS_REPORTS = "/accounting/receipts-reports";

/**
 * The remaining receipts reports.
 *
 * Each has its own typed endpoint on the server; this one accessor carries the code so the
 * frontend does not need thirteen near-identical functions. The RESPONSE type is supplied by the
 * caller, which keeps each screen typed against its own DTO.
 */
export function getReceiptsReport<TResult>(
  code: string,
  filter: ReceiptsReportFilter,
  options: EndpointOptions = {},
): Promise<TResult> {
  return apiGet<TResult>(withQuery(`${RECEIPTS_REPORTS}/${code}`, { ...filter }), options);
}

/** The five customer-master reports share a DTO, so they share one typed accessor. */
export function getCustomerMasterReport(
  code: string,
  filter: CustomerMasterFilter,
  options: EndpointOptions = {},
): Promise<CustomerMasterResult> {
  return apiGet<CustomerMasterResult>(
    withQuery(`${RECEIPTS_REPORTS}/${code}`, { ...filter }),
    options,
  );
}

export function customerMasterReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: CustomerMasterFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIPTS_REPORTS}/${code}/${format}`, {
    ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

export function getAgingGrouped(
  filter: AgingGroupedFilter,
  options: EndpointOptions = {},
): Promise<AgingGroupedResult> {
  return apiGet<AgingGroupedResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/aging-grouped`, { ...filter }),
    options,
  );
}

export function agingGroupedExportUrl(
  format: "pdf" | "excel",
  filter: AgingGroupedFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${RECEIVABLES_INQUIRIES}/aging-grouped/${format}`, {
    ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}),
  })}`;
}

export function getCustomerAccountCostCenter(
  filter: CustomerAccountCostCenterFilter,
  options: EndpointOptions = {},
): Promise<CustomerAccountCostCenterResult> {
  return apiGet<CustomerAccountCostCenterResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/customer-account-cost-center`, { ...filter }),
    options,
  );
}

export function customerAccountCostCenterExportUrl(
  format: "pdf" | "excel",
  filter: CustomerAccountCostCenterFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/customer-account-cost-center/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

export function getVoucherTransactions(
  filter: VoucherTransactionsFilter,
  options: EndpointOptions = {},
): Promise<VoucherTransactionsResult> {
  return apiGet<VoucherTransactionsResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/voucher-transactions`, { ...filter }),
    options,
  );
}

export function voucherTransactionsExportUrl(
  format: "pdf" | "excel",
  filter: VoucherTransactionsFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/voucher-transactions/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── فواتير العملاء المستحقة

/** Every customer invoice with an unpaid balance, as a FLAT LIST — one row per invoice. */
export function getOutstandingInvoices(
  filter: OutstandingInvoicesFilter,
  options: EndpointOptions = {},
): Promise<OutstandingInvoicesResult> {
  return apiGet<OutstandingInvoicesResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/outstanding-invoices`, { ...filter }),
    options,
  );
}

export function outstandingInvoicesExportUrl(
  format: "pdf" | "excel",
  filter: OutstandingInvoicesFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/outstanding-invoices/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── سندات القبض بدون فواتير

/** Customer receipts still carrying money no invoice has been matched to. READ ONLY. */
export function getReceiptsWithoutInvoices(
  filter: ReceiptsWithoutInvoicesFilter,
  options: EndpointOptions = {},
): Promise<ReceiptVouchersWithoutInvoicesResult> {
  return apiGet<ReceiptVouchersWithoutInvoicesResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/receipts-without-invoices`, { ...filter }),
    options,
  );
}

/** One receipt's payment splits and allocations — cancelled allocations included, flagged. */
export function getReceiptAllocationDetail(
  receiptId: string,
  options: EndpointOptions = {},
): Promise<ReceiptAllocationDetailResult> {
  return apiGet<ReceiptAllocationDetailResult>(
    `${RECEIVABLES_INQUIRIES}/receipts-without-invoices/${receiptId}/allocations`,
    options,
  );
}

export function receiptsWithoutInvoicesExportUrl(
  format: "pdf" | "excel",
  filter: ReceiptsWithoutInvoicesFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/receipts-without-invoices/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ─────────────────────────────── التسلسلات المفقودة في سندات القبض

/** Gaps in Receipt Voucher numbering. An audit — it allocates nothing. */
export function getMissingReceiptVoucherSequences(
  filter: MissingVoucherSequenceFilter,
  options: EndpointOptions = {},
): Promise<MissingReceiptVoucherSequencesResult> {
  return apiGet<MissingReceiptVoucherSequencesResult>(
    withQuery(`${RECEIVABLES_INQUIRIES}/missing-receipt-voucher-sequences`, { ...filter }),
    options,
  );
}

export function missingVoucherSequencesExportUrl(
  format: "pdf" | "excel",
  filter: MissingVoucherSequenceFilter,
  locale: string,
  forPrinting = false,
): string {
  return `${getApiBaseUrl()}${withQuery(
    `${RECEIVABLES_INQUIRIES}/missing-receipt-voucher-sequences/${format}`,
    { ...filter, locale, ...(forPrinting ? { forPrinting: true } : {}) },
  )}`;
}

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// Financial Management › Payments › Inquiries
//
// Nine read-only screens and their export actions. Each screen sends its whole filter — including
// page, page size and sort — because the server does the filtering, sorting, paging AND totalling.
// The export URLs take the SAME filter, so a printed page can never differ from the screen that
// produced it beyond being complete rather than paged.
// ═══════════════════════════════════════════════════════════════════════════════════════════════

const PAYMENTS_INQUIRIES = "/accounting/payments-inquiries";

/**
 * The export URL for any of the nine.
 *
 * One helper, because eighteen near-identical URL builders is eighteen chances to forget a
 * filter and print something the screen never showed.
 */
function paymentsInquiryExportUrl<TFilter extends PaymentsInquiryFilter>(
  screen: string,
  format: "pdf" | "excel",
  filter: TFilter,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${PAYMENTS_INQUIRIES}/${screen}/${format}`, {
    ...(filter as unknown as Record<string, string | number | boolean | undefined>),
    locale,
  })}`;
}

// ─────────────────────────────────────────── #1 إجمالي ذمم الموردين

/** One consolidated row per supplier in the caller's Inquiry scope. */
export function getTotalSupplierPayables(
  filter: TotalSupplierPayablesFilter,
  options: EndpointOptions = {},
): Promise<TotalSupplierPayablesResult> {
  return apiGet<TotalSupplierPayablesResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/total-supplier-payables`, { ...filter }),
    options,
  );
}

export function totalSupplierPayablesExportUrl(
  format: "pdf" | "excel", filter: TotalSupplierPayablesFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("total-supplier-payables", format, filter, locale);
}

// ─────────────────────────────────────────── #2 حركات حساب مورد

/** One supplier's subledger, with an opening balance and a running balance. */
export function getSupplierAccountMovements(
  filter: SupplierAccountMovementsFilter,
  options: EndpointOptions = {},
): Promise<SupplierAccountMovementsResult> {
  return apiGet<SupplierAccountMovementsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-account-movements`, { ...filter }),
    options,
  );
}

export function supplierAccountMovementsExportUrl(
  format: "pdf" | "excel", filter: SupplierAccountMovementsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-account-movements", format, filter, locale);
}

// ─────────────────────────────────────────── #3 حركات الموردين

/** The same movements across every supplier in scope. No running balance — it would be meaningless. */
export function getSupplierMovements(
  filter: SupplierAccountMovementsFilter,
  options: EndpointOptions = {},
): Promise<SupplierAccountMovementsResult> {
  return apiGet<SupplierAccountMovementsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-movements`, { ...filter }),
    options,
  );
}

export function supplierMovementsExportUrl(
  format: "pdf" | "excel", filter: SupplierAccountMovementsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-movements", format, filter, locale);
}

// ─────────────────────────────────── #4 الحركات اليومية للمدفوعات

/** Every AP document raised in a window — accounting and non-accounting alike. */
export function getPaymentsDailyTransactions(
  filter: PaymentsDailyTransactionsFilter,
  options: EndpointOptions = {},
): Promise<PaymentsDailyTransactionsResult> {
  return apiGet<PaymentsDailyTransactionsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/daily-transactions`, { ...filter }),
    options,
  );
}

export function paymentsDailyTransactionsExportUrl(
  format: "pdf" | "excel", filter: PaymentsDailyTransactionsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("daily-transactions", format, filter, locale);
}

// ─────────────────────────────────────────── #5 حركات سندات الدفع

/** Payment vouchers with their real settlement split. */
export function getPaymentVoucherMovements(
  filter: PaymentVoucherMovementsFilter,
  options: EndpointOptions = {},
): Promise<PaymentVoucherMovementsResult> {
  return apiGet<PaymentVoucherMovementsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/payment-voucher-movements`, { ...filter }),
    options,
  );
}

export function paymentVoucherMovementsExportUrl(
  format: "pdf" | "excel", filter: PaymentVoucherMovementsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("payment-voucher-movements", format, filter, locale);
}

// ──────────────────────────────── #6 حركات مستندات شراء الخدمات

/** Request → invoice → return, as one chain. */
export function getServicePurchaseDocuments(
  filter: ServicePurchaseDocumentsFilter,
  options: EndpointOptions = {},
): Promise<ServicePurchaseDocumentsResult> {
  return apiGet<ServicePurchaseDocumentsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/service-purchase-documents`, { ...filter }),
    options,
  );
}

export function servicePurchaseDocumentsExportUrl(
  format: "pdf" | "excel", filter: ServicePurchaseDocumentsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("service-purchase-documents", format, filter, locale);
}

// ───────────────────────────── #7 حركات المورد حسب مركز التكلفة

/** Supplier postings split by the cost centre each one actually carries. */
export function getSupplierCostCenterMovements(
  filter: SupplierCostCenterFilter,
  options: EndpointOptions = {},
): Promise<SupplierCostCenterResult> {
  return apiGet<SupplierCostCenterResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-cost-center-movements`, { ...filter }),
    options,
  );
}

export function supplierCostCenterMovementsExportUrl(
  format: "pdf" | "excel", filter: SupplierCostCenterFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-cost-center-movements", format, filter, locale);
}

// ─────────────────────────────────────────── #8 دفاتر سندات الدفع

/** Book custody. No supplier is involved, so no supplier scope applies — only the permission. */
export function getPaymentBooksInquiry(
  filter: PaymentBooksInquiryFilter,
  options: EndpointOptions = {},
): Promise<PaymentBooksInquiryResult> {
  return apiGet<PaymentBooksInquiryResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/payment-books`, { ...filter }),
    options,
  );
}

export function paymentBooksInquiryExportUrl(
  format: "pdf" | "excel", filter: PaymentBooksInquiryFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("payment-books", format, filter, locale);
}

// ────────────────────────────────────── #9 فجوات نطاقات الدفاتر

/** Number ranges registered to NO book. Never "missing vouchers". */
export function getPaymentBookRangeGaps(
  filter: MissingBookSequencesFilter,
  options: EndpointOptions = {},
): Promise<MissingBookSequencesResult> {
  return apiGet<MissingBookSequencesResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/payment-book-range-gaps`, { ...filter }),
    options,
  );
}

export function paymentBookRangeGapsExportUrl(
  format: "pdf" | "excel", filter: MissingBookSequencesFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("payment-book-range-gaps", format, filter, locale);
}

/** The suppliers the caller may inquire on. The picker for all seven supplier-scoped screens. */
export function getInquirySuppliers(
  search?: string,
  options: EndpointOptions = {},
): Promise<InquirySupplierOption[]> {
  return apiGet<InquirySupplierOption[]>(
    withQuery(`${PAYMENTS_INQUIRIES}/suppliers`, { search }),
    options,
  );
}

// ═══════════════ Payments › Inquiries — the ten completing the AP catalogue ═══════════════

/** أوامر الصرف غير المدرجة — instructions not yet covered by posted vouchers. */
export function getUnsettledPaymentOrders(
  filter: UnsettledPaymentOrdersFilter, options: EndpointOptions = {},
): Promise<UnsettledPaymentOrdersResult> {
  return apiGet<UnsettledPaymentOrdersResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/unsettled-payment-orders`, { ...filter }), options);
}

export function unsettledPaymentOrdersExportUrl(
  format: "pdf" | "excel", filter: UnsettledPaymentOrdersFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("unsettled-payment-orders", format, filter, locale);
}

/** بيانات المورد — the supplier card, read only, under Inquiry scope. */
export function getSupplierInformationInquiry(
  filter: SupplierInformationInquiryFilter, options: EndpointOptions = {},
): Promise<SupplierInformationInquiryResult> {
  return apiGet<SupplierInformationInquiryResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-information`, { ...filter }), options);
}

export function supplierInformationExportUrl(
  format: "pdf" | "excel", filter: SupplierInformationInquiryFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-information", format, filter, locale);
}

/** حساب المورد - عملة / محلي — both sides of every movement at the posted rate. */
export function getSupplierCurrencyStatement(
  filter: SupplierCurrencyStatementFilter, options: EndpointOptions = {},
): Promise<SupplierCurrencyStatementResult> {
  return apiGet<SupplierCurrencyStatementResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-currency-statement`, { ...filter }), options);
}

export function supplierCurrencyStatementExportUrl(
  format: "pdf" | "excel", filter: SupplierCurrencyStatementFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-currency-statement", format, filter, locale);
}

/** إجمالي أرصدة الموردين - مركز التكلفة — balances grouped by authoritative cost centre. */
export function getSupplierBalancesByCostCenter(
  filter: SupplierBalancesByCostCenterFilter, options: EndpointOptions = {},
): Promise<SupplierBalancesByCostCenterResult> {
  return apiGet<SupplierBalancesByCostCenterResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-balances-by-cost-center`, { ...filter }), options);
}

export function supplierBalancesByCostCenterExportUrl(
  format: "pdf" | "excel", filter: SupplierBalancesByCostCenterFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-balances-by-cost-center", format, filter, locale);
}

/** أوامر الشراء بانتظار الدفع — genuine purchase orders with something still to pay. */
export function getPurchaseOrdersAwaitingPayment(
  filter: PurchaseOrdersAwaitingPaymentFilter, options: EndpointOptions = {},
): Promise<PurchaseOrdersAwaitingPaymentResult> {
  return apiGet<PurchaseOrdersAwaitingPaymentResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/purchase-orders-awaiting-payment`, { ...filter }), options);
}

export function purchaseOrdersAwaitingPaymentExportUrl(
  format: "pdf" | "excel", filter: PurchaseOrdersAwaitingPaymentFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("purchase-orders-awaiting-payment", format, filter, locale);
}

/** دفاتر القبض والصرف — both registers side by side; the domains stay separate. */
export function getCombinedBooks(
  filter: CombinedBooksFilter, options: EndpointOptions = {},
): Promise<CombinedBooksResult> {
  return apiGet<CombinedBooksResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/receipt-and-payment-books`, { ...filter }), options);
}

export function combinedBooksExportUrl(
  format: "pdf" | "excel", filter: CombinedBooksFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("receipt-and-payment-books", format, filter, locale);
}

/** حركات المادة - المورد — purchase lines by the purchase side's own item identity. */
export function getSupplierItemTransactions(
  filter: SupplierItemTransactionsFilter, options: EndpointOptions = {},
): Promise<SupplierItemTransactionsResult> {
  return apiGet<SupplierItemTransactionsResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/supplier-item-transactions`, { ...filter }), options);
}

export function supplierItemTransactionsExportUrl(
  format: "pdf" | "excel", filter: SupplierItemTransactionsFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("supplier-item-transactions", format, filter, locale);
}

/** فواتير الموردين المستحقة — from the settlement engine, not from invoice status. */
export function getOutstandingSupplierInvoices(
  filter: OutstandingSupplierInvoicesFilter, options: EndpointOptions = {},
): Promise<OutstandingSupplierInvoicesResult> {
  return apiGet<OutstandingSupplierInvoicesResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/outstanding-supplier-invoices`, { ...filter }), options);
}

export function outstandingSupplierInvoicesExportUrl(
  format: "pdf" | "excel", filter: OutstandingSupplierInvoicesFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("outstanding-supplier-invoices", format, filter, locale);
}

/** الفواتير المسددة وغير المسددة — classified by what was actually applied. */
export function getPaidUnpaidSupplierInvoices(
  filter: PaidUnpaidSupplierInvoicesFilter, options: EndpointOptions = {},
): Promise<PaidUnpaidSupplierInvoicesResult> {
  return apiGet<PaidUnpaidSupplierInvoicesResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/paid-unpaid-supplier-invoices`, { ...filter }), options);
}

export function paidUnpaidSupplierInvoicesExportUrl(
  format: "pdf" | "excel", filter: PaidUnpaidSupplierInvoicesFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("paid-unpaid-supplier-invoices", format, filter, locale);
}

/** سندات الصرف بدون فواتير مسددة — money on account that no invoice has claimed. */
export function getUnappliedPaymentVouchers(
  filter: UnappliedPaymentVouchersFilter, options: EndpointOptions = {},
): Promise<UnappliedPaymentVouchersResult> {
  return apiGet<UnappliedPaymentVouchersResult>(
    withQuery(`${PAYMENTS_INQUIRIES}/unapplied-payment-vouchers`, { ...filter }), options);
}

export function unappliedPaymentVouchersExportUrl(
  format: "pdf" | "excel", filter: UnappliedPaymentVouchersFilter, locale: string,
): string {
  return paymentsInquiryExportUrl("unapplied-payment-vouchers", format, filter, locale);
}

// ─────────────────────────────── Purchase Items (مواد الشراء)

const PURCHASE_ITEMS = "/accounting/purchase-items";

/** The purchase catalogue. `selectableOnly` is what a document picker asks for. */
export function getPurchaseItems(
  filter: {
    search?: string; itemType?: PurchaseItemType; isActive?: boolean; selectableOnly?: boolean;
  } = {},
  options: EndpointOptions = {},
): Promise<PurchaseItemList> {
  return apiGet<PurchaseItemList>(withQuery(PURCHASE_ITEMS, { ...filter }), options);
}

/** Adds when the input carries no id, edits when it does. */
export function savePurchaseItem(
  input: SavePurchaseItemInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PURCHASE_ITEMS, { ...options, method: "PUT", body: input });
}

/** Suspends or restores one item. Never deletes — history keeps pointing at it. */
export function setPurchaseItemActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${PURCHASE_ITEMS}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

// ─────────────────────────────── Purchase Orders (أوامر الشراء)

const PURCHASE_ORDERS = "/accounting/purchase-orders";

/** Commitments to suppliers. Non-accounting — nothing here posts. */
export function getPurchaseOrders(
  filter: {
    supplierId?: string; status?: PurchaseOrderStatus; dateFrom?: string; dateTo?: string;
    branchId?: string; search?: string; awaitingPaymentOnly?: boolean;
  } = {},
  options: EndpointOptions = {},
): Promise<PurchaseOrderList> {
  return apiGet<PurchaseOrderList>(withQuery(PURCHASE_ORDERS, { ...filter }), options);
}

export function getPurchaseOrder(
  id: string, options: EndpointOptions = {},
): Promise<PurchaseOrder> {
  return apiGet<PurchaseOrder>(`${PURCHASE_ORDERS}/${id}`, options);
}

/** Draft only — an approved commitment is closed or cancelled, never rewritten. */
export function savePurchaseOrder(
  input: SavePurchaseOrderInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PURCHASE_ORDERS, { ...options, method: "PUT", body: input });
}

export function approvePurchaseOrder(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${PURCHASE_ORDERS}/${id}/approve`, { ...options, method: "POST" });
}

export function closePurchaseOrder(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    `${PURCHASE_ORDERS}/${id}/close`, { ...options, method: "POST", body: { reason } });
}

export function cancelPurchaseOrder(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    `${PURCHASE_ORDERS}/${id}/cancel`, { ...options, method: "POST", body: { reason } });
}

// ═══════════════════ Payments › Reports ═══════════════════

const PAYMENTS_REPORTS = "/accounting/payments-reports";

/** One export URL builder for every Payments report, matching the inquiries' contract. */
function paymentsReportExportUrl<TFilter extends PaymentsInquiryFilter>(
  report: string, format: "pdf" | "excel", filter: TFilter, locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${PAYMENTS_REPORTS}/${report}/${format}`, {
    ...(filter as unknown as Record<string, string | number | boolean | undefined>),
    locale,
  })}`;
}

export function getSupplierBlacklistReport(
  filter: SupplierBlacklistFilter, options: EndpointOptions = {},
): Promise<SupplierBlacklistResult> {
  return apiGet<SupplierBlacklistResult>(
    withQuery(`${PAYMENTS_REPORTS}/supplier-blacklist`, { ...filter }), options);
}
export const supplierBlacklistExportUrl = (
  format: "pdf" | "excel", filter: SupplierBlacklistFilter, locale: string,
) => paymentsReportExportUrl("supplier-blacklist", format, filter, locale);

export function getExpiringDocumentsReport(
  filter: ExpiringDocumentsFilter, options: EndpointOptions = {},
): Promise<ExpiringDocumentsResult> {
  return apiGet<ExpiringDocumentsResult>(
    withQuery(`${PAYMENTS_REPORTS}/expiring-documents`, { ...filter }), options);
}
export const expiringDocumentsExportUrl = (
  format: "pdf" | "excel", filter: ExpiringDocumentsFilter, locale: string,
) => paymentsReportExportUrl("expiring-documents", format, filter, locale);

export function getPartnerInfoChangesReport(
  filter: PartnerInfoChangesFilter, options: EndpointOptions = {},
): Promise<PartnerInfoChangesResult> {
  return apiGet<PartnerInfoChangesResult>(
    withQuery(`${PAYMENTS_REPORTS}/partner-info-changes`, { ...filter }), options);
}
export const partnerInfoChangesExportUrl = (
  format: "pdf" | "excel", filter: PartnerInfoChangesFilter, locale: string,
) => paymentsReportExportUrl("partner-info-changes", format, filter, locale);

export function getSupplierAgeingReport(
  filter: SupplierAgeingFilter, options: EndpointOptions = {},
): Promise<SupplierAgeingResult> {
  return apiGet<SupplierAgeingResult>(
    withQuery(`${PAYMENTS_REPORTS}/supplier-ageing`, { ...filter }), options);
}
export const supplierAgeingExportUrl = (
  format: "pdf" | "excel", filter: SupplierAgeingFilter, locale: string,
) => paymentsReportExportUrl("supplier-ageing", format, filter, locale);

export function getShortTrialBalanceReport(
  filter: ShortTrialBalanceFilter, options: EndpointOptions = {},
): Promise<ShortTrialBalanceResult> {
  return apiGet<ShortTrialBalanceResult>(
    withQuery(`${PAYMENTS_REPORTS}/short-trial-balance`, { ...filter }), options);
}
export const shortTrialBalanceExportUrl = (
  format: "pdf" | "excel", filter: ShortTrialBalanceFilter, locale: string,
) => paymentsReportExportUrl("short-trial-balance", format, filter, locale);

export function getReceiptPaymentOrdersReport(
  filter: ReceiptPaymentOrdersFilter, options: EndpointOptions = {},
): Promise<ReceiptPaymentOrdersResult> {
  return apiGet<ReceiptPaymentOrdersResult>(
    withQuery(`${PAYMENTS_REPORTS}/receipt-payment-orders`, { ...filter }), options);
}
export const receiptPaymentOrdersExportUrl = (
  format: "pdf" | "excel", filter: ReceiptPaymentOrdersFilter, locale: string,
) => paymentsReportExportUrl("receipt-payment-orders", format, filter, locale);

export function getGuaranteesReport(
  filter: GuaranteesFilter, options: EndpointOptions = {},
): Promise<GuaranteesResult> {
  return apiGet<GuaranteesResult>(
    withQuery(`${PAYMENTS_REPORTS}/guarantees`, { ...filter }), options);
}
export const guaranteesExportUrl = (
  format: "pdf" | "excel", filter: GuaranteesFilter, locale: string,
) => paymentsReportExportUrl("guarantees", format, filter, locale);

export function getPurchaseInvoicesByTypeReport(
  filter: PurchaseInvoicesByTypeFilter, options: EndpointOptions = {},
): Promise<PurchaseInvoicesByTypeResult> {
  return apiGet<PurchaseInvoicesByTypeResult>(
    withQuery(`${PAYMENTS_REPORTS}/purchase-invoices-by-type`, { ...filter }), options);
}
export const purchaseInvoicesByTypeExportUrl = (
  format: "pdf" | "excel", filter: PurchaseInvoicesByTypeFilter, locale: string,
) => paymentsReportExportUrl("purchase-invoices-by-type", format, filter, locale);

export function getCapitalInvoicesReport(
  filter: CapitalInvoicesFilter, options: EndpointOptions = {},
): Promise<CapitalInvoicesResult> {
  return apiGet<CapitalInvoicesResult>(
    withQuery(`${PAYMENTS_REPORTS}/capital-invoices`, { ...filter }), options);
}
export const capitalInvoicesExportUrl = (
  format: "pdf" | "excel", filter: CapitalInvoicesFilter, locale: string,
) => paymentsReportExportUrl("capital-invoices", format, filter, locale);

export function getSupplierByAccountReport(
  filter: SupplierByAccountFilter, options: EndpointOptions = {},
): Promise<SupplierByAccountResult> {
  return apiGet<SupplierByAccountResult>(
    withQuery(`${PAYMENTS_REPORTS}/supplier-by-account`, { ...filter }), options);
}
export const supplierByAccountExportUrl = (
  format: "pdf" | "excel", filter: SupplierByAccountFilter, locale: string,
) => paymentsReportExportUrl("supplier-by-account", format, filter, locale);

// ─────────────── Payments settings: report signatures & evaluation criteria

const REPORT_SIGNATURES = "/accounting/report-signatures";
const EVALUATION_CRITERIA = "/accounting/supplier-evaluation-criteria";

/** تواقيع التقارير — the signature blocks printed beneath a company's reports. */
export function getReportSignatures(
  filter: { search?: string; module?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ReportSignatureList> {
  return apiGet<ReportSignatureList>(withQuery(REPORT_SIGNATURES, { ...filter }), options);
}

export function saveReportSignature(
  input: SaveReportSignatureInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(REPORT_SIGNATURES, { ...options, method: "PUT", body: input });
}

/** Suspends or restores one block. There is no delete — issued reports named it. */
export function setReportSignatureActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${REPORT_SIGNATURES}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

/** معايير تقييم الموردين — what suppliers are judged on. Criteria only, not scores. */
export function getSupplierEvaluationCriteria(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<SupplierEvaluationCriteriaList> {
  return apiGet<SupplierEvaluationCriteriaList>(
    withQuery(EVALUATION_CRITERIA, { ...filter }), options);
}

export function saveSupplierEvaluationCriterion(
  input: SaveSupplierEvaluationCriterionInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(EVALUATION_CRITERIA, { ...options, method: "PUT", body: input });
}

export function setSupplierEvaluationCriterionActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${EVALUATION_CRITERIA}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

/* ──────────────────────────────────────────────────────────────────────────────────────────────
 * Cash & Banks › Daily Transactions › the cheque desk.
 *
 * One read behind every cheque screen, and a NAMED action per business event. There is no generic
 * "set status" call, because each of these is a different authority with a different journal.
 * ────────────────────────────────────────────────────────────────────────────────────────────── */

const CHEQUE_DESK = "/cash-banks/cheques";
const CHEQUE_BOOKS = "/cash-banks/cheque-books";
const BANK_TRANSACTIONS = "/cash-banks/bank-transactions";
const BANK_TRANSFERS = "/cash-banks/bank-transfers";
const BANK_RECONCILIATIONS = "/cash-banks/bank-reconciliations";
const LETTERS_OF_CREDIT = "/cash-banks/letters-of-credit";
const BANK_LOANS = "/cash-banks/bank-loans";

export function getChequeDesk(
  filter: ChequeDeskFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeDeskList> {
  const { statuses, ...rest } = filter;
  const query = withQuery(CHEQUE_DESK, { ...rest });

  // Repeated key, not a joined string: the server binds statuses as an array, and "1,2" would
  // arrive as one unparseable value.
  const suffix = (statuses ?? []).map((status) => `statuses=${status}`).join("&");

  return apiGet<ChequeDeskList>(
    suffix ? `${query}${query.includes("?") ? "&" : "?"}${suffix}` : query,
    options,
  );
}

export function getChequeMovements(
  filter: {
    chequeId?: string;
    direction?: ChequeDirection;
    movementType?: ChequeMovementType;
    dateFrom?: string;
    dateTo?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<ChequeMovementList> {
  return apiGet<ChequeMovementList>(withQuery(`${CHEQUE_DESK}/movements`, { ...filter }), options);
}

// ─── Slips: several cheques moved in one trip to the bank ────────────────────────────────────
//
// The batch endpoints are NOT a convenience wrapper around the single-cheque ones. They run the
// same operation server-side inside ONE transaction, so five cheques on a slip either all move or
// none do — five separate calls from the browser could leave three moved and two behind.

/** استعلام السند — the deposits or collections already saved. */
export function getChequeBatches(
  filter: {
    movementType: ChequeMovementType;
    from?: string;
    to?: string;
    search?: string;
    take?: number;
  },
  options: EndpointOptions = {},
): Promise<ChequeBatchList> {
  return apiGet<ChequeBatchList>(withQuery(`${CHEQUE_DESK}/batches`, { ...filter }), options);
}

/** One saved slip, with its cheque lines. */
export function getChequeBatch(
  reference: string,
  filter: { movementType: ChequeMovementType; date?: string },
  options: EndpointOptions = {},
): Promise<ChequeBatchDetail> {
  return apiGet<ChequeBatchDetail>(
    withQuery(`${CHEQUE_DESK}/batches/${encodeURIComponent(reference)}`, { ...filter }),
    options,
  );
}

/**
 * Any cheque operation, applied to the selected cheques under one reference.
 *
 * ONE call for thirteen screens. The server dispatches each cheque to the command that already
 * owns that operation, so nothing about what an operation means is decided in the browser — and a
 * batch cannot post differently from the same action done to a single cheque.
 */
export function executeChequeBatch(
  body: ChequeBatchRequest,
  options: EndpointOptions = {},
): Promise<ChequeBatchResult> {
  return apiPost<ChequeBatchResult>(`${CHEQUE_DESK}/batch/execute`, body, options);
}

/** إيداع شيك برسم التحصيل. Operational — posts nothing. */
export function depositChequeForCollection(
  id: string,
  body: { depositedDate?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/deposit-for-collection`, body, options);
}

/** إيداع شيك فوري — straight into a bank account and treated as collected. */
export function depositChequeImmediately(
  id: string,
  body: { bankAccountId: string; date?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/deposit-immediately`, body, options);
}

/** تحصيل شيك برسم التحصيل — the money arrived. */
export function collectCheque(
  id: string,
  body: { bankAccountId: string; date?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/collect`, body, options);
}

/** سحب شيك برسم التحصيل — taken back off the bank uncollected. Posts nothing. */
export function withdrawChequeFromCollection(
  id: string,
  body: { date?: string | null; reference?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/withdraw-from-collection`, body, options);
}

/** ارتجاع شيك — the bank returned a received cheque unpaid. */
export function returnChequeUnpaid(
  id: string,
  body: { date?: string | null; reference?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/return-unpaid`, body, options);
}

/** إعادة الشيك للساحب — handed back uncollected. */
export function handBackCheque(
  id: string,
  body: { date?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/hand-back`, body, options);
}

/** معالجة شيك مرتجع — re-present, send to legal, or give it back. */
export function processReturnedCheque(
  id: string,
  body: { action: ReturnedChequeAction; date?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/process-return`, body, options);
}

/** تحرير شيك — writing one of ours. Returns the new cheque's id. */
export function issueCheque(
  input: IssueChequeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${CHEQUE_DESK}/issue`, input, options);
}

/** تسليم شيك — the paper was handed over. Operational; posts nothing. */
export function deliverCheque(
  id: string,
  body: { date?: string | null; deliveredTo?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/deliver`, body, options);
}

/** صرف الشيك — the bank debited our account. */
export function settleOutgoingCheque(
  id: string,
  body: { date?: string | null; reference?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/settle`, body, options);
}

/** ارتجاع شيك مدفوع — one of ours came back unpaid. */
export function returnIssuedCheque(
  id: string,
  body: { date?: string | null; reference?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/return-issued`, body, options);
}

/** معالجة شيك مدفوع مرتجع — re-deliver it or void it. */
export function processReturnedIssuedCheque(
  id: string,
  body: { action: ReturnedOutgoingChequeAction; date?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/process-issued-return`, body, options);
}

/** إلغاء شيك — voiding one of ours. */
export function cancelCheque(
  id: string,
  body: { date?: string | null; reason: string },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/cancel`, body, options);
}

/** تغيير تاريخ استحقاق شيك — posts nothing; a due date is not an amount. */
export function changeChequeDueDate(
  id: string,
  body: { newDueDate: string; reason: string },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_DESK}/${id}/change-due-date`, body, options);
}

export function getChequeBooks(
  filter: { bankAccountId?: string; cashboxId?: string; isActive?: boolean; search?: string } = {},
  options: EndpointOptions = {},
): Promise<ChequeBookList> {
  return apiGet<ChequeBookList>(withQuery(CHEQUE_BOOKS, { ...filter }), options);
}

export function getChequeBook(id: string, options: EndpointOptions = {}): Promise<ChequeBook> {
  return apiGet<ChequeBook>(`${CHEQUE_BOOKS}/${id}`, options);
}

/** The leaves a new cheque could be written on. Used and spoiled leaves never appear. */
export function getAvailableChequeLeaves(
  bankAccountId: string,
  options: EndpointOptions = {},
): Promise<ChequeBookLeafList> {
  return apiGet<ChequeBookLeafList>(
    withQuery(`${CHEQUE_BOOKS}/available-leaves`, { bankAccountId }),
    options,
  );
}

export function saveChequeBook(
  input: SaveChequeBookInput,
  options: EndpointOptions = {},
): Promise<string> {
  return request<string>(CHEQUE_BOOKS, { ...options, method: "PUT", body: input });
}

/** سحب ورقة من صندوق الشيكات — signing a blank leaf out. */
export function withdrawChequeLeaf(
  leafId: string,
  body: { date?: string | null; withdrawnBy: string; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${CHEQUE_BOOKS}/leaves/${leafId}/withdraw`, body, options);
}

/* ── Bank movements ─────────────────────────────────────────────────────────────────────────── */

export function getBankTransactions(
  filter: {
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    bankAccountId?: string;
    kind?: BankTransactionKind;
    status?: JournalStatus;
  } = {},
  options: EndpointOptions = {},
): Promise<BankTransactionList> {
  return apiGet<BankTransactionList>(withQuery(BANK_TRANSACTIONS, { ...filter }), options);
}

export function getBankTransaction(
  id: string,
  options: EndpointOptions = {},
): Promise<BankTransaction> {
  return apiGet<BankTransaction>(`${BANK_TRANSACTIONS}/${id}`, options);
}

export function saveBankTransaction(
  input: SaveBankTransactionInput,
  options: EndpointOptions = {},
): Promise<BankTransaction> {
  return request<BankTransaction>(BANK_TRANSACTIONS, { ...options, method: "PUT", body: input });
}

export function postBankTransaction(
  id: string,
  options: EndpointOptions = {},
): Promise<BankTransaction> {
  return apiPost<BankTransaction>(`${BANK_TRANSACTIONS}/${id}/post`, undefined, options);
}

export function reverseBankTransaction(
  id: string,
  body: { reversalDate?: string | null; reason?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_TRANSACTIONS}/${id}/reverse`, body, options);
}

export function deleteBankTransaction(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANK_TRANSACTIONS}/${id}`, { ...options, method: "DELETE" });
}

export function getBankTransfers(
  filter: {
    search?: string;
    dateFrom?: string;
    dateTo?: string;
    bankAccountId?: string;
    status?: JournalStatus;
  } = {},
  options: EndpointOptions = {},
): Promise<BankTransferList> {
  return apiGet<BankTransferList>(withQuery(BANK_TRANSFERS, { ...filter }), options);
}

export function getBankTransfer(id: string, options: EndpointOptions = {}): Promise<BankTransfer> {
  return apiGet<BankTransfer>(`${BANK_TRANSFERS}/${id}`, options);
}

export function saveBankTransfer(
  input: SaveBankTransferInput,
  options: EndpointOptions = {},
): Promise<BankTransfer> {
  return request<BankTransfer>(BANK_TRANSFERS, { ...options, method: "PUT", body: input });
}

export function postBankTransfer(
  id: string,
  options: EndpointOptions = {},
): Promise<BankTransfer> {
  return apiPost<BankTransfer>(`${BANK_TRANSFERS}/${id}/post`, undefined, options);
}

export function reverseBankTransfer(
  id: string,
  body: { reversalDate?: string | null; reason?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_TRANSFERS}/${id}/reverse`, body, options);
}

export function deleteBankTransfer(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANK_TRANSFERS}/${id}`, { ...options, method: "DELETE" });
}

/* ── Bank reconciliation ────────────────────────────────────────────────────────────────────── */

export function getBankReconciliations(
  filter: {
    bankAccountId?: string;
    status?: BankReconciliationStatus;
    dateFrom?: string;
    dateTo?: string;
    search?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<BankReconciliationList> {
  return apiGet<BankReconciliationList>(withQuery(BANK_RECONCILIATIONS, { ...filter }), options);
}

export function getBankReconciliation(
  id: string,
  options: EndpointOptions = {},
): Promise<BankReconciliation> {
  return apiGet<BankReconciliation>(`${BANK_RECONCILIATIONS}/${id}`, options);
}

/**
 * إرفاق كشف البنك وقراءته — upload an Excel/CSV/PDF statement and turn it into comparison rows.
 *
 * THE FILE IS EVIDENCE, NOT A TRANSACTION. Its rows become statement-side reconciliation lines and
 * reach no journal, no ledger and no balance. `columnMapping` is sent only on a re-import, once the
 * accountant has corrected how a bank's captions were read; `allowDuplicate` only after the
 * duplicate-file warning has been seen.
 */
export function importBankStatement(
  id: string,
  file: File,
  options: EndpointOptions & {
    columnMapping?: Record<string, StatementColumn>;
    allowDuplicate?: boolean;
  } = {},
): Promise<BankStatementImport> {
  const { columnMapping, allowDuplicate, ...rest } = options;
  const form = new FormData();
  form.append("file", file);

  if (columnMapping) {
    form.append("columnMapping", JSON.stringify(columnMapping));
  }

  if (allowDuplicate) {
    form.append("allowDuplicate", "true");
  }

  return request<BankStatementImport>(`${BANK_RECONCILIATIONS}/${id}/statement`, {
    ...rest,
    method: "POST",
    body: form,
  });
}

/** المطابقة الآلية — classify every row. Writes classifications only; posts nothing. */
export function matchBankReconciliation(
  id: string,
  body: { amountTolerance?: number; dateToleranceDays?: number } = {},
  options: EndpointOptions = {},
): Promise<BankReconciliationMatchSummary> {
  return apiPost<BankReconciliationMatchSummary>(
    `${BANK_RECONCILIATIONS}/${id}/match`, body, options);
}

/** مطابقة يدوية — one statement row to one ledger row, recorded with the user's name. */
export function manualMatchBankReconciliation(
  id: string,
  body: { statementLineId: string; ledgerLineId: string; reason?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_RECONCILIATIONS}/${id}/manual-match`, body, options);
}

/** إلغاء المطابقة — separates a pair. Neither row is deleted. */
export function unmatchBankReconciliationLine(
  id: string,
  lineId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_RECONCILIATIONS}/${id}/unmatch`, { lineId }, options);
}

const INVENTORY = "/inventory";

// ─── المخزون: البطاقات التعريفية ──────────────────────────────────────────────────────────────
//
// Eight masters, one prefix. `reasons` is shared with the Settings catalogue — the SAME rows, not
// a copy, which is why «أسباب حركات المخزون» appears once in the menu.

export function getInventoryUnits(activeOnly = false, options: EndpointOptions = {}) {
  return apiGet<UnitOfMeasure[]>(withQuery(`${INVENTORY}/units`, { activeOnly }), options);
}
export function saveInventoryUnit(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/units`, { ...options, method: "PUT", body });
}
export function deleteInventoryUnit(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/units/${id}`, { ...options, method: "DELETE" });
}

// ─── الأسعار وموردو الصنف ───────────────────────────────────────────────────────────────────
// A price is a SELLING price. Nothing here reaches inventory valuation.

export function getPriceLists(activeOnly = false, options: EndpointOptions = {}) {
  return apiGet<PriceList[]>(withQuery(`${INVENTORY}/price-lists`, { activeOnly }), options);
}
export function savePriceList(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/price-lists`, { ...options, method: "PUT", body });
}
export function getItemPrices(itemId: string, currentOnly = false, options: EndpointOptions = {}) {
  return apiGet<ItemPrice[]>(
    withQuery(`${INVENTORY}/items/${itemId}/prices`, { currentOnly }), options);
}
export function saveItemPrice(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/items/prices`, { ...options, method: "PUT", body });
}
export function deleteItemPrice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/items/prices/${id}`, { ...options, method: "DELETE" });
}

export function getItemSuppliers(itemId: string, options: EndpointOptions = {}) {
  return apiGet<ItemSupplierLink[]>(`${INVENTORY}/items/${itemId}/suppliers`, options);
}
export function saveItemSupplier(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/items/suppliers`, { ...options, method: "PUT", body });
}
export function deleteItemSupplier(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/items/suppliers/${id}`, { ...options, method: "DELETE" });
}

/** بلد المنشأ + ضريبة الشراء الافتراضية — both pickers on the item card, in one call. */
export function getItemCardLookups(options: EndpointOptions = {}) {
  return apiGet<ItemCardLookups>(`${INVENTORY}/items/lookups`, options);
}

/** The branches a warehouse may be assigned to. Optional on the warehouse — see the card. */
export function getInventoryWarehouseBranches(options: EndpointOptions = {}) {
  return apiGet<InventoryBranchOption[]>(`${INVENTORY}/warehouses/branches`, options);
}
export function getInventoryWarehouses(activeOnly = false, options: EndpointOptions = {}) {
  return apiGet<InventoryWarehouse[]>(withQuery(`${INVENTORY}/warehouses`, { activeOnly }), options);
}
export function saveInventoryWarehouse(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/warehouses`, { ...options, method: "PUT", body });
}
export function deleteInventoryWarehouse(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/warehouses/${id}`, { ...options, method: "DELETE" });
}

export function getInventoryItemGroups(activeOnly = false, options: EndpointOptions = {}) {
  return apiGet<ItemGroup[]>(withQuery(`${INVENTORY}/item-groups`, { activeOnly }), options);
}
export function saveInventoryItemGroup(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/item-groups`, { ...options, method: "PUT", body });
}
export function deleteInventoryItemGroup(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/item-groups/${id}`, { ...options, method: "DELETE" });
}

export function getInventoryItemCategories(activeOnly = false, options: EndpointOptions = {}) {
  return apiGet<ItemCategory[]>(withQuery(`${INVENTORY}/item-categories`, { activeOnly }), options);
}
export function saveInventoryItemCategory(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/item-categories`, { ...options, method: "PUT", body });
}
export function deleteInventoryItemCategory(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/item-categories/${id}`, { ...options, method: "DELETE" });
}

export function getStorageLocations(
  filter: { warehouseId?: string; activeOnly?: boolean } = {}, options: EndpointOptions = {},
) {
  return apiGet<StorageLocation[]>(withQuery(`${INVENTORY}/storage-locations`, { ...filter }), options);
}
export function deleteStorageLocation(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/storage-locations/${id}`, { ...options, method: "DELETE" });
}
export function saveStorageLocation(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/storage-locations`, { ...options, method: "PUT", body });
}

export function getInventoryReasons(
  filter: { activeOnly?: boolean; scope?: number } = {}, options: EndpointOptions = {},
) {
  return apiGet<InventoryReason[]>(withQuery(`${INVENTORY}/reasons`, { ...filter }), options);
}
export function saveInventoryReason(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/reasons`, { ...options, method: "PUT", body });
}

export function getInventoryItems(
  filter: { activeOnly?: boolean; itemGroupId?: string; search?: string } = {},
  options: EndpointOptions = {},
) {
  return apiGet<InventoryItem[]>(withQuery(`${INVENTORY}/items`, { ...filter }), options);
}
export function saveInventoryItem(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY}/items`, { ...options, method: "PUT", body });
}
export function deleteInventoryItem(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY}/items/${id}`, { ...options, method: "DELETE" });
}

const INVENTORY_SETTINGS = "/inventory/settings";

/** إعدادات المخزون — every setting, plus whether the company has ever saved them. */
export function getInventorySettings(options: EndpointOptions = {}): Promise<InventorySettings> {
  return apiGet<InventorySettings>(INVENTORY_SETTINGS, options);
}

/**
 * Saves them. The server refuses contradictory combinations rather than storing a rule nobody can
 * obey, so a rejection here is a real answer and not a validation nuisance.
 */
export function saveInventorySettings(
  input: SaveInventorySettingsInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(INVENTORY_SETTINGS, { ...options, method: "PUT", body: input });
}

/** جاهزية الإعداد — what must still be configured before anything can post. */
export function getInventoryConfigurationStatus(
  options: EndpointOptions = {},
): Promise<InventoryConfigurationStatus> {
  return apiGet<InventoryConfigurationStatus>(`${INVENTORY_SETTINGS}/readiness`, options);
}

export function saveBankReconciliation(
  input: SaveBankReconciliationInput,
  options: EndpointOptions = {},
): Promise<BankReconciliation> {
  return request<BankReconciliation>(BANK_RECONCILIATIONS, {
    ...options,
    method: "PUT",
    body: input,
  });
}

export function completeBankReconciliation(
  id: string,
  body: { notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_RECONCILIATIONS}/${id}/complete`, body, options);
}

export function deleteBankReconciliation(
  id: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${BANK_RECONCILIATIONS}/${id}`, { ...options, method: "DELETE" });
}

/* ── Letters of credit ──────────────────────────────────────────────────────────────────────── */

export function getLettersOfCredit(
  filter: {
    status?: LetterOfCreditStatus;
    bankId?: string;
    beneficiaryPartyId?: string;
    bankFacilityId?: string;
    dateFrom?: string;
    dateTo?: string;
    search?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<LetterOfCreditList> {
  return apiGet<LetterOfCreditList>(withQuery(LETTERS_OF_CREDIT, { ...filter }), options);
}

export function getLetterOfCredit(
  id: string,
  options: EndpointOptions = {},
): Promise<LetterOfCredit> {
  return apiGet<LetterOfCredit>(`${LETTERS_OF_CREDIT}/${id}`, options);
}

export function saveLetterOfCredit(
  input: SaveLetterOfCreditInput,
  options: EndpointOptions = {},
): Promise<LetterOfCredit> {
  return request<LetterOfCredit>(LETTERS_OF_CREDIT, { ...options, method: "PUT", body: input });
}

/** فتح الاعتماد — the bank opened it and took the margin. */
export function openLetterOfCredit(
  id: string,
  body: {
    openedDate?: string | null;
    marginPaidFromBankAccountId?: string | null;
    notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${LETTERS_OF_CREDIT}/${id}/open`, body, options);
}

export function settleLetterOfCredit(
  id: string,
  body: { date?: string | null; releaseToBankAccountId?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${LETTERS_OF_CREDIT}/${id}/settle`, body, options);
}

export function cancelLetterOfCredit(
  id: string,
  body: { date?: string | null; releaseToBankAccountId?: string | null; reason?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${LETTERS_OF_CREDIT}/${id}/cancel`, body, options);
}

/* ── Bank loans ─────────────────────────────────────────────────────────────────────────────── */

export function getBankLoans(
  filter: {
    status?: LoanStatus;
    bankFacilityId?: string;
    bankAccountId?: string;
    search?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<BankLoanList> {
  return apiGet<BankLoanList>(withQuery(BANK_LOANS, { ...filter }), options);
}

export function getBankLoan(id: string, options: EndpointOptions = {}): Promise<BankLoan> {
  return apiGet<BankLoan>(`${BANK_LOANS}/${id}`, options);
}

export function saveBankLoan(
  input: SaveBankLoanInput,
  options: EndpointOptions = {},
): Promise<BankLoan> {
  return request<BankLoan>(BANK_LOANS, { ...options, method: "PUT", body: input });
}

/** سحب القرض — the money arrives and the debt goes on the books. */
export function drawdownBankLoan(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${BANK_LOANS}/${id}/drawdown`, undefined, options);
}

/** سداد قسط — principal and interest in one entry. */
export function repayLoanInstallment(
  installmentId: string,
  body: { paidDate?: string | null; paidFromBankAccountId?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${BANK_LOANS}/installments/${installmentId}/repay`, body, options);
}

export function deleteBankLoan(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${BANK_LOANS}/${id}`, { ...options, method: "DELETE" });
}

/* ──────────────────────────────────────────────────────────────────────────────────────────────
 * Cash & Banks › Inquiries — seventeen read-only screens over seven query families.
 *
 * Each catalogue entry has its OWN path even where two share a query: the discriminator that
 * makes a screen what it is (closing versus count, received versus paid) is fixed server-side,
 * so it cannot be talked out of the screen from the browser.
 * ────────────────────────────────────────────────────────────────────────────────────────────── */

const CB_INQUIRIES = "/cash-banks/inquiries";

/** The absolute URL an export button opens, with the same filters the grid ran. */
export function cashBanksInquiryExportUrl(
  path: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${CB_INQUIRIES}/${path}/${format}`, {
    ...filter,
    locale,
  })}`;
}

// ── ledger-driven ────────────────────────────────────────────────────────────────────────────

export function getCbBankAccountLedger(
  filter: LedgerMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<LedgerMovementsResult> {
  return apiGet<LedgerMovementsResult>(
    withQuery(`${CB_INQUIRIES}/bank-account`, { ...filter }), options);
}

export function getCbCashboxLedger(
  filter: LedgerMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<LedgerMovementsResult> {
  return apiGet<LedgerMovementsResult>(
    withQuery(`${CB_INQUIRIES}/cashbox-account`, { ...filter }), options);
}

export function getCbAccountMovements(
  filter: LedgerMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<LedgerMovementsResult> {
  return apiGet<LedgerMovementsResult>(
    withQuery(`${CB_INQUIRIES}/account-movements`, { ...filter }), options);
}

export function getCbBankAccountCurrency(
  filter: BankAccountCurrencyFilter = {},
  options: EndpointOptions = {},
): Promise<BankAccountCurrencyResult> {
  return apiGet<BankAccountCurrencyResult>(
    withQuery(`${CB_INQUIRIES}/bank-account-currency`, { ...filter }), options);
}

// ── cashbox documents ────────────────────────────────────────────────────────────────────────

export function getCbCashboxMovements(
  filter: CashboxMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<CashboxMovementsResult> {
  return apiGet<CashboxMovementsResult>(
    withQuery(`${CB_INQUIRIES}/cashbox-movements`, { ...filter }), options);
}

export function getCbCashboxClosing(
  filter: CashboxMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<CashboxMovementsResult> {
  return apiGet<CashboxMovementsResult>(
    withQuery(`${CB_INQUIRIES}/cashbox-closing`, { ...filter }), options);
}

export function getCbCashboxCount(
  filter: CashboxMovementsFilter = {},
  options: EndpointOptions = {},
): Promise<CashboxMovementsResult> {
  return apiGet<CashboxMovementsResult>(
    withQuery(`${CB_INQUIRIES}/cashbox-count`, { ...filter }), options);
}

export function getCbCashboxClosingFollowUp(
  filter: CashboxClosingFollowUpFilter = {},
  options: EndpointOptions = {},
): Promise<CashboxClosingFollowUpResult> {
  return apiGet<CashboxClosingFollowUpResult>(
    withQuery(`${CB_INQUIRIES}/cashbox-closing-follow-up`, { ...filter }), options);
}

// ── cheques ──────────────────────────────────────────────────────────────────────────────────

export function getCbReceivedCheques(
  filter: ChequeInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeInquiryResult> {
  return apiGet<ChequeInquiryResult>(
    withQuery(`${CB_INQUIRIES}/received-cheques`, { ...filter }), options);
}

export function getCbPaidCheques(
  filter: ChequeInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeInquiryResult> {
  return apiGet<ChequeInquiryResult>(
    withQuery(`${CB_INQUIRIES}/paid-cheques`, { ...filter }), options);
}

export function getCbChequeDelivery(
  filter: ChequeInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeInquiryResult> {
  return apiGet<ChequeInquiryResult>(
    withQuery(`${CB_INQUIRIES}/cheque-delivery`, { ...filter }), options);
}

export function getCbUndeliveredCheques(
  filter: ChequeInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeInquiryResult> {
  return apiGet<ChequeInquiryResult>(
    withQuery(`${CB_INQUIRIES}/undelivered-cheques`, { ...filter }), options);
}

export function getCbChequeMovements(
  filter: ChequeMovementInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeMovementInquiryResult> {
  return apiGet<ChequeMovementInquiryResult>(
    withQuery(`${CB_INQUIRIES}/cheque-movements`, { ...filter }), options);
}

export function getCbMissingChequeSequences(
  filter: ChequeSequenceGapsFilter = {},
  options: EndpointOptions = {},
): Promise<ChequeSequenceGapsResult> {
  return apiGet<ChequeSequenceGapsResult>(
    withQuery(`${CB_INQUIRIES}/missing-cheque-sequences`, { ...filter }), options);
}

// ── documents, credits, loans ────────────────────────────────────────────────────────────────

export function getCbDailyTransactions(
  filter: CashBanksDocumentsFilter = {},
  options: EndpointOptions = {},
): Promise<CashBanksDocumentsResult> {
  return apiGet<CashBanksDocumentsResult>(
    withQuery(`${CB_INQUIRIES}/daily-transactions`, { ...filter }), options);
}

export function getCbLettersOfCredit(
  filter: LetterOfCreditInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<LetterOfCreditInquiryResult> {
  return apiGet<LetterOfCreditInquiryResult>(
    withQuery(`${CB_INQUIRIES}/letters-of-credit`, { ...filter }), options);
}

export function getCbBankLoans(
  filter: BankLoanInquiryFilter = {},
  options: EndpointOptions = {},
): Promise<BankLoanInquiryResult> {
  return apiGet<BankLoanInquiryResult>(
    withQuery(`${CB_INQUIRIES}/bank-loans`, { ...filter }), options);
}

/* ── Fixed Assets › Settings ──────────────────────────────────────────────────────────────────
 *
 * Thirteen vocabularies over one endpoint, keyed by the lookup type, plus the company's own
 * configuration. There is no delete: an entry a posted document names is withdrawn, never removed.
 * ──────────────────────────────────────────────────────────────────────────────────────────── */

const FA_SETTINGS = "/fixed-assets/settings";

export function getFixedAssetLookups(
  lookupType: FixedAssetLookupType,
  filter: { isActive?: boolean; search?: string } = {},
  options: EndpointOptions = {},
): Promise<FixedAssetLookupEntry[]> {
  return apiGet<FixedAssetLookupEntry[]>(
    withQuery(`${FA_SETTINGS}/lookups/${lookupType}`, { ...filter }), options);
}

export function saveFixedAssetLookup(
  input: SaveFixedAssetLookupInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_SETTINGS}/lookups`, input, options);
}

/** Withdraws an entry from new work, or brings it back. This is the delete. */
export function setFixedAssetLookupActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_SETTINGS}/lookups/${id}/active`,
    { ...options, method: "PUT", body: { isActive } });
}

export function getFixedAssetsSettings(
  options: EndpointOptions = {},
): Promise<FixedAssetsSettings> {
  return apiGet<FixedAssetsSettings>(FA_SETTINGS, options);
}

export function saveFixedAssetsSystemSettings(
  input: SaveFixedAssetsSystemSettingsInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_SETTINGS}/system`, { ...options, method: "PUT", body: input });
}

export function saveFixedAssetCodingSettings(
  input: SaveFixedAssetCodingSettingsInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_SETTINGS}/coding`, { ...options, method: "PUT", body: input });
}

/* ── Fixed Assets › Reports ───────────────────────────────────────────────────────────────────
 *
 * One endpoint for all thirteen, on the same registry the Cash & Banks reports use: the catalogue
 * CODE identifies the report and the server resolves it to exactly one executor. A registered code
 * with no executor returns 404 saying so — never an empty grid a reader could mistake for
 * "nothing matched my filters".
 * ──────────────────────────────────────────────────────────────────────────────────────────── */

const FA_REPORTS = "/fixed-assets/reports";

export function runFixedAssetsReport(
  code: string,
  filter: FixedAssetsReportFilter = {},
  options: EndpointOptions = {},
): Promise<FixedAssetsReportResult> {
  return apiGet<FixedAssetsReportResult>(
    withQuery(`${FA_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
export function fixedAssetsReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${FA_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

/** The catalogue checked against the executors, both ways. Both gap lists must come back empty. */
export function getFixedAssetsReportCoverage(
  options: EndpointOptions = {},
): Promise<FixedAssetsReportCoverage> {
  return apiGet<FixedAssetsReportCoverage>(`${FA_REPORTS}/mapped-codes`, options);
}

/* ── Cash & Banks › Reports ───────────────────────────────────────────────────────────────────
 *
 * One endpoint for all fifty-eight: the catalogue CODE identifies the report, and the server
 * resolves it to exactly one executor. A code with no executor returns 404 with a message saying
 * so — never an empty grid a reader could mistake for "nothing matched".
 * ──────────────────────────────────────────────────────────────────────────────────────────── */

const CB_REPORTS = "/cash-banks/reports";

const GL_REPORTS = "/accounting/general-ledger-reports";

/** Runs one General Ledger report. The server describes its own columns, totals and filters. */
export function runGeneralLedgerReport(
  code: string,
  filter: GeneralLedgerReportFilter = {},
  options: EndpointOptions = {},
): Promise<GeneralLedgerReportResult> {
  return apiGet<GeneralLedgerReportResult>(
    withQuery(`${GL_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
/**
 * طباعة المحدد - the URL a batch print POSTs its selection to.
 *
 * A URL rather than a fetch helper because the caller sends it through the shared authenticated
 * file plumbing, which is what turns a response into a printed or previewed document.
 */
export function generalLedgerBatchPrintUrl(code: string, locale: string): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_REPORTS}/${code}/batch-print`, { locale })}`;
}

export function generalLedgerReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${GL_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

export function runCashBanksReport(
  code: string,
  filter: CashBanksReportFilter = {},
  options: EndpointOptions = {},
): Promise<CashBanksReportResult> {
  return apiGet<CashBanksReportResult>(withQuery(`${CB_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
export function cashBanksReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${CB_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

/** Which catalogue codes have an executor. Used to check the mapping from outside. */
export function getCashBanksMappedReportCodes(
  options: EndpointOptions = {},
): Promise<string[]> {
  return apiGet<string[]>(`${CB_REPORTS}/mapped-codes`, options);
}

// ═════════════════════════════════════════════ Cash & Banks › Settings

const CB_SETTINGS = "/cash-banks/settings";

export function getCashboxGroups(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CashboxGroupList> {
  return apiGet<CashboxGroupList>(withQuery(`${CB_SETTINGS}/cashbox-groups`, { ...filter }), options);
}

export function saveCashboxGroup(
  input: SaveCashboxGroupInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${CB_SETTINGS}/cashbox-groups`, { ...options, method: "PUT", body: input });
}

/** Suspends or restores one group. There is no delete: cashboxes may still name it. */
export function setCashboxGroupActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${CB_SETTINGS}/cashbox-groups/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

export function getCashboxCashFloats(
  filter: { search?: string; cashboxId?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<CashboxCashFloatList> {
  return apiGet<CashboxCashFloatList>(
    withQuery(`${CB_SETTINGS}/cashbox-cash-floats`, { ...filter }), options);
}

export function saveCashboxCashFloat(
  input: SaveCashboxCashFloatInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(
    `${CB_SETTINGS}/cashbox-cash-floats`, { ...options, method: "PUT", body: input });
}

export function setCashboxCashFloatActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${CB_SETTINGS}/cashbox-cash-floats/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

export function getLetterOfCreditTypes(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<LetterOfCreditTypeList> {
  return apiGet<LetterOfCreditTypeList>(
    withQuery(`${CB_SETTINGS}/letter-of-credit-types`, { ...filter }), options);
}

export function saveLetterOfCreditType(
  input: SaveLetterOfCreditTypeInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(
    `${CB_SETTINGS}/letter-of-credit-types`, { ...options, method: "PUT", body: input });
}

export function setLetterOfCreditTypeActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${CB_SETTINGS}/letter-of-credit-types/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

export function getChequeReturnReasons(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ChequeReturnReasonList> {
  return apiGet<ChequeReturnReasonList>(
    withQuery(`${CB_SETTINGS}/cheque-return-reasons`, { ...filter }), options);
}

export function saveChequeReturnReason(
  input: SaveChequeReturnReasonInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(
    `${CB_SETTINGS}/cheque-return-reasons`, { ...options, method: "PUT", body: input });
}

export function setChequeReturnReasonActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    withQuery(`${CB_SETTINGS}/cheque-return-reasons/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

export function getUserCashboxAccessUsers(
  filter: { search?: string } = {}, options: EndpointOptions = {},
): Promise<UserCashboxAccessSummary[]> {
  return apiGet<UserCashboxAccessSummary[]>(
    withQuery(`${CB_SETTINGS}/user-cashbox-access`, { ...filter }), options);
}

export function getUserCashboxAccess(
  userId: string, options: EndpointOptions = {},
): Promise<UserCashboxAccess> {
  return apiGet<UserCashboxAccess>(`${CB_SETTINGS}/user-cashbox-access/${userId}`, options);
}

/** Grants or revokes ONE cashbox. Revoking flips the row rather than deleting it. */
export function setUserCashboxAccess(
  input: { userId: string; cashboxId: string; isGranted: boolean; branchId?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    `${CB_SETTINGS}/user-cashbox-access`, { ...options, method: "PUT", body: input });
}

/** Replaces the user's whole set in one call, for "grant all" / "revoke all". */
export function replaceUserCashboxAccess(
  input: { userId: string; cashboxIds: string[] }, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(
    `${CB_SETTINGS}/user-cashbox-access/replace`, { ...options, method: "PUT", body: input });
}

export function getCashAndBanksSettings(
  options: EndpointOptions = {},
): Promise<CashAndBanksSettings> {
  return apiGet<CashAndBanksSettings>(`${CB_SETTINGS}/system`, options);
}

export function saveCashAndBanksSettings(
  input: SaveCashAndBanksSettingsInput, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${CB_SETTINGS}/system`, { ...options, method: "PUT", body: input });
}

/** Puts every setting back to the shipped default. Prospective, like any other change. */
export function restoreCashAndBanksSettings(options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${CB_SETTINGS}/system/restore-defaults`, { ...options, method: "POST" });
}

// ═════════════════════════════════════════════ Fixed Assets › Master Data

const FA_GROUPS = "/fixed-assets/asset-groups";
const FA_LOCATIONS = "/fixed-assets/asset-locations";
const FA_ASSETS = "/fixed-assets/assets";
const FA_LOOKUPS = "/fixed-assets/lookups";

export function getFixedAssetGroupTree(
  filter: { search?: string; activeOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<FixedAssetTreeNode[]> {
  return apiGet<FixedAssetTreeNode[]>(withQuery(FA_GROUPS, { ...filter }), options);
}

export function getFixedAssetGroup(
  id: string, options: EndpointOptions = {},
): Promise<FixedAssetGroup> {
  return apiGet<FixedAssetGroup>(`${FA_GROUPS}/${id}`, options);
}

export function createFixedAssetGroup(
  input: SaveFixedAssetGroupInput, options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(FA_GROUPS, input, options);
}

export function updateFixedAssetGroup(
  id: string, input: SaveFixedAssetGroupInput, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_GROUPS}/${id}`, { ...options, method: "PUT", body: input });
}

export function setFixedAssetGroupActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_GROUPS}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

/** Only ever succeeds for a group nothing has referenced. Otherwise deactivate. */
export function deleteFixedAssetGroup(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${FA_GROUPS}/${id}`, { ...options, method: "DELETE" });
}

export function getFixedAssetLocationTree(
  filter: { search?: string; activeOnly?: boolean; branchId?: string } = {},
  options: EndpointOptions = {},
): Promise<FixedAssetTreeNode[]> {
  return apiGet<FixedAssetTreeNode[]>(withQuery(FA_LOCATIONS, { ...filter }), options);
}

export function getFixedAssetLocation(
  id: string, options: EndpointOptions = {},
): Promise<FixedAssetLocation> {
  return apiGet<FixedAssetLocation>(`${FA_LOCATIONS}/${id}`, options);
}

export function createFixedAssetLocation(
  input: SaveFixedAssetLocationInput, options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(FA_LOCATIONS, input, options);
}

export function updateFixedAssetLocation(
  id: string, input: SaveFixedAssetLocationInput, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_LOCATIONS}/${id}`, { ...options, method: "PUT", body: input });
}

export function setFixedAssetLocationActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_LOCATIONS}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

export function deleteFixedAssetLocation(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${FA_LOCATIONS}/${id}`, { ...options, method: "DELETE" });
}

export function getFixedAssets(
  filter: {
    search?: string; groupId?: string; locationId?: string; supplierId?: string;
    branchId?: string; status?: number; isActive?: boolean;
  } = {},
  options: EndpointOptions = {},
): Promise<FixedAssetList> {
  return apiGet<FixedAssetList>(withQuery(FA_ASSETS, { ...filter }), options);
}

export function getFixedAsset(id: string, options: EndpointOptions = {}): Promise<FixedAssetCard> {
  return apiGet<FixedAssetCard>(`${FA_ASSETS}/${id}`, options);
}

/** Adds when the body carries no id, amends when it does. */
export function saveFixedAsset(
  input: SaveFixedAssetInput, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(FA_ASSETS, { ...options, method: "PUT", body: input });
}

/** Suspends or restores a card. NOT a disposal — the company still owns the asset. */
export function setFixedAssetActive(
  id: string, isActive: boolean, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_ASSETS}/${id}/active`, { isActive }),
    { ...options, method: "POST" });
}

/** Attaches a document or image to an asset card. Same store and rules as every other module. */
export function uploadFixedAssetAttachment(
  assetId: string,
  file: File,
  description: string | undefined,
  options: EndpointOptions = {},
): Promise<FixedAssetAttachment> {
  const form = new FormData();
  form.append("file", file);

  if (description) {
    form.append("description", description);
  }

  return request<FixedAssetAttachment>(`${FA_ASSETS}/${assetId}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

export function deleteFixedAssetAttachment(
  assetId: string, attachmentId: string, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_ASSETS}/${assetId}/attachments/${attachmentId}`,
    { ...options, method: "DELETE" });
}

/** The authenticated download URL for one attachment. */
export function fixedAssetAttachmentUrl(assetId: string, attachmentId: string): string {
  return `${getApiBaseUrl()}${FA_ASSETS}/${assetId}/attachments/${attachmentId}`;
}

export function getFixedAssetSupplierOptions(
  filter: { search?: string; take?: number } = {}, options: EndpointOptions = {},
): Promise<FixedAssetLookupOption[]> {
  return apiGet<FixedAssetLookupOption[]>(
    withQuery(`${FA_LOOKUPS}/suppliers`, { ...filter }), options);
}

export function getFixedAssetAccountOptions(
  filter: { search?: string; take?: number } = {}, options: EndpointOptions = {},
): Promise<FixedAssetLookupOption[]> {
  return apiGet<FixedAssetLookupOption[]>(
    withQuery(`${FA_LOOKUPS}/accounts`, { ...filter }), options);
}

export function getFixedAssetCustodianOptions(
  filter: { search?: string; take?: number } = {}, options: EndpointOptions = {},
): Promise<FixedAssetLookupOption[]> {
  return apiGet<FixedAssetLookupOption[]>(
    withQuery(`${FA_LOOKUPS}/custodians`, { ...filter }), options);
}

/**
 * The asset cards an operation may act on.
 *
 * THE resolution point for every Fixed Assets Daily Transaction, so all of them name one identity.
 */
export function getFixedAssetOptions(
  filter: {
    search?: string; groupId?: string; locationId?: string;
    excludeClosed?: boolean; take?: number;
  } = {},
  options: EndpointOptions = {},
): Promise<FixedAssetLookupOption[]> {
  return apiGet<FixedAssetLookupOption[]>(
    withQuery(`${FA_LOOKUPS}/assets`, { ...filter }), options);
}

// ═════════════════════════════════ Fixed Assets › Daily Transactions

const FA_TX = "/fixed-assets";

// ── Custody: issue, return, transfer ───────────────────────────────────────

export function getAssetCustodies(
  filter: { search?: string; fixedAssetId?: string; custodianUserId?: string; openOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<AssetCustodyList> {
  return apiGet<AssetCustodyList>(withQuery(`${FA_TX}/custody`, { ...filter }), options);
}

export function getAssetCustodyHistory(
  fixedAssetId: string, options: EndpointOptions = {},
): Promise<AssetCustodyMovement[]> {
  return apiGet<AssetCustodyMovement[]>(`${FA_TX}/custody/history/${fixedAssetId}`, options);
}

export function issueAssetCustody(
  input: {
    fixedAssetId: string; custodianUserId: string; issuedOn?: string | null;
    expectedReturnOn?: string | null; conditionOnIssue: number; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/custody/issue`, input, options);
}

export function returnAssetCustody(
  input: {
    fixedAssetId: string; returnedOn?: string | null; conditionOnReturn: number;
    returnToLocationId?: string | null; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/custody/return`, input, options);
}

export function transferAssetCustody(
  input: {
    fixedAssetId: string; toCustodianUserId: string; transferDate?: string | null;
    condition: number; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/custody/transfer`, input, options);
}

// ── Location change ────────────────────────────────────────────────────────

export function getAssetLocationMovements(
  filter: { search?: string; fixedAssetId?: string; locationId?: string; from?: string; to?: string } = {},
  options: EndpointOptions = {},
): Promise<AssetLocationMovementList> {
  return apiGet<AssetLocationMovementList>(
    withQuery(`${FA_TX}/location-movements`, { ...filter }), options);
}

export function moveAssetLocation(
  input: {
    fixedAssetId: string; toLocationId: string; movementDate?: string | null;
    reason?: string | null; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/location-movements`, input, options);
}

// ── Insurance ──────────────────────────────────────────────────────────────

export function getAssetInsurancePolicies(
  filter: { search?: string; fixedAssetId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetInsuranceList> {
  return apiGet<AssetInsuranceList>(withQuery(`${FA_TX}/insurance`, { ...filter }), options);
}

export function saveAssetInsurancePolicy(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/insurance`, { ...options, method: "PUT", body: input });
}

// ── Maintenance ────────────────────────────────────────────────────────────

export function getAssetMaintenances(
  filter: {
    search?: string; fixedAssetId?: string; maintenanceType?: number;
    from?: string; to?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<AssetMaintenanceList> {
  return apiGet<AssetMaintenanceList>(withQuery(`${FA_TX}/maintenance`, { ...filter }), options);
}

export function saveAssetMaintenance(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/maintenance`, { ...options, method: "PUT", body: input });
}

// ── Inventory count ────────────────────────────────────────────────────────

export function getAssetInventoryCounts(
  filter: { search?: string; locationId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetInventoryCountList> {
  return apiGet<AssetInventoryCountList>(
    withQuery(`${FA_TX}/inventory-counts`, { ...filter }), options);
}

export function getAssetInventoryCount(
  id: string, options: EndpointOptions = {},
): Promise<AssetInventoryCount> {
  return apiGet<AssetInventoryCount>(`${FA_TX}/inventory-counts/${id}`, options);
}

/** Draws the sheet: every asset expected at the chosen location, snapshotted. */
export function openAssetInventoryCount(
  input: {
    countDate?: string | null; locationId?: string | null; branchId?: string | null;
    responsibleUserId?: string | null; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/inventory-counts`, input, options);
}

/** Records what the counter found. Writes nothing but the line — never moves the asset. */
export function recordAssetCountLine(
  countId: string,
  lineId: string,
  input: {
    result: number; actualLocationId?: string | null; condition?: number | null;
    discrepancyResolved: boolean; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${FA_TX}/inventory-counts/${countId}/lines/${lineId}`,
    { ...options, method: "PUT", body: input });
}

export function completeAssetInventoryCount(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/inventory-counts/${id}/complete`, {}, options);
}

export function cancelAssetInventoryCount(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/inventory-counts/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

// ── Depreciation ───────────────────────────────────────────────────────────

export function getAssetDepreciationRuns(
  filter: { search?: string; periodYear?: number; fixedAssetGroupId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetDepreciationRunList> {
  return apiGet<AssetDepreciationRunList>(
    withQuery(`${FA_TX}/depreciation`, { ...filter }), options);
}

export function getAssetDepreciationRun(
  id: string, options: EndpointOptions = {},
): Promise<AssetDepreciationRun> {
  return apiGet<AssetDepreciationRun>(`${FA_TX}/depreciation/${id}`, options);
}

/** Computes the period's charge for every eligible asset, as a draft to review. */
export function prepareAssetDepreciationRun(
  input: {
    periodYear: number; periodMonth: number;
    fixedAssetGroupId?: string | null; branchId?: string | null; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/depreciation/prepare`, input, options);
}

export function approveAssetDepreciationRun(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/depreciation/${id}/approve`, {}, options);
}

/** Puts down a run prepared for the wrong period. Only before it posts. */
export function cancelAssetDepreciationRun(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/depreciation/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

export function postAssetDepreciationRun(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/depreciation/${id}/post`, {}, options);
}

export function reverseAssetDepreciationRun(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/depreciation/${id}/reverse`, { reason }),
    { ...options, method: "POST" });
}

/** احتساب الاهتلاك السنوي — what the span would charge, and the voucher it would post. Writes nothing. */
export function previewAnnualAssetDepreciation(
  filter: {
    periodYear: number; fromMonth: number; toMonth: number;
    fixedAssetGroupId?: string | null; branchId?: string | null;
  },
  options: EndpointOptions = {},
): Promise<AnnualAssetDepreciationPreview> {
  return apiGet<AnnualAssetDepreciationPreview>(
    withQuery(`${FA_TX}/depreciation/annual/preview`, {
      periodYear: filter.periodYear,
      fromMonth: filter.fromMonth,
      toMonth: filter.toMonth,
      fixedAssetGroupId: filter.fixedAssetGroupId ?? undefined,
      branchId: filter.branchId ?? undefined,
    }),
    options);
}

/**
 * Recomputes the span, files one run per month and posts ONE voucher. Refused when the figures no
 * longer match `expectedTotal` — what posts is what was previewed.
 */
export function executeAnnualAssetDepreciation(
  input: {
    periodYear: number; fromMonth: number; toMonth: number;
    fixedAssetGroupId?: string | null; branchId?: string | null;
    notes?: string | null; expectedTotal: number;
  },
  options: EndpointOptions = {},
): Promise<AnnualAssetDepreciationResult> {
  return apiPost<AnnualAssetDepreciationResult>(`${FA_TX}/depreciation/annual`, input, options);
}

// ── Sale / disposal ────────────────────────────────────────────────────────

export function getAssetSales(
  filter: { search?: string; fixedAssetId?: string; status?: number; from?: string; to?: string } = {},
  options: EndpointOptions = {},
): Promise<AssetSaleList> {
  return apiGet<AssetSaleList>(withQuery(`${FA_TX}/sales`, { ...filter }), options);
}

export function saveAssetSale(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/sales`, { ...options, method: "PUT", body: input });
}

export function postAssetSale(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/sales/${id}/post`, {}, options);
}

export function getAssetDisposals(
  filter: { search?: string; fixedAssetId?: string; status?: number; reason?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetDisposalList> {
  return apiGet<AssetDisposalList>(withQuery(`${FA_TX}/disposals`, { ...filter }), options);
}

export function saveAssetDisposal(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/disposals`, { ...options, method: "PUT", body: input });
}

export function postAssetDisposal(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/disposals/${id}/post`, {}, options);
}

// ── Expense / revenue ──────────────────────────────────────────────────────

export function getAssetExpenses(
  filter: {
    search?: string; fixedAssetId?: string; treatment?: number; status?: number;
    from?: string; to?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<AssetExpenseList> {
  return apiGet<AssetExpenseList>(withQuery(`${FA_TX}/expenses`, { ...filter }), options);
}

export function saveAssetExpense(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/expenses`, { ...options, method: "PUT", body: input });
}

export function postAssetExpense(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/expenses/${id}/post`, {}, options);
}

export function getAssetRevenues(
  filter: { search?: string; fixedAssetId?: string; status?: number; from?: string; to?: string } = {},
  options: EndpointOptions = {},
): Promise<AssetRevenueList> {
  return apiGet<AssetRevenueList>(withQuery(`${FA_TX}/revenues`, { ...filter }), options);
}

export function saveAssetRevenue(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/revenues`, { ...options, method: "PUT", body: input });
}

export function postAssetRevenue(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/revenues/${id}/post`, {}, options);
}

// ── Revaluation / split ────────────────────────────────────────────────────

export function getAssetRevaluations(
  filter: { search?: string; fixedAssetId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetRevaluationList> {
  return apiGet<AssetRevaluationList>(withQuery(`${FA_TX}/revaluations`, { ...filter }), options);
}

/** What the asset is carried at now, computed server-side. Never typed by the user. */
export function getAssetCarryingAmount(
  fixedAssetId: string, asOf: string | undefined, options: EndpointOptions = {},
): Promise<AssetValuationSnapshot> {
  return apiGet<AssetValuationSnapshot>(
    withQuery(`${FA_TX}/revaluations/carrying-amount/${fixedAssetId}`, { asOf }), options);
}

export function saveAssetRevaluation(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/revaluations`, { ...options, method: "PUT", body: input });
}

export function postAssetRevaluation(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/revaluations/${id}/post`, {}, options);
}

export function getAssetSplits(
  filter: { search?: string; status?: number } = {}, options: EndpointOptions = {},
): Promise<AssetSplitList> {
  return apiGet<AssetSplitList>(withQuery(`${FA_TX}/splits`, { ...filter }), options);
}

export function getAssetSplit(id: string, options: EndpointOptions = {}): Promise<AssetSplit> {
  return apiGet<AssetSplit>(`${FA_TX}/splits/${id}`, options);
}

export function saveAssetSplit(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/splits`, { ...options, method: "PUT", body: input });
}

/**
 * Split has its own approve and cancel rather than the shared document workflow: the shared one
 * also carries Reverse, and a completed split cannot be undone by an opposite voucher.
 */
export function approveAssetSplit(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/splits/${id}/approve`, {}, options);
}

export function cancelAssetSplit(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/splits/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

/** Creates the children and retires the parent. Posts only if the accounts differ. */
export function completeAssetSplit(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/splits/${id}/complete`, {}, options);
}

// ── Purchase ───────────────────────────────────────────────────────────────

export function getAssetPurchaseOrders(
  filter: { search?: string; supplierId?: string; availableOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<AssetPurchaseOrderList> {
  return apiGet<AssetPurchaseOrderList>(
    withQuery(`${FA_TX}/purchases/orders`, { ...filter }), options);
}

export function getAssetPurchaseInvoices(
  filter: { search?: string; supplierId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetPurchaseInvoiceList> {
  return apiGet<AssetPurchaseInvoiceList>(
    withQuery(`${FA_TX}/purchases/invoices`, { ...filter }), options);
}

export function getAssetPurchaseInvoice(
  id: string, options: EndpointOptions = {},
): Promise<AssetPurchaseInvoice> {
  return apiGet<AssetPurchaseInvoice>(`${FA_TX}/purchases/invoices/${id}`, options);
}

export function saveAssetPurchaseInvoice(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/purchases/invoices`,
    { ...options, method: "PUT", body: input });
}

/** Posts the acquisition AND brings the asset cards into service. */
export function postAssetPurchaseInvoice(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/purchases/invoices/${id}/post`, {}, options);
}

// ── Shared document lifecycle ──────────────────────────────────────────────

export function approveAssetDocument(
  kind: AssetDocumentKind, id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/documents/${kind}/${id}/approve`, {}, options);
}

/** Only before posting. A posted document is reversed, never cancelled. */
export function cancelAssetDocument(
  kind: AssetDocumentKind, id: string, reason: string | undefined,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/documents/${kind}/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

/** Posts an opposite voucher and restores the asset's state. Never edits the original. */
export function reverseAssetDocument(
  kind: AssetDocumentKind, id: string, reason: string | undefined,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/documents/${kind}/${id}/reverse`, { reason }),
    { ...options, method: "POST" });
}

// ═════════════════════════ Fixed Assets › Daily Transactions (the final eight)

/** إيداع عهدة — deposited IN for safekeeping. The same custody engine as an issue. */
export function depositAssetCustody(
  input: {
    fixedAssetId: string; custodianUserId: string; depositedOn?: string | null;
    depositLocationId?: string | null; conditionOnDeposit: number;
    expectedReturnOn?: string | null; notes?: string | null;
  },
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${FA_TX}/custody/deposit`, input, options);
}

/** ورقة جرد الأصول — a READ of an existing count. Changes nothing, by design. */
export function getAssetInventoryWorksheet(
  countId: string, discrepanciesOnly: boolean, options: EndpointOptions = {},
): Promise<AssetInventoryWorksheet> {
  return apiGet<AssetInventoryWorksheet>(
    withQuery(`${FA_TX}/inventory-counts/${countId}/worksheet`, { discrepanciesOnly }), options);
}

// ── مردودات مشتريات أصول ────────────────────────────────────────────────────

export function getAssetPurchaseReturns(
  filter: { search?: string; supplierId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetPurchaseReturnList> {
  return apiGet<AssetPurchaseReturnList>(
    withQuery(`${FA_TX}/purchase-returns`, { ...filter }), options);
}

export function getAssetPurchaseReturn(
  id: string, options: EndpointOptions = {},
): Promise<AssetPurchaseReturn> {
  return apiGet<AssetPurchaseReturn>(`${FA_TX}/purchase-returns/${id}`, options);
}

/** What is still returnable on one posted invoice, and why the rest is not. */
export function getReturnableAssetInvoice(
  invoiceId: string, options: EndpointOptions = {},
): Promise<ReturnableAssetInvoice> {
  return apiGet<ReturnableAssetInvoice>(`${FA_TX}/purchase-returns/eligible/${invoiceId}`, options);
}

export function saveAssetPurchaseReturn(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/purchase-returns`,
    { ...options, method: "PUT", body: input });
}

export function postAssetPurchaseReturn(
  id: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${FA_TX}/purchase-returns/${id}/post`, {}, options);
}

// ── مردودات مصاريف الأصول ───────────────────────────────────────────────────

export function getAssetExpenseReturns(
  filter: { search?: string; fixedAssetId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetExpenseReturnList> {
  return apiGet<AssetExpenseReturnList>(
    withQuery(`${FA_TX}/expense-returns`, { ...filter }), options);
}

export function getReturnableAssetExpenses(
  filter: { fixedAssetId?: string; search?: string } = {}, options: EndpointOptions = {},
): Promise<ReturnableExpense[]> {
  return apiGet<ReturnableExpense[]>(
    withQuery(`${FA_TX}/expense-returns/eligible`, { ...filter }), options);
}

export function saveAssetExpenseReturn(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/expense-returns`,
    { ...options, method: "PUT", body: input });
}

export function postAssetExpenseReturn(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/expense-returns/${id}/post`, {}, options);
}

// ── تحويل أصل / مادة ────────────────────────────────────────────────────────

export function getAssetTransfers(
  filter: { search?: string; fixedAssetId?: string; status?: number } = {},
  options: EndpointOptions = {},
): Promise<AssetTransferList> {
  return apiGet<AssetTransferList>(withQuery(`${FA_TX}/transfers`, { ...filter }), options);
}

export function getAssetTransfer(
  id: string, options: EndpointOptions = {},
): Promise<AssetTransfer> {
  return apiGet<AssetTransfer>(`${FA_TX}/transfers/${id}`, options);
}

export function saveAssetTransfer(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${FA_TX}/transfers`, { ...options, method: "PUT", body: input });
}

export function approveAssetTransfer(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${FA_TX}/transfers/${id}/approve`, {}, options);
}

export function dispatchAssetTransfer(
  id: string,
  input: { dispatchedOn?: string; condition?: number } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/transfers/${id}/dispatch`, { ...input }),
    { ...options, method: "POST" });
}

/** Receives it, moves it, and posts the reclassification when one is required. */
export function receiveAssetTransfer(
  id: string,
  input: { receivedOn?: string; condition?: number; costCenterId?: string } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/transfers/${id}/receive`, { ...input }),
    { ...options, method: "POST" });
}

export function cancelAssetTransfer(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${FA_TX}/transfers/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

// ═══════════════ Procurement › the shared quotation cycle

const PROCUREMENT_RFQ = "/procurement/quotation-requests";

export function getQuotationRequests(
  filter: { search?: string; purpose?: number; status?: number } = {},
  options: EndpointOptions = {},
): Promise<QuotationRequestList> {
  return apiGet<QuotationRequestList>(withQuery(PROCUREMENT_RFQ, { ...filter }), options);
}

export function getQuotationRequest(
  id: string, options: EndpointOptions = {},
): Promise<QuotationRequest> {
  return apiGet<QuotationRequest>(`${PROCUREMENT_RFQ}/${id}`, options);
}

export function saveQuotationRequest(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(PROCUREMENT_RFQ, { ...options, method: "PUT", body: input });
}

/** Puts the request in front of the invited suppliers. Nothing may be quoted before it. */
export function issueQuotationRequest(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${PROCUREMENT_RFQ}/${id}/issue`, {}, options);
}

export function cancelQuotationRequest(
  id: string, reason: string | undefined, options: EndpointOptions = {},
): Promise<void> {
  return request<void>(withQuery(`${PROCUREMENT_RFQ}/${id}/cancel`, { reason }),
    { ...options, method: "POST" });
}

export function getSupplierQuotations(
  requestId: string, liveOnly: boolean, options: EndpointOptions = {},
): Promise<SupplierQuotationList> {
  return apiGet<SupplierQuotationList>(
    withQuery(`${PROCUREMENT_RFQ}/${requestId}/quotations`, { liveOnly }), options);
}

export function saveSupplierQuotation(
  input: Record<string, unknown>, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${PROCUREMENT_RFQ}/quotations`,
    { ...options, method: "PUT", body: input });
}

export function withdrawSupplierQuotation(
  quotationId: string, options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PROCUREMENT_RFQ}/quotations/${quotationId}/withdraw`, {}, options);
}

/** The offers already recorded, set side by side. A read — it stores and invents nothing. */
export function getQuotationComparison(
  requestId: string, options: EndpointOptions = {},
): Promise<QuotationComparison> {
  return apiGet<QuotationComparison>(`${PROCUREMENT_RFQ}/${requestId}/comparison`, options);
}

export function awardQuotation(
  requestId: string,
  input: {
    supplierQuotationId?: string | null;
    awardDate?: string | null;
    reason?: string | null;
    lines?: Array<{
      requestLineId: string;
      supplierQuotationLineId?: string | null;
      awardedQuantity?: number | null;
    }>;
  },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${PROCUREMENT_RFQ}/${requestId}/award`,
    { requestId, ...input }, options);
}

// ═══════════════════════════ Fixed Assets › Inquiries (the registered eight)

const FA_INQUIRIES = "/fixed-assets/inquiries";

/**
 * One inquiry's PDF or Excel, carrying exactly the filters the grid ran.
 *
 * The shared export engine — the same one Payments and Cash &amp; Banks use, which renders the
 * file server-side from the same query, the same authorisation and the same ordering.
 */
export function fixedAssetInquiryExportUrl(
  path: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${FA_INQUIRIES}/${path}/${format}`, {
    ...filter,
    locale,
  })}`;
}

export function getFaAssetLifeCycle(
  filter: AssetLifeCycleFilter = {}, options: EndpointOptions = {},
): Promise<AssetLifeCycleResult> {
  return apiGet<AssetLifeCycleResult>(
    withQuery(`${FA_INQUIRIES}/asset-life-cycle`, { ...filter }), options);
}

export function getFaAssetFinancialMovements(
  filter: AssetFinancialMovementsFilter = {}, options: EndpointOptions = {},
): Promise<AssetFinancialMovementsResult> {
  return apiGet<AssetFinancialMovementsResult>(
    withQuery(`${FA_INQUIRIES}/asset-financial-movements`, { ...filter }), options);
}

export function getFaAssetMovements(
  filter: AssetMovementsInquiryFilter = {}, options: EndpointOptions = {},
): Promise<AssetMovementsResult> {
  return apiGet<AssetMovementsResult>(
    withQuery(`${FA_INQUIRIES}/asset-movements`, { ...filter }), options);
}

export function getFaAssetExpenses(
  filter: AssetExpensesInquiryFilter = {}, options: EndpointOptions = {},
): Promise<AssetExpensesInquiryResult> {
  return apiGet<AssetExpensesInquiryResult>(
    withQuery(`${FA_INQUIRIES}/asset-expenses`, { ...filter }), options);
}

export function getFaAssetRecords(
  filter: AssetRecordsFilter = {}, options: EndpointOptions = {},
): Promise<AssetRecordsResult> {
  return apiGet<AssetRecordsResult>(
    withQuery(`${FA_INQUIRIES}/asset-records`, { ...filter }), options);
}

export function getFaAssetTransferStatus(
  filter: AssetTransferStatusInquiryFilter = {}, options: EndpointOptions = {},
): Promise<AssetTransferStatusResult> {
  return apiGet<AssetTransferStatusResult>(
    withQuery(`${FA_INQUIRIES}/asset-item-transfer-status`, { ...filter }), options);
}

export function getFaAssetTree(
  filter: AssetTreeInquiryFilter = {}, options: EndpointOptions = {},
): Promise<AssetTreeResult> {
  return apiGet<AssetTreeResult>(
    withQuery(`${FA_INQUIRIES}/asset-tree`, { ...filter }), options);
}

export function getFaDailyTransactions(
  filter: AssetDailyTransactionsInquiryFilter = {}, options: EndpointOptions = {},
): Promise<AssetDailyTransactionsResult> {
  return apiGet<AssetDailyTransactionsResult>(
    withQuery(`${FA_INQUIRIES}/daily-transactions`, { ...filter }), options);
}

// ── Human Resources › Employee Affairs › Basic Data › Employee Card ─────────────────────────
//
// HR master data only. There is no delete: withdrawing an employee deactivates them, so
// anything that later names them stays explicable.

const HR_EMPLOYEES = "/hr/employees";
const HR_RESPONSIBLE_ENTITIES = "/hr/responsible-entities";
const HR_LOOKUPS = "/hr/lookups";

/* ══════════════════════════════════════════════════════════════════════════════════════════
 * Human Resources — شؤون الموظفين
 *
 * The screens that used to sit here were written before any backend existed: they called
 * `/hr/employees` when there was no employees table, no HR controller and no `hr.*` permission.
 * These calls land on handlers that now exist, and the shapes match what those handlers return.
 * ══════════════════════════════════════════════════════════════════════════════════════════ */

export function getEmployees(
  filter: {
    search?: string;
    isActive?: boolean;
    departmentLookupId?: string;
    responsibleEntityId?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<EmployeeListItem[]> {
  return apiGet<EmployeeListItem[]>(withQuery(HR_EMPLOYEES, { ...filter }), options);
}

export function getEmployee(id: string, options: EndpointOptions = {}): Promise<Employee> {
  return apiGet<Employee>(`${HR_EMPLOYEES}/${id}`, options);
}

/** Every dropdown the card needs, in one call. */
export function getEmployeeFormContext(options: EndpointOptions = {}): Promise<EmployeeFormContext> {
  return apiGet<EmployeeFormContext>(`${HR_EMPLOYEES}/form-context`, options);
}

/** Creates when `id` is absent, updates when present. Returns the employee id either way. */
export function saveEmployee(
  input: SaveEmployeeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_EMPLOYEES, input, options);
}

/**
 * The stored photo, fetched through the SAME authenticated path as every other request.
 *
 * Necessary because the API authenticates with a bearer token and nothing else: pointing an
 * `<img src>` straight at this URL sends no Authorization header and the request is refused with
 * 401, which the browser renders as a broken image. The card turns this blob into an object URL.
 */
export function fetchEmployeePhoto(id: string, options: EndpointOptions = {}): Promise<ApiFile> {
  return requestFile(`${HR_EMPLOYEES}/${id}/photo`, "employee-photo", options);
}

export function uploadEmployeePhoto(
  id: string,
  file: File,
  options: EndpointOptions = {},
): Promise<void> {
  const form = new FormData();
  form.append("file", file);

  return request<void>(`${HR_EMPLOYEES}/${id}/photo`, { ...options, method: "POST", body: form });
}

export function removeEmployeePhoto(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HR_EMPLOYEES}/${id}/photo`, { ...options, method: "DELETE" });
}

export function getResponsibleEntities(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<ResponsibleEntity[]> {
  return apiGet<ResponsibleEntity[]>(withQuery(HR_RESPONSIBLE_ENTITIES, { ...filter }), options);
}

export function saveResponsibleEntity(
  input: SaveResponsibleEntityInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_RESPONSIBLE_ENTITIES, input, options);
}

/** Refused by the server while any employee still reports to it — deactivate instead. */
export function deleteResponsibleEntity(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HR_RESPONSIBLE_ENTITIES}/${id}`, { ...options, method: "DELETE" });
}

/** Adds one entry to a small HR vocabulary, from the dropdown that needed it. */
export function saveHrLookup(
  input: SaveHrLookupInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_LOOKUPS, input, options);
}

/** One HR vocabulary, listed for its settings screen — active and retired alike. */
export function getHrLookupEntries(
  lookupType: HrLookupType,
  filter: { isActive?: boolean; search?: string } = {},
  options: EndpointOptions = {},
): Promise<HrLookupEntry[]> {
  return apiGet<HrLookupEntry[]>(withQuery(HR_LOOKUPS, { lookupType, ...filter }), options);
}

/** Retires an entry or brings it back. There is no delete: a posted document still names it. */
export function setHrLookupActive(
  id: string,
  isActive: boolean,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${HR_LOOKUPS}/${id}/active`,
    { ...options, method: "PUT", body: { isActive } });
}

/* ══════════════════════════════════════════════════════════════════════════════════════════
 * Human Resources › شؤون الموظفين › الإجازات
 *
 * Four documents and two inquiries. The request is the only one people raise; the amendment
 * changes an approved one after the fact; the adjustment is the only way days reach a balance
 * without a request behind it, which is why it carries its own permission on the server.
 * ══════════════════════════════════════════════════════════════════════════════════════════ */

const HR_LEAVE_TYPES = "/hr/leave-types";
const HR_LEAVE_REQUESTS = "/hr/leave-requests";
const HR_LEAVE_AMENDMENTS = "/hr/leave-amendments";
const HR_LEAVE_ADJUSTMENTS = "/hr/leave-balance-adjustments";
const HR_LEAVE = "/hr/leave";

export function getLeaveTypes(
  filter: { search?: string; isActive?: boolean } = {},
  options: EndpointOptions = {},
): Promise<LeaveType[]> {
  return apiGet<LeaveType[]>(withQuery(HR_LEAVE_TYPES, { ...filter }), options);
}

export function saveLeaveType(
  input: SaveLeaveTypeInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_LEAVE_TYPES, input, options);
}

/** Refused by the server once anything refers to the type — deactivate instead. */
export function deleteLeaveType(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HR_LEAVE_TYPES}/${id}`, { ...options, method: "DELETE" });
}

/** Every dropdown the leave forms need, in one call. */
export function getLeaveFormContext(options: EndpointOptions = {}): Promise<LeaveFormContext> {
  return apiGet<LeaveFormContext>(`${HR_LEAVE_REQUESTS}/form-context`, options);
}

export function searchLeaveRequests(
  filter: {
    employeeId?: string;
    leaveTypeId?: string;
    branchId?: string;
    departmentLookupId?: string;
    status?: number;
    fromDate?: string;
    toDate?: string;
    search?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<LeaveRequestListItem[]> {
  return apiGet<LeaveRequestListItem[]>(withQuery(HR_LEAVE_REQUESTS, { ...filter }), options);
}

export function getLeaveRequest(
  id: string,
  options: EndpointOptions = {},
): Promise<LeaveRequestDetail> {
  return apiGet<LeaveRequestDetail>(`${HR_LEAVE_REQUESTS}/${id}`, options);
}

/** Creates when `id` is absent, updates the DRAFT when present. */
export function saveLeaveRequest(
  input: SaveLeaveRequestInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_LEAVE_REQUESTS, input, options);
}

export function deleteLeaveRequest(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HR_LEAVE_REQUESTS}/${id}`, { ...options, method: "DELETE" });
}

export function submitLeaveRequest(id: string, options: EndpointOptions = {}): Promise<void> {
  return apiPost<void>(`${HR_LEAVE_REQUESTS}/${id}/submit`, {}, options);
}

/** The only call that moves a balance. `approvedDays` null approves what was requested. */
export function approveLeaveRequest(
  id: string,
  input: { approvedDays?: number | null; notes?: string | null } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_LEAVE_REQUESTS}/${id}/approve`, input, options);
}

export function rejectLeaveRequest(
  id: string,
  input: { reason: string },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_LEAVE_REQUESTS}/${id}/reject`, input, options);
}

export function cancelLeaveRequest(
  id: string,
  input: { reason?: string | null } = {},
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_LEAVE_REQUESTS}/${id}/cancel`, input, options);
}

export function uploadLeaveAttachment(
  id: string,
  file: File,
  notes: string | null = null,
  options: EndpointOptions = {},
): Promise<string> {
  const form = new FormData();
  form.append("file", file);
  if (notes) form.append("notes", notes);

  return request<string>(`${HR_LEAVE_REQUESTS}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

/**
 * The stored attachment, fetched through the SAME authenticated path as every other request.
 *
 * The API authenticates with a bearer token and nothing else, so pointing a link straight at this
 * URL sends no Authorization header and is refused with 401. The screen turns this blob into an
 * object URL.
 */
export function fetchLeaveAttachment(
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(`${HR_LEAVE_REQUESTS}/attachments/${attachmentId}`, "leave-attachment", options);
}

export function deleteLeaveAttachment(
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${HR_LEAVE_REQUESTS}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

/** Extends, cuts short, cancels or re-categorises an APPROVED leave. */
export function saveLeaveAmendment(
  input: SaveLeaveAmendmentInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_LEAVE_AMENDMENTS, input, options);
}

/** Grants or takes back days directly. Requires `hr.leave.adjust-balance`. */
export function saveLeaveBalanceAdjustment(
  input: SaveLeaveBalanceAdjustmentInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(HR_LEAVE_ADJUSTMENTS, input, options);
}

export function getLeaveMovements(
  filter: {
    employeeId?: string;
    leaveTypeId?: string;
    movementType?: number;
    fromDate?: string;
    toDate?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<LeaveMovement[]> {
  return apiGet<LeaveMovement[]>(withQuery(`${HR_LEAVE}/movements`, { ...filter }), options);
}

/* ══════════════════════════════════════════════════════════════════════════════════════════
 * Human Resources › شؤون الموظفين › الحركات اليومية
 *
 * FOUR shared calls serve every document — read one, search the rest, move one along its life,
 * attach a file — and one typed save per document. The kind is a path segment, and the server
 * derives every permission from it.
 * ══════════════════════════════════════════════════════════════════════════════════════════ */

const HR_DAILY = "/hr/daily";

export function searchHrDocuments(
  kind: number,
  filter: HrDocumentSearchFilter = {},
  options: EndpointOptions = {},
): Promise<HrDocumentListItem[]> {
  return apiGet<HrDocumentListItem[]>(withQuery(`${HR_DAILY}/${kind}`, { ...filter }), options);
}

export function getHrDocument(
  kind: number,
  id: string,
  options: EndpointOptions = {},
): Promise<HrDocument> {
  return apiGet<HrDocument>(`${HR_DAILY}/${kind}/${id}`, options);
}

/** إرسال · اعتماد · رفض · إلغاء · تنفيذ. */
export function runHrWorkflow(
  kind: number,
  id: string,
  action: number,
  reason: string | null = null,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_DAILY}/${kind}/${id}/${action}`, { reason }, options);
}

/** Saves any HR document. The path names which one; the body is that document's own shape. */
export function saveHrDocument(
  path: string,
  input: Record<string, unknown>,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(`${HR_DAILY}/${path}`, input, options);
}

export function uploadHrAttachment(
  kind: number,
  id: string,
  file: File,
  notes: string | null = null,
  options: EndpointOptions = {},
): Promise<string> {
  const form = new FormData();
  form.append("file", file);
  if (notes) form.append("notes", notes);

  return request<string>(`${HR_DAILY}/${kind}/${id}/attachments`, {
    ...options,
    method: "POST",
    body: form,
  });
}

/**
 * The stored attachment, fetched through the SAME authenticated path as every other request.
 *
 * A plain link would send no bearer token and be refused with a 401 the browser renders as a
 * broken page.
 */
export function fetchHrAttachment(
  kind: number,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<ApiFile> {
  return requestFile(`${HR_DAILY}/${kind}/attachments/${attachmentId}`, "hr-attachment", options);
}

export function deleteHrAttachment(
  kind: number,
  attachmentId: string,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${HR_DAILY}/${kind}/attachments/${attachmentId}`, {
    ...options,
    method: "DELETE",
  });
}

/** Everything the HR daily transaction forms need to fill their pickers, in one call. */
export function getHrDailyFormContext(
  options: EndpointOptions = {},
): Promise<HrDailyFormContext> {
  return apiGet<HrDailyFormContext>(`${HR_DAILY}/form-context`, options);
}

/** Hands a written message to its provider. Refused, honestly, when none is configured. */
export function dispatchHrCommunication(
  id: string,
  channel: number,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_DAILY}/communications/${id}/dispatch/${channel}`, {}, options);
}

/** One department's answer on a clearance. */
export function settleClearanceItem(
  input: { itemId: string; itemStatus: number; outstandingDescription?: string | null; notes?: string | null },
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${HR_DAILY}/clearance-items/settle`, input, options);
}

export function getCompanyDocuments(
  filter: { search?: string; documentStatus?: number } = {},
  options: EndpointOptions = {},
): Promise<CompanyDocumentRow[]> {
  return apiGet<CompanyDocumentRow[]>(withQuery(`${HR_DAILY}/company-documents`, { ...filter }), options);
}

export function getPolicyRegulations(
  filter: { search?: string; documentStatus?: number } = {},
  options: EndpointOptions = {},
): Promise<PolicyRegulationRow[]> {
  return apiGet<PolicyRegulationRow[]>(withQuery(`${HR_DAILY}/policies`, { ...filter }), options);
}

/** READ-ONLY over the Fixed Assets custody register. HR owns no custody table. */
export function getEmployeeCustody(
  filter: { employeeId?: string; openOnly?: boolean } = {},
  options: EndpointOptions = {},
): Promise<EmployeeCustodyRow[]> {
  return apiGet<EmployeeCustodyRow[]>(withQuery(`${HR_DAILY}/employee-custody`, { ...filter }), options);
}

/* ══════════════════════════════════════════════════════════════════════════════════════════
 * Human Resources › شؤون الموظفين › الاستعلامات
 *
 * Only the three that are not document-kind searches. Everything else an inquiry screen needs —
 * نقل، ترقية، مسمى، مغادرات، عقوبات، عمل إضافي، حركات الوثائق — is `searchHrDocuments` above,
 * because «استعلام» over a kind is the same query the daily screens already use.
 * ══════════════════════════════════════════════════════════════════════════════════════════ */

const HR_INQUIRIES = "/hr/inquiries";

export function getCompanyDocumentsInquiry(
  filter: {
    search?: string;
    documentTypeLookupId?: string;
    expiringWithinDays?: number;
    excludeExpired?: boolean;
  } = {},
  options: EndpointOptions = {},
): Promise<CompanyDocumentInquiryRow[]> {
  return apiGet<CompanyDocumentInquiryRow[]>(
    withQuery(`${HR_INQUIRIES}/company-documents`, { ...filter }), options);
}

export function getEmployeeStateChanges(
  filter: {
    employeeId?: string;
    employeeNumber?: string;
    changeKind?: number;
    fromDate?: string;
    toDate?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<EmployeeStateChangeRow[]> {
  return apiGet<EmployeeStateChangeRow[]>(
    withQuery(`${HR_INQUIRIES}/employee-actions`, { ...filter }), options);
}

export function getHrDailyRegister(
  filter: {
    kind?: number;
    number?: string;
    employeeNumber?: string;
    employeeId?: string;
    branchId?: string;
    departmentLookupId?: string;
    status?: number;
    fromDate?: string;
    toDate?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<HrDailyRegisterRow[]> {
  return apiGet<HrDailyRegisterRow[]>(
    withQuery(`${HR_INQUIRIES}/daily-register`, { ...filter }), options);
}

const HR_LEAVE_REPORTS = "/hr/leave/reports";

/** Runs one of the seven Leave reports. The code identifies it; the server resolves the executor. */
export function runLeaveReport(
  code: string,
  filter: LeaveReportFilter = {},
  options: EndpointOptions = {},
): Promise<LeaveReportResult> {
  return apiGet<LeaveReportResult>(withQuery(`${HR_LEAVE_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
export function leaveReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${HR_LEAVE_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

const HR_EMPLOYEE_REPORTS = "/hr/employees/reports";

/**
 * One employee register report.
 *
 * The SAME filter object is handed to `employeeReportExportUrl`, so the file and the grid can
 * never be run with different criteria.
 */
export function runEmployeeReport(
  code: string,
  filter: EmployeeReportFilter = {},
  options: EndpointOptions = {},
): Promise<EmployeeReportResult> {
  return apiGet<EmployeeReportResult>(
    withQuery(`${HR_EMPLOYEE_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
export function employeeReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${HR_EMPLOYEE_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

/** The catalogue checked against the executors, both ways. Both gap lists must come back empty. */
export function getLeaveReportCoverage(
  options: EndpointOptions = {},
): Promise<LeaveReportCoverage> {
  return apiGet<LeaveReportCoverage>(`${HR_LEAVE_REPORTS}/mapped-codes`, options);
}

export function getLeaveBalances(
  filter: {
    employeeId?: string;
    leaveTypeId?: string;
    branchId?: string;
    departmentLookupId?: string;
    activeEmployeesOnly?: boolean;
    asOf?: string;
  } = {},
  options: EndpointOptions = {},
): Promise<LeaveBalanceRow[]> {
  return apiGet<LeaveBalanceRow[]>(withQuery(`${HR_LEAVE}/balances`, { ...filter }), options);
}

/* ══════════════════════════════════════════════════════════════════════════════════════════
 * System Settings — إعدادات النظام
 *
 * Every call below lands on a handler that already existed and was already permission-guarded.
 * The identity endpoints are the Identity module, companies and branches are the Companies
 * module, and the audit trail reads `audit_logs` — the table the persistence interceptor has
 * been writing to since the first run. Nothing here writes a store of its own.
 * ══════════════════════════════════════════════════════════════════════════════════════════ */

const SS_USERS = "/users";
const SS_ROLES = "/roles";
const SS_AUDIT = "/audit-trail";
const SS_COMPANIES = "/companies";
const SS_BRANCHES = "/branches";

export function getSystemUsers(
  filter: SystemUserFilter = {},
  options: EndpointOptions = {},
): Promise<SystemPagedResult<User>> {
  return apiGet<SystemPagedResult<User>>(withQuery(SS_USERS, { ...filter }), options);
}

export function getSystemUser(
  id: string,
  options: EndpointOptions = {},
): Promise<SystemUserDetail> {
  return apiGet<SystemUserDetail>(`${SS_USERS}/${id}`, options);
}

export function createSystemUser(
  input: CreateSystemUserInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(SS_USERS, input, options);
}

export function updateSystemUser(
  id: string,
  input: UpdateSystemUserInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_USERS}/${id}`, { ...options, method: "PUT", body: input });
}

/** Replaces the user's roles with exactly the set supplied. */
export function assignSystemUserRoles(
  id: string,
  roleIds: string[],
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_USERS}/${id}/roles`, {
    ...options,
    method: "PUT",
    body: { userId: id, roleIds },
  });
}

export function resetSystemUserPassword(
  id: string,
  input: ResetSystemUserPasswordInput,
  options: EndpointOptions = {},
): Promise<void> {
  return apiPost<void>(`${SS_USERS}/${id}/reset-password`, { userId: id, ...input }, options);
}

export function deleteSystemUser(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${SS_USERS}/${id}`, { ...options, method: "DELETE" });
}

export function getSystemRoles(
  filter: SystemRoleFilter = {},
  options: EndpointOptions = {},
): Promise<SystemPagedResult<SystemRole>> {
  return apiGet<SystemPagedResult<SystemRole>>(withQuery(SS_ROLES, { ...filter }), options);
}

export function getSystemRole(id: string, options: EndpointOptions = {}): Promise<SystemRoleDetail> {
  return apiGet<SystemRoleDetail>(`${SS_ROLES}/${id}`, options);
}

/**
 * The permission catalogue. PLATFORM-WIDE, not tenant-scoped: what Business OS can do is the
 * same for every subscriber, and what differs is which roles grant it. Names are filled in
 * both languages here (see `permission-labels.ts`): the server sends English only.
 */
export function getPermissionCatalog(options: EndpointOptions = {}): Promise<PermissionCatalog> {
  return apiGet<PermissionCatalog>(`${SS_ROLES}/permissions`, options).then(localizePermissionCatalog);
}

export function createSystemRole(
  input: SaveSystemRoleInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(SS_ROLES, input, options);
}

export function updateSystemRole(
  id: string,
  input: SaveSystemRoleInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_ROLES}/${id}`, {
    ...options,
    method: "PUT",
    body: { roleId: id, ...input },
  });
}

/** Replaces the role's grants with exactly the set supplied. */
export function assignRolePermissions(
  id: string,
  permissions: string[],
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_ROLES}/${id}/permissions`, {
    ...options,
    method: "PUT",
    body: { roleId: id, permissions },
  });
}

export function deleteSystemRole(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${SS_ROLES}/${id}`, { ...options, method: "DELETE" });
}

export function getAuditTrail(
  filter: AuditTrailFilter = {},
  options: EndpointOptions = {},
): Promise<SystemPagedResult<AuditTrailEntry>> {
  return apiGet<SystemPagedResult<AuditTrailEntry>>(withQuery(SS_AUDIT, { ...filter }), options);
}

/** Entity names actually present in the trail, so the filter never offers an empty option. */
export function getAuditTrailEntities(
  options: EndpointOptions = {},
): Promise<AuditTrailEntityOption[]> {
  return apiGet<AuditTrailEntityOption[]>(`${SS_AUDIT}/entities`, options);
}

export function getSystemCompanies(
  filter: { searchTerm?: string; isActive?: boolean; pageNumber?: number; pageSize?: number } = {},
  options: EndpointOptions = {},
): Promise<SystemPagedResult<SystemCompany>> {
  return apiGet<SystemPagedResult<SystemCompany>>(withQuery(SS_COMPANIES, { ...filter }), options);
}

export function createSystemCompany(
  input: SaveSystemCompanyInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(SS_COMPANIES, input, options);
}

export function updateSystemCompany(
  id: string,
  input: SaveSystemCompanyInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_COMPANIES}/${id}`, { ...options, method: "PUT", body: { id, ...input } });
}

export function deleteSystemCompany(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${SS_COMPANIES}/${id}`, { ...options, method: "DELETE" });
}

export function getSystemBranches(
  filter: {
    companyId?: string;
    searchTerm?: string;
    isActive?: boolean;
    pageNumber?: number;
    pageSize?: number;
  } = {},
  options: EndpointOptions = {},
): Promise<SystemPagedResult<SystemBranch>> {
  return apiGet<SystemPagedResult<SystemBranch>>(withQuery(SS_BRANCHES, { ...filter }), options);
}

export function createSystemBranch(
  input: SaveSystemBranchInput,
  options: EndpointOptions = {},
): Promise<string> {
  return apiPost<string>(SS_BRANCHES, input, options);
}

export function updateSystemBranch(
  id: string,
  input: SaveSystemBranchInput,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${SS_BRANCHES}/${id}`, { ...options, method: "PUT", body: { id, ...input } });
}

export function deleteSystemBranch(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${SS_BRANCHES}/${id}`, { ...options, method: "DELETE" });
}

// ─────────────────────────────────────────────────────────────────────────────────────────────
// المخزون والمستودعات › الحركات اليومية
//
// One door per document. The rules — what may be received, what may be invoiced, what enters
// stock — all live on the server; nothing here decides anything.
// ─────────────────────────────────────────────────────────────────────────────────────────────

const INVENTORY_TX = "/inventory/transactions";

export interface InventoryDocumentFilter {
  id?: string;
  search?: string;
  from?: string;
  to?: string;
  status?: number;
  supplierId?: string;
  warehouseId?: string;
  itemId?: string;
}

// ── 1. طلب شراء مواد ────────────────────────────────────────────────────────────────
export function getMaterialRequests(
  filter: InventoryDocumentFilter & { convertibleOnly?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<MaterialRequest[]>(withQuery(`${INVENTORY_TX}/purchase-requests`, { ...filter }), options);
}
export function saveMaterialRequest(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/purchase-requests`, { ...options, method: "POST", body });
}
export function approveMaterialRequest(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-requests/${id}/approve`, { ...options, method: "POST" });
}
export function closeMaterialRequest(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-requests/${id}/close`, { ...options, method: "POST" });
}
export function cancelMaterialRequest(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-requests/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}

// ── 2. أمر شراء مواد — read through the inventory view, written through Purchasing ──
export function getMaterialOrders(
  filter: { id?: string; search?: string; supplierId?: string; warehouseId?: string;
            from?: string; to?: string; includeCompleted?: boolean; withLines?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<MaterialOrder[]>(withQuery(`${INVENTORY_TX}/purchase-orders`, { ...filter }), options);
}

/** The SHARED purchase-order engine. `kind: 2` makes it a material order. */
export function saveMaterialOrder(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>("/accounting/purchase-orders", { ...options, method: "PUT", body });
}
export function approveMaterialOrder(id: string, options: EndpointOptions = {}) {
  return request<void>(`/accounting/purchase-orders/${id}/approve`, { ...options, method: "POST", body: {} });
}
export function closeMaterialOrder(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`/accounting/purchase-orders/${id}/close`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function cancelMaterialOrder(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`/accounting/purchase-orders/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}

// ── 3. سند استلام مواد ──────────────────────────────────────────────────────────────
export function getGoodsReceipts(
  filter: InventoryDocumentFilter & { purchaseOrderId?: string; invoiceableOnly?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<GoodsReceipt[]>(withQuery(`${INVENTORY_TX}/goods-receipts`, { ...filter }), options);
}
export function saveGoodsReceipt(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/goods-receipts`, { ...options, method: "POST", body });
}
export function auditGoodsReceipt(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/goods-receipts/${id}/audit`, { ...options, method: "POST" });
}
export function postGoodsReceipt(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/goods-receipts/${id}/post`, { ...options, method: "POST" });
}
export function cancelGoodsReceipt(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/goods-receipts/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function reverseGoodsReceipt(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_TX}/goods-receipts/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 4. فاتورة مشتريات مواد ──────────────────────────────────────────────────────────
export function getMaterialInvoices(
  filter: InventoryDocumentFilter & { goodsReceiptNoteId?: string; returnableOnly?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<MaterialInvoice[]>(withQuery(`${INVENTORY_TX}/purchase-invoices`, { ...filter }), options);
}
export function saveMaterialInvoice(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/purchase-invoices`, { ...options, method: "POST", body });
}
export function auditMaterialInvoice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-invoices/${id}/audit`, { ...options, method: "POST" });
}
export function postMaterialInvoice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-invoices/${id}/post`, { ...options, method: "POST" });
}
export function cancelMaterialInvoice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-invoices/${id}/cancel`, {
    ...options, method: "POST", body: { reason: null },
  });
}
export function reverseMaterialInvoice(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_TX}/purchase-invoices/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 5. مردود مشتريات مواد ───────────────────────────────────────────────────────────
export function getMaterialReturns(filter: InventoryDocumentFilter = {}, options: EndpointOptions = {}) {
  return apiGet<MaterialReturn[]>(withQuery(`${INVENTORY_TX}/purchase-returns`, { ...filter }), options);
}
export function saveMaterialReturn(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/purchase-returns`, { ...options, method: "POST", body });
}
export function auditMaterialReturn(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-returns/${id}/audit`, { ...options, method: "POST" });
}
export function postMaterialReturn(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-returns/${id}/post`, { ...options, method: "POST" });
}
export function cancelMaterialReturn(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/purchase-returns/${id}/cancel`, { ...options, method: "POST" });
}
export function reverseMaterialReturn(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_TX}/purchase-returns/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 6–9, 11. إدخال / إخراج / تحويل / تسوية / تسوية فروقات الجرد ─────────────────────
export function getStockDocuments(
  filter: InventoryDocumentFilter & { kind?: number } = {}, options: EndpointOptions = {},
) {
  return apiGet<StockDocument[]>(withQuery(`${INVENTORY_TX}/stock-documents`, { ...filter }), options);
}
export function saveStockDocument(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/stock-documents`, { ...options, method: "POST", body });
}
export function auditStockDocument(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/stock-documents/${id}/audit`, { ...options, method: "POST" });
}
export function postStockDocument(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/stock-documents/${id}/post`, { ...options, method: "POST" });
}
export function cancelStockDocument(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/stock-documents/${id}/cancel`, { ...options, method: "POST" });
}
export function reverseStockDocument(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_TX}/stock-documents/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 10. جرد مخزون ───────────────────────────────────────────────────────────────────
export function getStockCounts(
  filter: InventoryDocumentFilter & { adjustableOnly?: boolean } = {}, options: EndpointOptions = {},
) {
  return apiGet<StockCount[]>(withQuery(`${INVENTORY_TX}/stock-counts`, { ...filter }), options);
}
export function saveStockCount(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_TX}/stock-counts`, { ...options, method: "POST", body });
}
export function auditStockCount(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/stock-counts/${id}/audit`, { ...options, method: "POST" });
}
export function cancelStockCount(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_TX}/stock-counts/${id}/cancel`, { ...options, method: "POST" });
}
export function createCountAdjustment(
  id: string, documentDate?: string, options: EndpointOptions = {},
) {
  return request<string>(`${INVENTORY_TX}/stock-counts/${id}/adjustment`, {
    ...options, method: "POST", body: { documentDate: documentDate ?? null },
  });
}

// ─────────────────────────────────────────────────────────────────────────────────────────────
// المخزون والمستودعات › الاستعلامات — read-only, every one.
//
// Each catalogue entry has its own route even where two share a query: the narrowing that makes
// a screen what it is (per item, running balance, uninvoiced only, this document kind) is fixed
// on the SERVER, so a filter the browser could widen cannot make a screen's title untrue.
// ─────────────────────────────────────────────────────────────────────────────────────────────

const INVENTORY_REPORTS = "/inventory/reports";

/**
 * Runs one Inventory report.
 *
 * The code comes from the ROUTE, and the server resolves it to exactly one executor. A code with
 * no executor answers 404 rather than an empty grid, so a reader can always tell "nothing matched
 * my filters" from "nobody built this".
 */
export function runInventoryReport(
  code: string,
  filter: InventoryReportFilter = {},
  options: EndpointOptions = {},
): Promise<InventoryReportResult> {
  return apiGet<InventoryReportResult>(
    withQuery(`${INVENTORY_REPORTS}/${code}`, { ...filter }), options);
}

/** The export URL, carrying exactly the filters the grid ran. */
export function inventoryReportExportUrl(
  code: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${INVENTORY_REPORTS}/${code}/${format}`, {
    ...filter,
    locale,
  })}`;
}

const INVENTORY_INQUIRIES = "/inventory/inquiries";

/** The Print/PDF/Excel URL for an inquiry. Same path, same filters, `/pdf` or `/excel` on the end. */
/**
 * The print/export URL for one of the البطاقات التعريفية registers.
 *
 * `card` is the register — `units`, `item-groups`, `item-categories`, `warehouses`,
 * `storage-locations`, `reasons`. The server sends the SAME query the card reads, so a printed
 * register cannot show something the screen does not.
 */
export function inventoryMasterDataExportUrl(
  card: string,
  format: "pdf" | "excel",
  locale: string,
  activeOnly = false,
): string {
  return `${getApiBaseUrl()}${withQuery(`${INVENTORY}/master-data/${card}/${format}`, {
    activeOnly,
    locale,
  })}`;
}

export function inventoryInquiryExportUrl(
  path: string,
  format: "pdf" | "excel",
  filter: object,
  locale: string,
): string {
  return `${getApiBaseUrl()}${withQuery(`${INVENTORY_INQUIRIES}/${path}/${format}`, {
    ...filter,
    locale,
  })}`;
}

/**
 * One doorway per inquiry, built from its path.
 *
 * Twenty-four hand-written fetchers would be twenty-four chances for one of them to send its
 * filters differently from the rest — which is exactly how an export stops matching its screen.
 */
const inquiry = <TFilter, TResult>(path: string) =>
  (filter: TFilter, options: EndpointOptions = {}) =>
    apiGet<TResult>(
      withQuery(`${INVENTORY_INQUIRIES}/${path}`,
        { ...filter } as unknown as Record<string, string | number | boolean | undefined>),
      options);

// ── stock ───────────────────────────────────────────────────────────────────────────────────
export const getInvItemBalance = inquiry<StockBalanceFilter, StockBalanceResult>("item-balance");
export const getInvStockByWarehouse =
  inquiry<StockBalanceFilter, StockBalanceResult>("stock-by-warehouse");
export const getInvStockAsOf = inquiry<StockBalanceFilter, StockBalanceResult>("stock-as-of");
export const getInvItemsByGroup = inquiry<StockBalanceFilter, StockBalanceResult>("items-by-group");

export const getInvItemMovements =
  inquiry<StockMovementInquiryFilter, StockMovementInquiryResult>("item-movements");
export const getInvItemLedgerCard =
  inquiry<StockMovementInquiryFilter, StockMovementInquiryResult>("item-ledger-card");
export const getInvWarehouseMovements =
  inquiry<StockMovementInquiryFilter, StockMovementInquiryResult>("warehouse-movements");
export const getInvStockLedger =
  inquiry<StockMovementInquiryFilter, StockMovementInquiryResult>("stock-ledger");

export const getInvBelowReorder = inquiry<ReorderFilter, ReorderResult>("below-reorder");
export const getInvNonMoving = inquiry<NonMovingFilter, NonMovingResult>("non-moving");

// ── procurement ─────────────────────────────────────────────────────────────────────────────
export const getInvPurchaseOrders =
  inquiry<PurchaseOrderInquiryFilter, PurchaseOrderInquiryResult>("purchase-orders");
export const getInvPurchaseOrderReceipts =
  inquiry<PurchaseOrderInquiryFilter, PurchaseOrderInquiryResult>("purchase-order-receipts");
export const getInvGoodsReceipts =
  inquiry<GoodsReceiptInquiryFilter, GoodsReceiptInquiryResult>("goods-receipts");
export const getInvReceivedNotInvoiced =
  inquiry<GoodsReceiptInquiryFilter, GoodsReceiptInquiryResult>("received-not-invoiced");
export const getInvPurchaseInvoices =
  inquiry<MaterialInvoiceInquiryFilter, MaterialInvoiceInquiryResult>("purchase-invoices");
export const getInvPurchaseReturns =
  inquiry<MaterialReturnInquiryFilter, MaterialReturnInquiryResult>("purchase-returns");
export const getInvItemBySupplier =
  inquiry<ItemBySupplierFilter, ItemBySupplierResult>("item-by-supplier");

/** سجل أصناف المواد — the card register. The one inventory inquiry that reads no stock. */
export const getInvItemRegister =
  inquiry<ItemRegisterFilter, ItemRegisterResult>("item-register");

// ── control ─────────────────────────────────────────────────────────────────────────────────
export const getInvStockReceipts =
  inquiry<StockDocumentInquiryFilter, StockDocumentInquiryResult>("stock-receipts");
export const getInvStockIssues =
  inquiry<StockDocumentInquiryFilter, StockDocumentInquiryResult>("stock-issues");
export const getInvTransfers =
  inquiry<StockDocumentInquiryFilter, StockDocumentInquiryResult>("transfers");
export const getInvAdjustments =
  inquiry<StockDocumentInquiryFilter, StockDocumentInquiryResult>("adjustments");
export const getInvStockCounts =
  inquiry<StockCountInquiryFilter, StockCountInquiryResult>("stock-counts");
export const getInvCountDifferences =
  inquiry<StockCountInquiryFilter, StockCountInquiryResult>("count-differences");
export const getInvReconciliation =
  inquiry<InventoryReconciliationFilter, InventoryReconciliationResult>("reconciliation");

// ═══════════════════════════════════════════════════════════════════════════════════════════════
// المخزون والمستودعات › مبيعات المواد
//
// PHYSICAL goods only. Service sales have their own endpoints, their own invoice and their own
// revenue accounts; nothing below touches them.
//
// The chain: طلب بيع → إذن تسليم (خروج المخزون + تكلفة البضاعة المباعة) → فاتورة مبيعات مواد
// (ذمة العميل، بلا أثر مخزني) → مردود مبيعات مواد.
// ═══════════════════════════════════════════════════════════════════════════════════════════════

const INVENTORY_SALES = "/inventory/sales";

/** The filters every sales inquiry dialog shares. */
export interface SalesDocumentFilter {
  id?: string;
  search?: string;
  from?: string;
  to?: string;
  status?: number;
  customerId?: string;
  warehouseId?: string;
  branchId?: string;
  itemId?: string;
  createdBy?: string;
  amountFrom?: number;
  amountTo?: number;
}

// ── 1. طلب بيع ──────────────────────────────────────────────────────────────────────
export function getSalesOrders(
  filter: SalesDocumentFilter & { deliverableOnly?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<SalesDocument[]>(withQuery(`${INVENTORY_SALES}/orders`, { ...filter }), options);
}
export function saveSalesOrder(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_SALES}/orders`, { ...options, method: "POST", body });
}
export function approveSalesOrder(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/orders/${id}/approve`, { ...options, method: "POST" });
}
export function cancelSalesOrder(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/orders/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function closeSalesOrder(
  id: string, closed: boolean, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_SALES}/orders/${id}/close`, {
    ...options, method: "POST", body: { closed, reason: reason ?? null },
  });
}

// ── 2. إذن تسليم ────────────────────────────────────────────────────────────────────
export function getDeliveryNotes(
  filter: SalesDocumentFilter & { salesOrderId?: string; invoiceableOnly?: boolean } = {},
  options: EndpointOptions = {},
) {
  return apiGet<SalesDocument[]>(withQuery(`${INVENTORY_SALES}/deliveries`, { ...filter }), options);
}
export function saveDeliveryNote(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_SALES}/deliveries`, { ...options, method: "POST", body });
}
export function auditDeliveryNote(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/deliveries/${id}/audit`, { ...options, method: "POST" });
}
export function postDeliveryNote(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/deliveries/${id}/post`, { ...options, method: "POST" });
}
export function cancelDeliveryNote(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/deliveries/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function reverseDeliveryNote(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_SALES}/deliveries/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 3. فاتورة مبيعات مواد ───────────────────────────────────────────────────────────
export function getMaterialSalesInvoices(
  filter: SalesDocumentFilter & {
    deliveryNoteId?: string; salesOrderId?: string; returnableOnly?: boolean;
  } = {},
  options: EndpointOptions = {},
) {
  return apiGet<SalesDocument[]>(withQuery(`${INVENTORY_SALES}/invoices`, { ...filter }), options);
}
export function saveMaterialSalesInvoice(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_SALES}/invoices`, { ...options, method: "POST", body });
}
export function auditMaterialSalesInvoice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/invoices/${id}/audit`, { ...options, method: "POST" });
}
export function postMaterialSalesInvoice(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/invoices/${id}/post`, { ...options, method: "POST" });
}
export function cancelMaterialSalesInvoice(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/invoices/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function reverseMaterialSalesInvoice(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_SALES}/invoices/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

// ── 4. مردود مبيعات مواد ────────────────────────────────────────────────────────────
export function getMaterialSalesReturns(
  filter: SalesDocumentFilter & { materialSalesInvoiceId?: string } = {},
  options: EndpointOptions = {},
) {
  return apiGet<SalesDocument[]>(withQuery(`${INVENTORY_SALES}/returns`, { ...filter }), options);
}
export function saveMaterialSalesReturn(body: Record<string, unknown>, options: EndpointOptions = {}) {
  return request<string>(`${INVENTORY_SALES}/returns`, { ...options, method: "POST", body });
}
export function auditMaterialSalesReturn(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/returns/${id}/audit`, { ...options, method: "POST" });
}
export function postMaterialSalesReturn(id: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/returns/${id}/post`, { ...options, method: "POST" });
}
export function cancelMaterialSalesReturn(id: string, reason?: string, options: EndpointOptions = {}) {
  return request<void>(`${INVENTORY_SALES}/returns/${id}/cancel`, {
    ...options, method: "POST", body: { reason: reason ?? null },
  });
}
export function reverseMaterialSalesReturn(
  id: string, reversalDate: string, reason?: string, options: EndpointOptions = {},
) {
  return request<void>(`${INVENTORY_SALES}/returns/${id}/reverse`, {
    ...options, method: "POST", body: { reversalDate, reason: reason ?? null },
  });
}

/**
 * The lines a NEW document may be built from, with what is left on each.
 *
 * ONE call for all three hand-offs — order → delivery, delivery → invoice, invoice → return.
 * The server recomputes the remainder every time; nothing the screen holds is trusted.
 */
export function getSalesSourceLines(
  filter: { salesOrderId?: string; deliveryNoteId?: string; materialSalesInvoiceId?: string },
  options: EndpointOptions = {},
) {
  return apiGet<SalesSourceLine[]>(
    withQuery(`${INVENTORY_SALES}/source-lines`, { ...filter }), options);
}

/**
 * The dashboard's two live figures, in one call.
 *
 * `salesDates` is sent as a repeated query parameter rather than a range: the days a dashboard
 * compares are usually NOT contiguous (today against the same day last week), and a range would
 * make that impossible to ask for.
 */
export function getDashboardSummary(
  params: { asOf?: string; salesDates?: string[] } = {},
  options: EndpointOptions = {},
): Promise<DashboardSummary> {
  const search = new URLSearchParams();
  if (params.asOf) search.set("asOf", params.asOf);
  for (const date of params.salesDates ?? []) search.append("salesDates", date);

  const query = search.toString();
  return apiGet<DashboardSummary>(`/dashboard/summary${query ? `?${query}` : ""}`, options);
}

/**
 * Every report this user may open, flat, for the system search box.
 *
 * Fetched once and cached by the caller — the catalogue is a compile-time constant, so a round
 * trip per keystroke would buy nothing.
 */
export function getAllReports(options: EndpointOptions = {}): Promise<ReportSearchIndex> {
  return apiGet<ReportSearchIndex>("/reports-center/all", options);
}

/* ─── Hotel Front Desk ────────────────────────────────────────────────────────────────────
 * Restored verbatim from commit 6bb3be8 on 2026-09-20. The four front-desk screens in this
 * tree import these and they were absent here, so NOTHING in the web app could build. Added
 * as one block at the end of the file; not one existing line was touched.
 * ─────────────────────────────────────────────────────────────────────────────────────── */

// ═══════════════════════════════════════════════════════════════ Hotel Front Desk

const HOTEL = "/hotel";

export function getRoomBoard(options: EndpointOptions = {}): Promise<RoomBoardTileDto[]> {
  return apiGet<RoomBoardTileDto[]>(`${HOTEL}/room-board`, options);
}

export function getRooms(activeOnly = false, options: EndpointOptions = {}): Promise<RoomDto[]> {
  return apiGet<RoomDto[]>(withQuery(`${HOTEL}/rooms`, { activeOnly }), options);
}

export function saveRoom(body: Record<string, unknown>, options: EndpointOptions = {}): Promise<string> {
  return request<string>(`${HOTEL}/rooms`, { ...options, method: "POST", body });
}

export function markRoomCleaned(roomId: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HOTEL}/rooms/${roomId}/mark-cleaned`, { ...options, method: "POST" });
}
/** Manually flags a room dirty outside the automatic checkout/daily-service triggers. */
export function flagRoomNeedsCleaning(roomId: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HOTEL}/rooms/${roomId}/flag-needs-cleaning`, { ...options, method: "POST" });
}

/** Master-data field, edited from the board: `hotel-front-desk.master-data.manage` only. */
export function setRoomOutOfService(
  roomId: string,
  isOutOfService: boolean,
  reason: string | null,
  options: EndpointOptions = {},
): Promise<void> {
  return request<void>(`${HOTEL}/rooms/${roomId}/out-of-service`, {
    ...options, method: "POST", body: { roomId, isOutOfService, reason },
  });
}

export function getRoomTypes(
  activeOnly = false, options: EndpointOptions = {},
): Promise<RoomTypeDto[]> {
  return apiGet<RoomTypeDto[]>(withQuery(`${HOTEL}/room-types`, { activeOnly }), options);
}

export function saveRoomType(body: Record<string, unknown>, options: EndpointOptions = {}): Promise<string> {
  return request<string>(`${HOTEL}/room-types`, { ...options, method: "POST", body });
}

export function getHotelSettings(options: EndpointOptions = {}): Promise<HotelSettingsDto> {
  return apiGet<HotelSettingsDto>(`${HOTEL}/settings`, options);
}

export function saveHotelSettings(body: Record<string, unknown>, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HOTEL}/settings`, { ...options, method: "POST", body });
}

export function createRoomStay(body: Record<string, unknown>, options: EndpointOptions = {}): Promise<string> {
  return request<string>(`${HOTEL}/room-stays`, { ...options, method: "POST", body });
}

export function checkInRoomStay(id: string, options: EndpointOptions = {}): Promise<void> {
  return request<void>(`${HOTEL}/room-stays/${id}/check-in`, { ...options, method: "POST" });
}

export function checkOutRoomStay(
  id: string, actualCheckOutDate: string, options: EndpointOptions = {},
): Promise<string> {
  return request<string>(`${HOTEL}/room-stays/${id}/check-out`, {
    ...options, method: "POST", body: { actualCheckOutDate },
  });
}

export function quickAddGuest(
  body: Record<string, unknown>, options: EndpointOptions = {},
): Promise<QuickAddGuestResultDto> {
  return request<QuickAddGuestResultDto>(`${HOTEL}/room-stays/guests/quick-add`, {
    ...options, method: "POST", body,
  });
}

/**
 * Takes a POSTED entry back to Draft so it can be corrected in place. Administrator only
 * (`gl.journals.reopen`); the reason is mandatory and is recorded in the audit trail.
 *
 * Restored verbatim from commit 6bb3be8 on 2026-09-20 — «إعادة فتح القيد» in this tree imports
 * it and it was absent here, so the whole web app failed to build.
 */
export function reopenJournalVoucher(
  id: string,
  reason: string,
  options: EndpointOptions = {},
): Promise<JournalVoucher> {
  return apiPost<JournalVoucher>(`${JOURNALS}/${id}/reopen`, { reason }, options);
}
